<template>
	<div class="container-fluid" :key="atualizaDb">
		<div class="no-print">
			<div v-if="!visualizar">
				<fl-cabecalho-db-piloto
					:cabecalho-status="cabecalho"
					:form-id="form.id"
					@volta-lista="voltaLista"
					@click-print="clickPrint"
				/>
				<Camera
					v-if="showCamera"
					@close-camera="closeCamera"
					@image-taken="(imageString) => loadImageAbastecimento(imageString)"
				/>
				<Camera
					v-if="showCameraAnexos"
					@close-camera="closeCameraAnexos"
					@image-taken="(imageString) => loadImageAnexos(imageString)"
				/>

				<!-- FORM -->
			</div>
			<div v-if="!visualizar">
				<div class="row" style="margin-top: 12px">
					<div class="col-xs-12">
						<AlertSuccess>
							{{ _traducao('global', 'numero') }} -
							{{
								trecho.numero_diario == null
									?  _traducao('global', 'geradoApos').toUpperCase()
									: trecho.numero_diario
							}}
						</AlertSuccess>
					</div>
				</div>
				<flCabecalhoForm
					class="print-titulo-form-20"
					:texto="_traducao('global', 'aeronave')"
				/>
				<fl-informacoes-aeronave
					:aeronave="aeronave"
					:trecho="trecho"
					:fuso-horario="fusoHorario"
				/>
				<flCabecalhoForm
					class="print-titulo-form-20"
					:texto="_traducao('global', 'manutencao')"
				/>
				<fl-informacoes-manutencao :formulario="form" />
				<fl-informacoes-ciclos-totais
					:formulario="form"
					v-if="editar"
					:aeronave="aeronave"
				/>
			</div>

			<!-- ORIGEM DO VOO -->
			<div v-if="!visualizar">
				<flCabecalhoForm
					class="print-titulo-form-20"
					:texto="
						dbComercial
							? _traducao('global', 'programacaoVoo')
							: titulo != '' && titulo != 'Despacho'
							? titulo + ' ' + _traducao('submenu', 'aeronaves')
							: _traducao('global', 'despachoAeronaves')
					"
				/>

				<div class="row">
					<div class="col-xs-12">
						<AlertWarning v-if="liberarProgramacao && !qtdProgramacoesValidas">
							{{
								dbComercial
									? _traducao('global', 'trechosProgramacaoNaoPreenchidos')
									: titulo != '' && titulo != 'Despacho'
									? `Existem trechos do ${titulo.toLocaleLowerCase()} que ainda não possuem diários de bordo preenchidos.`
									: _traducao('global', 'trechosDespachoNaoPreenchidos')
							}}
						</AlertWarning>
						<AlertWarning v-if="liberarProgramacao">
							{{
								dbComercial
									? _traducao('global', 'encerrarProgramacaoAlerta')
									: titulo != '' && titulo != 'Despacho'
									? `Ao encerrar o ${titulo.toLocaleLowerCase()}, este não poderá mais se vincular a um Diário de Bordo.`
									: _traducao('global', 'encerrarDespachoAlerta')
							}}</AlertWarning
						>
						<ButtonEdit size="lg" @click="clickSetaTipoDiario(false, true)">
							<span v-if="despacho == ''"
								>{{
									dbComercial
										? _traducao('global', 'adicionarProgramacaoVoo')
										: titulo != '' && titulo != 'Despacho'
										? _traducao('global', 'adicionar') +
										  ' ' +
										  titulo.toLocaleLowerCase()
										: _traducao('global', 'adicionarDespacho')
								}}
							</span>
							<span v-if="despacho != ''"
								>{{
									dbComercial
										? _traducao('global', 'alterarProgramacaoVoo')
										: titulo != '' && titulo != 'Despacho'
										? _traducao('global', 'alterar') +
										  ' ' +
										  titulo.toLocaleLowerCase()
										: _traducao('global', 'alterarDespacho')
								}}
							</span>
						</ButtonEdit>
						<hr />
					</div>
				</div>

				<!-- DESPACHO -->
				<div v-if="despacho != ''">
					<div class="row">
						<div class="col-xs-6 col-md-2 form-group">
							<label>{{ _traducao('global', 'codigo') }}:</label>
							<br />
							<p>{{ despacho.numero }}</p>
						</div>

						<div class="col-xs-6 col-md-2 form-group">
							<label
								>{{ _traducao('global', 'data') }}
								<small v-if="_fusoHorarioAeronave(aeronave.fuso_horario) != ''"
									>(UTC{{ _fusoHorarioAeronave(aeronave.fuso_horario) }})</small
								>
								<flHorarioUtc
									v-if="_fusoHorarioAeronave(aeronave.fuso_horario) == ''"
									:fuso-horario="fusoHorario"
								/>
								:</label
							>
							<br />
							<p>{{ despacho.data_inicio | dataTempo }}</p>
						</div>

						<div class="col-md-4 col-xs-12 form-group">
							<label>{{ _traducao('global', 'descricao') }}:</label>
							<br />
							<p>{{ despacho.historico | na }}</p>
						</div>

						<div
							class="col-xs-12 col-md-4"
							:class="{'has-error': erro.finalizar_despacho != ''}"
							v-if="
								!dbComercial ||
								liberarProgramacao ||
								form.finalizar_despacho == '1'
							"
						>
							<i
								style="font-size: 12px"
								v-tooltip="
									'O encerramento só será liberado após o preenchimento completo do trecho final.'
								"
								class="fa fa-info-circle"
								aria-hidden="true"
							></i>
							<label>
								{{
									dbComercial
										? _traducao('global', 'desejaEncerrarEssaProgramacaoVoo')
										: titulo != '' && titulo != 'Despacho'
										? _traducao('global', 'desejaEncerrarEsse') +
										  ' ' +
										  titulo.toLocaleLowerCase()
										: _traducao('global', 'desejaEncerrarEsseDespacho')
								}}
							</label>
							<br />
							<div class="btn-group print-button-group" role="group">
								<button
									type="button"
									@click="
										form.finalizar_despacho = '1'
										erro.finalizar_despacho = ''
									"
									:class="{'btn-info': form.finalizar_despacho == '1'}"
									class="btn btn-default btn-sm"
								>
									{{ _traducao('global', 'sim') }}
								</button>
								<button
									type="button"
									@click="
										form.finalizar_despacho = '0'
										erro.finalizar_despacho = ''
									"
									:class="{'btn-info': form.finalizar_despacho == '0'}"
									class="btn btn-default btn-sm"
								>
									{{ _traducao('global', 'nao') }}
								</button>
							</div>
							<p class="help-block" v-if="erro.finalizar_despacho">
								{{ erro.finalizar_despacho }}
							</p>
						</div>
					</div>

					<div v-if="despacho.id_ordem_missao != null && !dbComercial">
						<flCabecalhoForm
							class="print-titulo-form-20"
							:texto="_traducao('global', 'ordemDeMissao')"
						/>

						<div class="row">
							<div class="col-xs-6 col-md-2 form-group">
								<label>{{ _traducao('global', 'codigo') }}:</label>
								<br />
								<p>{{ despacho.ordem_codigo }}</p>
							</div>

							<div class="col-xs-6 col-md-2 form-group">
								<label>{{ _traducao('global', 'data') }}:</label>
								<br />
								<p>{{ despacho.ordem_data_inicio | dataTempo }}</p>
							</div>

							<div class="col-md-4 col-xs-12 form-group">
								<label>{{ _traducao('global', 'descricao') }}:</label>
								<br />
								<p v-html="despacho.ordem_descricao"></p>
							</div>

							<div
								class="col-md-4 col-xs-12"
								:class="{'has-error': erro.finalizar_ordem != ''}"
								v-if="exibeFinalizarOrdemMissao == '1'"
							>
								<label
									>*
									{{
										_traducao('global', 'desejaEncerrarEssaOrdemDeMissao')
									}}</label
								>
								<br />
								<div class="btn-group print-button-group" role="group">
									<button
										type="button"
										@click="
											form.finalizar_ordem = '1'
											erro.finalizar_ordem = ''
										"
										:disabled="edicao && form.finalizar_ordem == 1"
										:class="{'btn-info': form.finalizar_ordem == '1'}"
										class="btn btn-default btn-sm"
									>
										{{ _traducao('global', 'sim') }}
									</button>
									<button
										type="button"
										@click="
											form.finalizar_ordem = '0'
											erro.finalizar_ordem = ''
										"
										:class="{'btn-info': form.finalizar_ordem == '0'}"
										:disabled="edicao && form.finalizar_ordem == 1"
										class="btn btn-default btn-sm"
									>
										{{ _traducao('global', 'nao') }}
									</button>
								</div>
								<p class="help-block" v-if="erro.finalizar_ordem">
									{{ erro.finalizar_ordem }}
								</p>
							</div>
						</div>
					</div>

					<div v-if="despacho.id_solicitacao != null">
						<flCabecalhoForm
							class="print-titulo-form-20"
							:texto="_traducao('global', 'solicitaUsoAeronave')"
						/>

						<div class="row">
							<div class="col-xs-6 col-md-2 form-group">
								<label>{{ _traducao('global', 'codigo') }}:</label>
								<br />
								<p>{{ despacho.solicitacao_codigo }}</p>
							</div>

							<div class="col-md-10 col-xs-12">
								<label>{{ _traducao('global', 'descricao') }}:</label>
								<br />
								<p>{{ despacho.solicitacao_descricao | na }}</p>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div v-if="!visualizar && exibeForm" style="margin-top: 22px">
				<div class="row" v-if="aeronave.tipo == 'A'">
					<div class="col-xs-12">
						<flCabecalhoForm :texto="'APU'" />
						<AlertDanger v-if="msgHorimetroApuInvalido">
							{{ msgHorimetroApuInvalido }}
						</AlertDanger>
						<div class="row">
							<div v-for="apu in computedApuAeronave" :key="'1' + apu.id">
								<div class="col-xs-12 col-md-2 form-group">
									<label>{{ _traducao('global', 'inicial') }}:</label><br />
									<money
										type="text"
										v-model="form.horimetro_inicial_apu"
										v-bind="_vpercem(1)"
										class="input-sm form-control"
									></money>
								</div>
								<div class="col-xs-12 col-md-2 form-group">
									<label>{{ _traducao('global', 'final') }}:</label><br />
									<money
										type="text"
										v-model="form.horimetro_final_apu"
										v-bind="_vpercem(1)"
										class="input-sm form-control"
									></money>
								</div>
								<div class="col-xs-12 col-md-2 form-group">
									<label>{{ _traducao('global', 'horas') }}:</label><br />
									<money
										type="text"
										v-model="form.horimetro_apu"
										v-bind="_vpercem(1)"
										class="input-sm form-control"
										disabled
									></money>
								</div>
								<div class="col-xs-6 col-md-2 form-group">
									<label>{{ _traducao('global', 'ciclos') }}:</label>
									<button
										type="button"
										class="pass-btn-mais-btn btn-link text-center"
										@click.prevent="form.ciclos_apu += 1"
									>
										<i style="margin-top: 7px" class="fa fa-plus fa-fw"></i>
									</button>
									<button
										type="button"
										:disabled="form.ciclos_apu == 0"
										class="pass-btn-menos-btn btn-link text-center"
										@click.prevent="form.ciclos_apu -= 1"
									>
										<i style="margin-top: 8px" class="fa fa-minus fa-fw"></i>
									</button>
									<input
										type="text"
										:value="form.ciclos_apu"
										:style="
											form.nome_mecanico_assinou == ''
												? 'cursor:default;background:#FFF;'
												: ''
										"
										v-mask="'00'"
										disabled="disabled"
										class="form-control text-center input-sm"
									/>
								</div>
							</div>
						</div>
						<div class="row" v-if="computedApuAeronave.length == 0">
							<div class="col-xs-12">
								<p>Não foi encontrada instalação de APU neste período.</p>
							</div>
						</div>
					</div>
				</div>

				<!-- EXIBE O FORM SE O TIPO DO VOO FOR DIFERENTE DE VAZIO -->
				<div v-if="exibeForm">
					<!-- TRECHO  -->
					<div class="row" :class="{'form-group': aeronave.tipo == 'A'}">
						<div class="col-xs-12">
							<flCabecalhoForm
								class="print-titulo-form-20"
								:texto="_traducao('global', 'trecho')"
							/>
							<!-- DE -->
							<div class="row">
								<div
									class="col-xs-12 col-md-4 form-group"
									:class="{'has-error': erro.de != ''}"
								>
									<label>* {{ _traducao('menuVoo', 'menuVde') }}:</label>

									<a
										href="#"
										@click.prevent="clickInverter()"
										style="position: absolute; right: 16px"
									>
										<i class="fa fa-retweet fa-fw" aria-hidden="true"></i
										>{{ _traducao('global', 'inverter') }}
									</a>

									<a
										href="#"
										@click.prevent="preencherRotaer(form.de, 'de')"
										v-if="form.de_select && form.de_select._default"
										style="position: absolute; right: 80px"
									>
										<i class="fa fa-magnet fa-fw" aria-hidden="true"></i
										>{{ _traducao('global', 'carregarPosicaoDoVoo') }}
									</a>
									<select-items
										@select="
											(item) => {
												form.de_select = item ? item : null
											}
										"
										:items="rotaER"
										:label="
											(item) =>
												`${item.sigla} - ${item.local ? item.local : 'N/A'}`
										"
										:active="
											(item) =>
												item && form.de_select && form.de_select.id == item.id
										"
										:class-erro="erro.de"
										@next="nextPageRotaer"
										@search="searchRotaerServer"
										:search-server="true"
										:observed="true"
										:has-next-page="hasNextPageRotaer"
										show-disabled
										:filter-disabled="
											(item) => item && Number(item.desativado) == 1
										"
									>
										<template #item>
											<span style="font-size: 11px" v-if="form.de_select">
												{{ form.de_select.sigla }} -
												{{
													form.de_select.local ? form.de_select.local : 'N/A'
												}}
											</span>
										</template>
									</select-items>
									<p class="help-block" v-if="erro.de != ''">{{ erro.de }}</p>
								</div>

								<div
									class="col-xs-12 col-md-2 form-group"
									v-if="form.de != ''"
									:class="{'has-error': erro.nome_estado_de != ''}"
								>
									<label>* {{ _traducao('global', 'estado') }}:</label>
									<select
										v-model="form.nome_estado_de"
										@change="blurCarregaCidades('de', true)"
										:disabled="form.de_select && !form.de_select._default"
										class="form-control input-sm"
									>
										<option value="">
											{{ _traducao('global', 'escolha').toUpperCase() }}
										</option>
										<option
											v-for="item in estados"
											:value="item.sigla"
											:key="'2' + item.sigla"
										>
											{{ item.sigla | upper }}
										</option>
									</select>
									<p class="help-block" v-if="erro.nome_estado_de != ''">
										{{ erro.nome_estado_de }}
									</p>
								</div>
								<div
									class="col-xs-12 col-md-2 form-group"
									v-if="form.de != ''"
									:class="{'has-error': erro.nome_cidade_de != ''}"
								>
									<label>* {{ _traducao('global', 'cidade') }}:</label>
									<span class="pull-right" v-if="loadDe">
										<i class="fa fa-fw fa-refresh fa-spin"></i>
										{{ _traducao('global', 'carregando') }}...</span
									>
									<input
										type="text"
										disabled="disabled"
										v-if="form.de_select && !form.de_select._default"
										class="form-control input-sm"
										v-model="form.nome_cidade_de"
									/>
									<select
										v-model="form.nome_cidade_de"
										v-else
										class="form-control input-sm"
									>
										<option value="">
											{{ _traducao('global', 'escolha').toUpperCase() }}
										</option>
										<option
											v-for="item in cidadesDe"
											:value="item.descricao"
											:key="'3' + item.descricao.toUpperCase()"
										>
											{{ item.descricao.toUpperCase() }}
										</option>
									</select>
									<p class="help-block" v-if="erro.nome_cidade_de != ''">
										{{ erro.nome_cidade_de }}
									</p>
								</div>
								<div class="col-xs-12 col-md-2 form-group">
									<label> Latitude:</label>
									<input
										v-model="form.lat_inicio"
										type="text"
										class="form-control input-sm"
										:disabled="form.de_select && !form.de_select._default"
										v-mask="'S00º00\'00'"
										placeholder="DGGºMM'SS"
									/>
								</div>

								<div class="col-xs-12 col-md-2 form-group">
									<label> Longitude:</label>
									<input
										v-model="form.lng_inicio"
										:disabled="form.de_select && !form.de_select._default"
										type="text"
										class="form-control input-sm"
										v-mask="'S000º00\'00'"
										placeholder="DGGGºMM'SS"
									/>
								</div>
							</div>

							<!-- PARA -->
							<div class="row" style="margin-top: 16px">
								<div
									class="col-xs-12 col-md-4 form-group"
									:class="{'has-error': erro.para != ''}"
								>
									<label>* {{ _traducao('menuVoo', 'menuVpara') }}:</label>

									<a
										href="#"
										@click.prevent="clickCopiarDe()"
										style="position: absolute; right: 16px"
									>
										<i class="fa fa-hand-o-up fa-fw" aria-hidden="true"></i
										>{{ _traducao('global', 'copiar') }}
									</a>

									<a
										href="#"
										@click.prevent="preencherRotaer(form.para, 'para')"
										v-if="form.para_select && form.para_select._default"
										style="position: absolute; right: 80px"
									>
										<i class="fa fa-magnet fa-fw" aria-hidden="true"></i
										>{{ _traducao('global', 'carregarPosicaoDoVoo') }}
									</a>
									<select-items
										@select="
											(item) => {
												form.para_select = item ? item : null
											}
										"
										:items="rotaER"
										:label="
											(item) =>
												`${item.sigla} - ${item.local ? item.local : 'N/A'}`
										"
										:active="
											(item) =>
												item &&
												form.para_select &&
												form.para_select.id == item.id
										"
										:class-erro="erro.para"
										@next="nextPageRotaer"
										@search="searchRotaerServer"
										:search-server="true"
										:observed="true"
										:has-next-page="hasNextPageRotaer"
										show-disabled
										:filter-disabled="(item) => item && item.desativado == '1'"
									>
										<template #item>
											<span style="font-size: 11px" v-if="form.para_select">
												{{ form.para_select.sigla }} -
												{{
													form.para_select.local
														? form.para_select.local
														: 'N/A'
												}}
											</span>
										</template>
									</select-items>
									<p class="help-block" v-if="erro.para != ''">
										{{ erro.para }}
									</p>
								</div>

								<div
									class="col-xs-12 col-md-2 form-group"
									v-if="form.para != ''"
									:class="{'has-error': erro.nome_estado_para != ''}"
								>
									<label>* {{ _traducao('global', 'estado') }}:</label>
									<select
										v-model="form.nome_estado_para"
										@change="blurCarregaCidades('para', true)"
										:disabled="form.para_select && !form.para_select._default"
										class="form-control input-sm"
									>
										<option value="">
											{{ _traducao('global', 'escolha').toUpperCase() }}
										</option>
										<option
											v-for="item in estadosDestino"
											:value="item.sigla"
											:key="'4' + item.sigla"
										>
											{{ item.sigla | upper }}
										</option>
									</select>
									<p class="help-block" v-if="erro.nome_estado_para != ''">
										{{ erro.nome_estado_para }}
									</p>
								</div>

								<div
									class="col-xs-12 col-md-2 form-group"
									v-if="form.para != ''"
									:class="{'has-error': erro.nome_cidade_para != ''}"
								>
									<label>* {{ _traducao('global', 'cidade') }}:</label>
									<span class="pull-right" v-if="loadPara">
										<i class="fa fa-fw fa-refresh fa-spin"></i>
										{{ _traducao('global', 'carregando') }}...</span
									>
									<input
										type="text"
										disabled="disabled"
										v-if="form.para_select && !form.para_select._default"
										class="form-control input-sm"
										v-model="form.nome_cidade_para"
									/>
									<select
										v-model="form.nome_cidade_para"
										v-else
										class="form-control input-sm"
									>
										<option value="">
											{{ _traducao('global', 'escolha').toUpperCase() }}
										</option>
										<option
											v-for="item in cidadesPara"
											:value="item.descricao"
											:key="'5' + item.descricao.toUpperCase()"
										>
											{{ item.descricao.toUpperCase() }}
										</option>
									</select>
									<p class="help-block" v-if="erro.nome_cidade_para != ''">
										{{ erro.nome_cidade_para }}
									</p>
								</div>

								<div class="col-xs-12 col-md-2 form-group">
									<label> {{ _traducao('global', 'latitude') }}:</label>
									<input
										v-model="form.lat_fim"
										type="text"
										class="form-control input-sm"
										:disabled="form.para_select && !form.para_select._default"
										v-mask="'S00º00\'00'"
										placeholder="DGGºMM'SS"
									/>
								</div>

								<div class="col-xs-12 col-md-2 form-group">
									<label> {{ _traducao('global', 'longitude') }}:</label>
									<input
										v-model="form.lng_fim"
										:disabled="form.para_select && !form.para_select._default"
										type="text"
										class="form-control input-sm"
										v-mask="'S000º00\'00'"
										placeholder="DGGGºMM'SS"
									/>
								</div>
							</div>
						</div>
					</div>

					<AlertInfo v-if="_idCliente == 62"
						>Os locais de operação desabilitados já estão vinculados ao trecho
						selecionado acima.</AlertInfo
					>
					<div class="row" v-if="_idCliente == 62">
						<div class="col-xs-12 col-md-6">
							<flCabecalhoForm texto="Local de operação - Origem" />
							<div class="row">
								<div class="col-xs-12 form-group">
									<label>* Origem:</label>
									<select-items
										@select="
											(item) => {
												form.id_integracao_local_origem = item
													? item.idLocalOperacao
													: null
											}
										"
										:items="locaisOperacaoOrigem"
										:label="
											(item) =>
												`${item.designativo} - ${item.nome ? item.nome : 'N/A'}`
										"
										:active="
											(item) =>
												item &&
												form.id_integracao_local_origem == item.idLocalOperacao
										"
										:search-items="searchRotaer"
										:class-erro="erro.local_operacao_origem"
									/>
								</div>
							</div>
						</div>
						<div class="col-xs-12 col-md-6">
							<flCabecalhoForm texto="Local de operação - Destino" />
							<div class="row">
								<div class="col-xs-12 form-group">
									<label>* Destino:</label>
									<select-items
										@select="
											(item) => {
												form.id_integracao_local_destino = item
													? item.idLocalOperacao
													: null
											}
										"
										:items="locaisOperacaoDestino"
										:label="
											(item) =>
												`${item.designativo} - ${item.nome ? item.nome : 'N/A'}`
										"
										:active="
											(item) =>
												item &&
												form.id_integracao_local_destino == item.idLocalOperacao
										"
										:search-items="searchRotaer"
										:class-erro="erro.local_operacao_destino"
									/>
								</div>
							</div>
						</div>
					</div>

					<!-- MOTOR E HORARIO  -->
					<div style="margin-top: 20px">
						<AlertDanger
							v-if="erro.acionamento == '' && !integridadeHorarioAcionamento"
							>{{
								_traducao('global', 'horarioAcionamentoInvalido')
							}}</AlertDanger
						>
						<AlertDanger v-if="erro.acionamento != ''">{{
							erro.acionamento
						}}</AlertDanger>
						<div class="row">
							<div class="col-xs-12 col-md-4">
								<flCabecalhoForm :texto="_traducao('global', 'horario')" />

								<div class="row">
									<!-- ACIONAMENTO -->
									<div
										class="col-xs-12 col-sm-6 form-group"
										:class="{
											'has-error':
												erro.acionamento != '' || !integridadeHorarioAcionamento
										}"
									>
										<label>* {{ label_acionamento }}:</label>
										<flDateTime
											@v-model="(val) => setaAcionamento(val)"
											:value="form.acionamento"
											name="dtOrdemInicio"
											:lang="_getLangDp"
											:max-date="maxDate"
											time="HH:mm"
											:disabled="disabledTempos"
											:format="_formatDate"
										/>
										<label
											v-show="
												form.acionamento_utc != '' && fusoHorario != 'UTC'
											"
											style="position: absolute"
											>UTC: {{ form.acionamento_utc }}</label
										>
									</div>

									<!-- DECOLAGEM -->
									<div
										class="col-xs-12 col-sm-6 form-group"
										:class="{'has-error': erro.decolagem != ''}"
									>
										<label>* {{ _traducao('global', 'decolagem') }}:</label>
										<flDateTime
											@v-model="(val) => setaDecolagem(val)"
											:value="form.decolagem"
											name="dtOrdemInicio"
											:lang="_getLangDp"
											:max-date="maxDate"
											time="HH:mm"
											:disabled="disabledTempos"
											:format="_formatDate"
										/>
										<p class="help-block" v-if="erro.decolagem != ''">
											{{ erro.decolagem }}
										</p>
										<label
											v-show="form.decolagem_utc != '' && fusoHorario != 'UTC'"
											style="position: absolute"
											>UTC: {{ form.decolagem_utc }}</label
										>
									</div>
								</div>

								<!-- POUSO/CORTE -->
								<div class="row" style="margin-top: 16px">
									<div
										class="col-xs-12 col-sm-6 form-group"
										:class="{'has-error': erro.pouso != ''}"
									>
										<label>* {{ _traducao('global', 'pouso') }}:</label>
										<flDateTime
											@v-model="(val) => setaPouso(val)"
											:value="form.pouso"
											name="dtOrdemPouso"
											:lang="_getLangDp"
											time="HH:mm"
											:disabled="disabledTempos"
											:max-date="maxDate"
											:format="_formatDate"
										/>
										<p class="help-block" v-if="erro.pouso != ''">
											{{ erro.pouso }}
										</p>
										<label
											v-show="form.pouso_utc != '' && fusoHorario != 'UTC'"
											style="position: absolute"
											>UTC: {{ form.pouso_utc }}</label
										>
									</div>

									<div
										class="col-xs-12 col-sm-6 form-group"
										:class="{'has-error': erro.corte != ''}"
									>
										<label>* {{ _traducao('global', 'corte') }}:</label>
										<flDateTime
											@v-model="(val) => setaCorte(val)"
											:value="form.corte"
											name="dtOrdemPouso"
											:lang="_getLangDp"
											time="HH:mm"
											:disabled="disabledTempos"
											:max-date="maxDate"
											:format="_formatDate"
										/>
										<p class="help-block" v-if="erro.corte != ''">
											{{ erro.corte }}
										</p>
										<label
											v-show="form.corte_utc != '' && fusoHorario != 'UTC'"
											style="position: absolute"
											>UTC: {{ form.corte_utc }}</label
										>
									</div>
								</div>
							</div>

							<!-- HORIMETRO MOTOR/CELULA -->
							<div class="col-xs-12 col-md-8">
								<div class="row">
									<div class="col-md-6">
										<flCabecalhoForm :texto="this.horasDeAcionamentoCorte" />

										<div class="row">
											<!-- HORIMETRO CELULA INICIAL/FINAL -->
											<div
												class="col-xs-12 col-md-6 form-group"
												:class="{'has-error': erro.horimetro_inicial != ''}"
											>
												<label>{{ _traducao('global', 'inicial') }}:</label>
												<money
													type="text"
													v-model="form.horimetro_inicial"
													disabled="disabled"
													v-bind="_vpercem(1)"
													class="input-sm form-control"
												></money>
												<p
													class="help-block"
													v-if="erro.horimetro_inicial != ''"
												>
													{{ erro.horimetro_inicial }}
												</p>
											</div>

											<div class="col-xs-12 col-md-6 form-group">
												<label>{{ _traducao('global', 'final') }}:</label>
												<money
													type="text"
													v-model="form.horimetro_final"
													disabled="disabled"
													v-bind="_vpercem(1)"
													class="input-sm form-control"
												></money>
												<p class="help-block" v-if="erro.horimetro_final != ''">
													{{ erro.horimetro_final }}
												</p>
											</div>
										</div>
									</div>

									<div class="col-md-6">
										<flCabecalhoForm
											:texto="_traducao('global', 'horasDecolagemPouso')"
										/>

										<div class="row">
											<!-- HORIMETRO MOTOR INICIAL/FINAL -->
											<div class="col-xs-12 col-md-6 form-group">
												<label>{{ _traducao('global', 'inicial') }}:</label>
												<money
													type="text"
													v-model="form.horimetro_inicial_manutencao"
													disabled="disabled"
													v-bind="_vpercem(1)"
													class="input-sm form-control"
												></money>
												<p
													class="help-block"
													v-if="erro.horimetro_inicial_manutencao != ''"
												>
													{{ erro.horimetro_inicial_manutencao }}
												</p>
											</div>

											<div class="col-xs-12 col-md-6 form-group">
												<label>{{ _traducao('global', 'final') }}:</label>
												<money
													type="text"
													v-model="form.horimetro_final_manutencao"
													disabled="disabled"
													v-bind="_vpercem(1)"
													class="input-sm form-control"
												></money>
												<p
													class="help-block"
													v-if="erro.horimetro_final_manutencao != ''"
												>
													{{ erro.horimetro_final_manutencao }}
												</p>
												<span
													class="text-info"
													v-if="form.alteradoPeloMecanico"
												>
													<i class="fa fa-fw fa-info-circle"></i
													>{{ _traducao('global', 'editadoMecanico') }}</span
												>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

					<!-- TEMPO DE VOO -->
					<tempoVoo
						ref="tempoVooRef"
						:form="form"
						:erro="erro"
						:aeronave="aeronave"
						:fuso-horario="fusoHorario"
						:label-tempo-acionamento-corte="labelTempoAcionamentoCorte"
						:valida-vfr="validaVfr"
						:preencher="preencher"
						:editar="editar"
						@tempo-voo-valido="dadosTempoVooValido"
						@tempo-voo-invalido="dadosTempoVooInvalido"
					/>

					<!-- DADOS DE MONITORAMENTO -->
					<div v-if="mostraDadosMotor">
						<flCabecalhoForm
							class="print-titulo-form-20"
							:texto="_traducao('global', 'dadosDeMonitoramento')"
						/>

						<div
							class="row"
							v-for="dadosMonitoramento in form.monitoramento_motor"
							:key="dadosMonitoramento.id"
						>
							<div class="col-sm-12">
								<h4>{{ dadosMonitoramento.descricao }}</h4>
								<hr />
							</div>

							<div class="col-xs-6 col-md-2 col-lg-4 coldcolform-group">
								<label>{{ _traducao('global', 'altitude') }}:</label>
								<input
									type="text"
									class="form-control input-sm"
									maxlength="5"
									v-model="dadosMonitoramento.altitude"
								/>
							</div>

							<div class="col-xs-6 col-md-2 col-lg-4 form-group">
								<label>OAT (ºC):</label>
								<input
									type="text"
									class="form-control input-sm"
									maxlength="5"
									v-model="dadosMonitoramento.oat"
								/>
							</div>

							<div class="col-xs-6 col-md-2 col-lg-4 form-group">
								<label>IAS:</label>
								<input
									type="text"
									class="form-control input-sm"
									maxlength="5"
									v-model="dadosMonitoramento.ias"
								/>
							</div>

							<div class="col-xs-6 col-md-2 col-lg-2 form-group">
								<label>{{ _traducao('global', 'numberMotor') }}:</label>
								<input
									type="text"
									class="form-control input-sm"
									disabled
									v-model="dadosMonitoramento.serial_number"
								/>
							</div>

							<div class="col-xs-6 col-md-2 col-lg-2 form-group">
								<label>Np (RPM):</label>
								<input
									type="text"
									class="form-control input-sm"
									maxlength="5"
									v-model="dadosMonitoramento.rpm"
								/>
							</div>

							<div class="col-xs-6 col-md-2 col-lg-2 form-group">
								<label>Ng/NH (%):</label>
								<money
									type="text"
									v-bind="_vpercem(1)"
									class="input-sm form-control"
									v-model="dadosMonitoramento.ng"
								></money>
							</div>

							<div class="col-xs-6 col-md-2 col-lg-2 form-group">
								<label>NL:</label>
								<input
									type="text"
									class="form-control input-sm"
									maxlength="5"
									v-model="dadosMonitoramento.nl"
								/>
							</div>

							<div class="col-xs-6 col-md-2 col-lg-2 form-group">
								<label>Fuel Flow:</label>
								<input
									type="text"
									class="form-control input-sm"
									maxlength="5"
									v-model="dadosMonitoramento.fuel_flow"
								/>
							</div>

							<div class="col-xs-6 col-md-2 col-lg-2 form-group">
								<label>ITT/TB (ºC):</label>
								<input
									type="text"
									class="form-control input-sm"
									maxlength="5"
									v-model="dadosMonitoramento.itt"
								/>
							</div>

							<div class="col-xs-6 col-md-2 col-lg-2 form-group">
								<label>TQ (ft-lbs):</label>
								<input
									type="text"
									class="form-control input-sm"
									maxlength="5"
									v-model="dadosMonitoramento.tq"
								/>
							</div>

							<div class="col-xs-6 col-md-2 col-lg-2 form-group">
								<label>{{ _traducao('global', 'abastecimentoOleo') }}:</label>
								<input
									type="text"
									class="form-control input-sm"
									maxlength="5"
									v-model="dadosMonitoramento.abastecimento_oleo"
								/>
							</div>
						</div>
					</div>

					<!-- VERIFICAÇÃO DO VOR -->
					<div v-if="mostraVor">
						<flCabecalhoForm
							class="print-titulo-form-20"
							:texto="_traducao('global', 'verificacaoDoVor')"
						/>

						<div class="row">
							<div class="col-xs-6 col-md-2 col-lg-12 form-group">
								<label>{{ _traducao('global', 'verificacaoDoVor') }}?</label>
								<br />
								<div class="btn-group print-button-group" role="group">
									<button
										type="button"
										@click="form.verificacao_vor = '1'"
										:class="{
											'btn-info': form.verificacao_vor == '1'
										}"
										class="btn btn-default btn-sm"
									>
										{{ _traducao('global', 'sim') }}
									</button>
									<button
										type="button"
										@click="form.verificacao_vor = '0'"
										:class="{
											'btn-info': form.verificacao_vor == '0'
										}"
										class="btn btn-default btn-sm"
									>
										{{ _traducao('global', 'nao') }}
									</button>
								</div>
								<div v-if="form.verificacao_vor == '1'">
									<div class="row" style="margin-top: 10px">
										<div class="col-xs-6 col-md-2 form-group">
											<label>VOR:</label>
											<input
												v-model="form.vor"
												class="input-sm form-control"
												type="text"
												maxlength="3"
											/>
										</div>
										<div class="col-xs-6 col-md-2 form-group">
											<label>{{ _traducao('global', 'radial') }}:</label>
											<input
												v-model="form.radial_vor"
												class="input-sm form-control"
												type="number"
												step="10"
												min="0"
												max="360"
											/>
										</div>
										<div class="col-xs-6 col-md-2 form-group">
											<label
												>{{ _traducao('global', 'afastamentoVor') }}:</label
											>
											<input
												v-model="form.afastamento_vor"
												class="input-sm form-control"
												type="number"
												step="10"
											/>
										</div>
										<div class="col-xs-6 col-md-2 form-group">
											<label>{{ _traducao('global', 'erroVor') }}:</label>
											<input
												v-model="form.erro_vor"
												class="input-sm form-control"
												type="number"
												step="10"
												min="0"
												max="360"
											/>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

					<!-- DADOS DO VOO -->
					<div>
						<flCabecalhoForm
							class="print-titulo-form-20"
							:texto="_traducao('global', 'dadosDoVoo')"
						/>

						<div class="row">
							<!-- COMBUSTIVEL -->
							<div
								class="col-xs-6 col-md-2 form-group"
								:class="{'has-error': erro.combustivel != ''}"
							>
								<label>* {{ _traducao('global', 'combustivel') }}:</label>
								<money
									type="text"
									v-model="form.combustivel"
									v-bind="_vpercem(0)"
									class="input-sm form-control"
								></money>
								<p class="help-block" v-if="erro.combustivel != ''">
									{{ erro.combustivel }}
								</p>
							</div>
							<div
								v-if="campoEncerrouCombustivel"
								class="col-xs-6 col-md-2 form-group"
								:class="{'has-error': erro.combustivelFinal != null}"
							>
								<label>* {{ _traducao('global', 'encerrouCom') }}:</label>
								<money
									type="text"
									v-model="form.combustivelFinal"
									v-bind="_vpercem(0)"
									class="input-sm form-control"
								></money>
								<p class="help-block" v-if="erro.combustivelFinal != null">
									{{ erro.combustivelFinal }}
								</p>
							</div>
							<!-- UNIDADE -->
							<div
								class="col-xs-6 col-md-2 form-group"
								:class="{'has-error': erro.unidade_combustivel != ''}"
							>
								<label>* {{ _traducao('global', 'relacao') }}:</label>
								<input
									class="input-sm form-control"
									v-show="this.aeronave.id_relacao_combustivel"
									:value="this.form.unidade_combustivel"
									disabled
								/>
								<select
									class="form-control input-sm"
									v-model="form.unidade_combustivel"
									v-show="!this.aeronave.id_relacao_combustivel"
								>
									<option value="">
										{{ _traducao('global', 'escolha').toUpperCase() }}
									</option>
									<option value="%">%</option>
									<option value="Litros">
										{{ _traducao('global', 'litros') }}
									</option>
									<option value="Libras">
										{{ _traducao('global', 'libras') }}
									</option>
									<option value="Galão">
										{{ _traducao('global', 'galao') }}
									</option>
									<option value="Kg">Kg</option>
								</select>
								<p class="help-block" v-if="erro.unidade_combustivel != ''">
									{{ erro.unidade_combustivel }}
								</p>
							</div>

							<!-- PARTIDAS -->
							<div
								class="col-xs-6 col-md-2 form-group"
								:class="{'has-error': erro.partidas != ''}"
								v-show="habilitaPartida"
							>
								<label>{{ _traducao('global', 'partidas') }}:</label>
								<button
									type="button"
									class="pass-btn-mais-btn btn-link text-center"
									@click.prevent="form.partidas += 1"
									:disabled="bloqueadoEdicao"
								>
									<i style="margin-top: 7px" class="fa fa-plus fa-fw"></i>
								</button>
								<button
									type="button"
									class="pass-btn-menos-btn btn-link text-center"
									:disabled="form.partidas == 0 || bloqueadoEdicao"
									@click.prevent="form.partidas -= 1"
								>
									<i style="margin-top: 8px" class="fa fa-minus fa-fw"></i>
								</button>
								<input
									type="text"
									:value="form.partidas"
									v-mask="'00'"
									disabled="disabled"
									class="form-control text-center input-sm"
									:style="
										!bloqueadoEdicao ? 'cursor:default; background:#FFF;' : ''
									"
								/>
								<p class="help-block" v-if="erro.partidas != ''">
									{{ erro.partidas }}
								</p>
							</div>

							<!-- POUSOS -->
							<div
								class="col-xs-6 col-md-2 form-group"
								:class="{'has-error': erro.pousos != ''}"
							>
								<label>{{ _traducao('global', 'pousos') }}:</label>
								<button
									type="button"
									class="pass-btn-mais-btn btn-link text-center"
									@click.prevent="form.pousos += 1"
									:disabled="bloqueadoEdicao"
								>
									<i style="margin-top: 7px" class="fa fa-plus fa-fw"></i>
								</button>
								<button
									type="button"
									:disabled="form.pousos == 0 || bloqueadoEdicao"
									class="pass-btn-menos-btn btn-link text-center"
									@click.prevent="form.pousos -= 1"
								>
									<i style="margin-top: 8px" class="fa fa-minus fa-fw"></i>
								</button>
								<input
									type="text"
									:value="form.pousos"
									:style="
										!bloqueadoEdicao ? 'cursor:default; background:#FFF;' : ''
									"
									v-mask="'00'"
									disabled="disabled"
									class="form-control text-center input-sm"
								/>
								<p class="help-block" v-if="erro.pousos != ''">
									{{ erro.pousos }}
								</p>
							</div>

							<!-- GUINCHO -->
							<div
								class="col-xs-6 col-md-2 form-group"
								v-if="aeronave.tipo == 'H' && aeronave.habilita_guincho == '1'"
							>
								<label>{{ _traducao('global', 'guincho') }}:</label>
								<br />
								<button
									type="button"
									class="pass-btn-mais-btn btn-link text-center"
									@click.prevent="form.guincho += 1"
									:disabled="bloqueadoEdicao"
								>
									<i style="margin-top: 7px" class="fa fa-plus fa-fw"></i>
								</button>
								<button
									type="button"
									:disabled="form.guincho == 0 || bloqueadoEdicao"
									class="pass-btn-menos-btn btn-link text-center"
									@click.prevent="form.guincho -= 1"
								>
									<i style="margin-top: 8px" class="fa fa-minus fa-fw"></i>
								</button>
								<input
									type="text"
									:value="form.guincho"
									:style="
										!bloqueadoEdicao ? 'cursor:default; background:#FFF;' : ''
									"
									v-mask="'00'"
									disabled="disabled"
									class="form-control text-center input-sm"
								/>
							</div>

							<!-- GANCHO -->
							<div
								class="col-xs-6 col-md-2 form-group"
								v-if="aeronave.tipo == 'H' && aeronave.habilita_gancho == '1'"
							>
								<label>{{ _traducao('global', 'gancho') }}:</label>
								<br />
								<button
									type="button"
									class="pass-btn-mais-btn btn-link text-center"
									@click.prevent="form.gancho += 1"
									:disabled="bloqueadoEdicao"
								>
									<i style="margin-top: 7px" class="fa fa-plus fa-fw"></i>
								</button>
								<button
									type="button"
									:disabled="form.gancho == 0 || bloqueadoEdicao"
									class="pass-btn-menos-btn btn-link text-center"
									@click.prevent="form.gancho -= 1"
								>
									<i style="margin-top: 8px" class="fa fa-minus fa-fw"></i>
								</button>
								<input
									type="text"
									:value="form.gancho"
									:style="
										!bloqueadoEdicao ? 'cursor:default; background:#FFF;' : ''
									"
									v-mask="'00'"
									disabled="disabled"
									class="form-control text-center input-sm"
								/>
							</div>
						</div>

						<div class="row">
							<!-- PAX  -->
							<div v-if="tripulacaoTecnica !== '1'">
								<div
									class="col-xs-6 col-md-2 form-group"
									:class="{'has-error': erro.pax != ''}"
								>
									<label>PAX:</label>
									<input
										type="number"
										:disabled="disablePaxPob"
										v-model.lazy="form.pax"
										class="form-control input-sm"
										@change="
											form.pob = disablePaxPob
												? form.tripulacao.length + Math.abs(form.pax)
												: form.pob
										"
									/>
									<p class="help-block" v-if="erro.pax != ''">{{ erro.pax }}</p>
								</div>
								<!-- POB -->
								<div class="col-xs-6 col-md-2 form-group">
									<label>POB:</label>
									<input
										type="number"
										disabled
										v-model="form.pob"
										class="form-control input-sm"
									/>
								</div>
							</div>
							<div v-else>
								<div
									class="col-xs-6 col-md-2 form-group"
									:class="{'has-error': erro.pax != ''}"
								>
									<label>PAX:</label>
									<money
										disabled
										type="text"
										v-model="form.pax"
										v-bind="_vpercem(0)"
										class="input-sm form-control"
									></money>
									<p class="help-block" v-if="erro.pax != ''">{{ erro.pax }}</p>
								</div>
								<!-- POB -->
								<div class="col-xs-6 col-md-2 form-group">
									<label>POB:</label>
									<input
										type="number"
										disabled
										:value="form.passageiro.length + form.tripulacao.length"
										class="form-control input-sm"
									/>
								</div>
							</div>
							<div class="col-xs-6 col-md-2 form-group">
								<label>
									{{ _traducao('global', 'milhasNavegacao') }} :
									<i
										class="fa fa-info-circle"
										v-tooltip="_traducao('global', 'milhasNavegacaoTexto')"
									></i>
								</label>
								<!-- <input
									disabled
									v-model="form.milhas_navegacao"
									class="form-control input-sm"
								/> -->
								<money
									v-model="form.milhas_navegacao"
									v-bind="_vpercem(1)"
									class="form-control text-right input-sm"
								></money>
							</div>

							<!-- flir -->
							<div
								class="col-xs-6 col-md-2 form-group"
								v-if="aeronave.tipo == 'H' && aeronave.habilita_flir == '1'"
								:class="{'has-error': erro.flir != ''}"
							>
								<label>* {{ _traducao('global', 'usoDe') }} FLIR:</label>
								<br />
								<div class="btn-group print-button-group" role="group">
									<button
										type="button"
										@click="
											form.flir = '1'
											erro.flir = ''
										"
										:class="{'btn-info': form.flir == '1'}"
										class="btn btn-default btn-sm"
									>
										{{ _traducao('global', 'sim') }}
									</button>
									<button
										type="button"
										@click="
											form.flir = '0'
											erro.flir = ''
										"
										:class="{'btn-info': form.flir == '0'}"
										class="btn btn-default btn-sm"
									>
										{{ _traducao('global', 'nao') }}
									</button>
								</div>
								<p class="help-block" v-if="erro.flir != ''">{{ erro.flir }}</p>
							</div>
						</div>

						<div v-if="aeronave.ciclo_total == '1'">
							<flCabecalhoForm
								v-if="form.trecho_motor.length != 0"
								class="print-titulo-form-20"
								:texto="form.trecho_motor.length > 1  
									? _traducao('global', 'motores') : 
									_traducao('global', 'motor')"
							/>

							<!-- NUMERO DO VOO -->
							<div class="row" v-if="aeronave.numero_voo == '1'">
								<div
									class="col-xs-12 col-md-2 form-group"
									:class="{'has-error': erro.numero_voo != ''}"
								>
									<label>* {{ _traducao('global', 'numeroDeVoo') }}:</label>
									<input
										type="number"
										v-model="form.numero_voo"
										class="form-control input-sm"
									/>
									<p class="help-block" v-if="erro.numero_voo != ''">
										{{ erro.numero_voo }}
									</p>
								</div>
							</div>

							<div
								class="row"
								v-for="trechoMotor in form.trecho_motor"
								:key="'6' + trechoMotor.id"
							>
								<!-- SERIAL -->
								<div class="col-xs-6 col-md-2 form-group">
									<label>Serial Number:</label>
									<input
										type="text"
										disabled="disabled"
										:value="
											trechoMotor.serial_number +
											(trechoMotor.lado == 'D' && form.trecho_motor.length == 2
												? (_traducao('global', 'direito'))
												: trechoMotor.lado == 'E' &&
												  form.trecho_motor.length == 2
												?  (_traducao('global', 'esquerdo')) 
												: '')
										"
										class="form-control input-sm"
									/>
								</div>

								<!-- CICLO NG -->
								<div
									v-if="trechoMotor.tipo_aeronave == '2'"
									class="col-xs-6 col-md-2 form-group"
									:class="{'has-error': trechoMotor.erro_ciclo_ng != ''}"
								>
									<label>* {{ aeronave.nomenclatura_n1 }}:</label>
									<money
										type="text"
										v-model="trechoMotor.ciclo_ng"
										class="form-control text-right input-sm"
										v-bind="_vpercem(2)"
									></money>
									<p class="help-block" v-if="trechoMotor.erro_ciclo_ng != ''">
										{{ trechoMotor.erro_ciclo_ng }}
									</p>
								</div>
								<!-- CICLO NF -->
								<div
									v-if="trechoMotor.tipo_aeronave == '2'"
									class="col-xs-6 col-md-2 form-group"
									:class="{'has-error': trechoMotor.erro_ciclo_nf != ''}"
								>
									<label>* {{ aeronave.nomenclatura_n2 }} :</label>
									<money
										type="text"
										v-model="trechoMotor.ciclo_nf"
										class="form-control text-right input-sm"
										v-bind="_vpercem(2)"
									></money>
									<p class="help-block" v-if="trechoMotor.erro_ciclo_nf != ''">
										{{ trechoMotor.erro_ciclo_nf }}
									</p>
								</div>
								<!-- CICLO NP -->
								<div
									v-if="
										trechoMotor.tipo_aeronave == '2' &&
										aeronave.habilita_ciclo_np == 1
									"
									class="col-xs-6 col-md-2 form-group"
									:class="{'has-error': trechoMotor.erro_ciclo_np != ''}"
								>
									<label>* {{ aeronave.nomenclatura_np }}:</label>
									<money
										type="text"
										v-model="trechoMotor.ciclo_np"
										class="form-control text-right input-sm"
										v-bind="_vpercem(2)"
									></money>
									<p class="help-block" v-if="trechoMotor.erro_ciclo_np != ''">
										{{ trechoMotor.erro_ciclo_np }}
									</p>
								</div>

								<div class="col-xs-6 col-md-2 form-group">
									<label
										>{{ _traducao('global', 'horasMotor') }}:
										<i
											class="fa fa-info-circle"
											v-tooltip="_traducao('global', 'horasMotorInformativo')"
										>
										</i>
									</label>
									<input
										:value="
											trechoMotor.total_horimetro
												? trechoMotor.total_horimetro
												: 'N/A'
										"
										type="decimal"
										class="form-control text-right input-sm"
										disabled
									/>
								</div>
								<div
									v-if="trechoMotor.tipo_aeronave == '1'"
									class="col-xs-6 col-md-2 form-group"
									:class="{'has-error': trechoMotor.erro_ciclo_nf != ''}"
								>
									<label
										>* {{ _traducao('menuManutencao', 'menuMasaFixa') }}:</label
									>
									<money
										type="text"
										v-model="trechoMotor.ciclo_nf"
										v-bind="_vpercem(0)"
										class="form-control text-right input-sm"
										v-mask="'#'"
									></money>
									<p class="help-block" v-if="trechoMotor.erro_ciclo_nf != ''">
										{{ trechoMotor.erro_ciclo_nf }}
									</p>
								</div>
							</div>
						</div>
					</div>

					<!-- DADOS DO VOO -->
					<div>
						<div class="row print-titulo-form-20">
							<div class="col-md-12 col-xs-12 color" style="font-size: 14px">
								<button
									type="button"
									class="btn no-print btn-xs btn-danger pull-right"
									v-show="exibirRemover()"
									@click="limpardb()"
								>
								{{ _traducao('global', 'remover') }}
								</button>
								<p style="margin-top: 0px"> {{ _traducao('global', 'dadosAbastecimento') }} </p>
								<hr class="border-color" />
							</div>
						</div>

						<div
							class="form-group"
							:class="{'has-error': erro.existe_abastecimento != ''}"
						>
							<label>* {{ _traducao('global', 'houveAbastecimento') }}</label>
							<br />
							<div class="btn-group print-button-group" role="group">
								<button
									type="button"
									class="btn btn-default btn-sm"
									:class="{'btn-info': form.existe_abastecimento == '1'}"
									@click="adicionarAbastecimento()"
								>
									{{ _traducao('global', 'sim') }}
								</button>
								<button
									type="button"
									class="btn btn-default btn-sm"
									:class="{'btn-info': form.existe_abastecimento == '0'}"
									@click="naoHouveAbastecimento()"
								>
									{{ _traducao('global', 'nao') }}
								</button>
							</div>
							<p class="help-block" v-if="erro.existe_abastecimento != ''">
								{{ erro.existe_abastecimento }}
							</p>
						</div>
						<div v-if="form.existe_abastecimento == '1'">
							<abastecimentoBasico
								ref="abastecimentoBasicoRef"
								v-if="componenteAbastecimento == 'somente_ce'"
								:dados-abastecimento="form.abastecimentoCombustivel"
								:aeronave="aeronave"
								:trecho="trecho"
								:permitir-excluir="__permitirExcluir"
								@abastecimento-valido="dadosAbastecimentoValido"
								@abastecimento-invalido="dadosAbastecimentoInvalido"
							/>
							<abastecimentoIntermediario
								ref="abastecimentoIntermediarioRef"
								v-if="componenteAbastecimento == 'campos_intermediarios'"
								:dados-abastecimento="form.abastecimentoCombustivel"
								:aeronave="aeronave"
								:trecho="trecho"
								:fornecedores="fornecedores"
								:unidades-armazenamento="unidadesArmazenamento"
								:permitir-excluir="__permitirExcluir"
								@atualizar-lista-fornecedores="getFornecedores"
								@abastecimento-valido="dadosAbastecimentoValido"
								@abastecimento-invalido="dadosAbastecimentoInvalido"
							/>
							<abastecimentoMovimentacaoCombustivel
								ref="abastecimentoMovimentacaoCombustivelRef"
								v-if="
									componenteAbastecimento == 'campos_movimentacao_combustivel'
								"
								:dados-abastecimento="form.abastecimentoCombustivel"
								:aeronave="aeronave"
								:trecho="trecho"
								:fornecedores="fornecedores"
								:unidades-armazenamento="unidadesArmazenamento"
								:permitir-excluir="__permitirExcluir"
								@atualizar-lista-fornecedores="getFornecedores"
								@abastecimento-valido="dadosAbastecimentoValido"
								@abastecimento-invalido="dadosAbastecimentoInvalido"
								@seleciona-unidade-armazenamento="selecionaUnidadeArmazenamento"
								@carrega-contratos="carregaContratos"
								@carrega-empenhos="carregaEmpenhos"
								@preenhcer-Orgao="preencherOrgao"
							/>
						</div>
					</div>
					<!-- ÓLEO LUBRIFICANTE -->
					<div v-if="habilitaOleoLubrificante == true">
						<div class="row print-titulo-form-20">
							<div class="col-md-12 col-xs-12 color" style="font-size: 14px">
								<p>{{ _traducao('global', 'oleoLubrificante') }}</p>
								<hr
									class="border-color"
									style="margin-top: 2px; margin-bottom: 10px"
								/>
							</div>
						</div>

						<div class="form-group">
							<label>{{ _traducao('global', 'adicaoOleoLubrificante') }}</label>
							<br />
							<div class="btn-group print-button-group" role="group">
								<button
									type="button"
									class="btn btn-default btn-sm"
									:class="{'btn-info': form.adicao_oleo_lubrificante == '1'}"
									@click="form.adicao_oleo_lubrificante = '1'"
								>
									{{ _traducao('global', 'sim') }}
								</button>
								<button
									type="button"
									class="btn btn-default btn-sm"
									:class="{'btn-info': form.adicao_oleo_lubrificante == '0'}"
									@click="form.adicao_oleo_lubrificante = '0'"
								>
									{{ _traducao('global', 'nao') }}
								</button>
							</div>
						</div>

						<div v-if="form.adicao_oleo_lubrificante == true">
							<div class="row">
								<div class="col-sm-2 form-group">
									<label>{{ _traducao('global', 'fornecedor') }}:</label>
									<select
										class="form-control"
										v-model="form.fornecedor_oleo_lubrificante"
									>
										<option
											v-for="fornecedor in fornecedores"
											:key="fornecedor.id"
											:value="fornecedor.id"
										>
											{{ fornecedor.razao_social }}
										</option>
									</select>
								</div>
								<div class="col-sm-2 form-group">
									<label>{{ _traducao('global', 'numeroDaCE') }}:</label>
									<input
										class="form-control"
										type="text"
										v-model="form.numero_ce_oleo_lubrificante"
									/>
								</div>
								<div
									v-if="
										dadosOleoLubrificante.campo_lubrificacao_1 != null &&
										dadosOleoLubrificante.campo_lubrificacao_1 != ''
									"
									class="col-sm-2 form-group"
								>
									<label
										>{{ dadosOleoLubrificante.campo_lubrificacao_1 }}:</label
									>
									<input
										class="form-control"
										type="number"
										step="0.1"
										min="0"
										v-model="form.campo_lubrificacao_1"
									/>
								</div>
								<div
									v-if="
										dadosOleoLubrificante.campo_lubrificacao_2 != null &&
										dadosOleoLubrificante.campo_lubrificacao_2 != ''
									"
									class="col-sm-2 form-group"
								>
									<label
										>{{ dadosOleoLubrificante.campo_lubrificacao_2 }}:</label
									>
									<input
										class="form-control"
										type="number"
										step="0.1"
										min="0"
										v-model="form.campo_lubrificacao_2"
									/>
								</div>
								<div
									v-if="
										dadosOleoLubrificante.campo_lubrificacao_3 != null &&
										dadosOleoLubrificante.campo_lubrificacao_3 != ''
									"
									class="col-sm-2 form-group"
								>
									<label
										>{{ dadosOleoLubrificante.campo_lubrificacao_3 }}:</label
									>
									<input
										class="form-control"
										type="number"
										step="0.1"
										min="0"
										v-model="form.campo_lubrificacao_3"
									/>
								</div>
								<div
									v-if="
										dadosOleoLubrificante.campo_lubrificacao_4 != null &&
										dadosOleoLubrificante.campo_lubrificacao_4 != ''
									"
									class="col-sm-2 form-group"
								>
									<label
										>{{ dadosOleoLubrificante.campo_lubrificacao_4 }}:</label
									>
									<input
										class="form-control"
										type="number"
										step="0.1"
										min="0"
										v-model="form.campo_lubrificacao_4"
									/>
								</div>
								<div
									v-if="
										dadosOleoLubrificante.campo_lubrificacao_5 != null &&
										dadosOleoLubrificante.campo_lubrificacao_5 != ''
									"
									class="col-sm-2 form-group"
								>
									<label
										>{{ dadosOleoLubrificante.campo_lubrificacao_5 }}:</label
									>
									<input
										class="form-control"
										type="number"
										step="0.1"
										min="0"
										v-model="form.campo_lubrificacao_5"
									/>
								</div>
							</div>

							<div class="row">
								<div class="col-sm-12 form-group">
									<label>{{ _traducao('global', 'observacoes') }}:</label>
									<textarea
										class="form-control input-sm"
										type="text"
										rows="2"
										v-model="form.observacoes_oleo_lubrificante"
									>
									</textarea>
								</div>
							</div>
							<div
								class="text-info"
								v-if="edicao_mecanico_oleo_lubrificante == '1'"
							>
								<p>
									<i
										class="fa fa-info-circle"
										v-tooltip="
											`${_traducao('global', 'dadosOleoEdicaoMecanico')}`
										"
									>
									</i>
									{{ _traducao('global', 'editadoMecanico') }}
								</p>
							</div>
						</div>
					</div>

					<!-- Performance Motor -->
					<div v-if="form.quantidadeMotores != 0">
						<div v-if="habilitaPerformanceMotor == true">
							<div>
								<flCabecalhoForm
									class="print-titulo-form-20"
									:texto="'Performance Motor'"
								/>
							</div>

							<div class="row">
								<div class="col-md-4 form-group">
									<div class="row">
										<!-- PERFORMANCE MOTOR -->
										<div class="col-xs-6 col-md-6 form-group">
											<label>{{ _traducao('global', 'horario') }}:</label>
											<flDateTime
												@v-model="
													(val) => {
														form.horario_performance_motor = val
													}
												"
												:value="form.horario_performance_motor"
												name="dtPerformance"
												:lang="_getLangDp"
												time="HH:mm"
												:format="_formatDate"
											/>
										</div>
										<div class="col-xs-6 col-md-6 form-group">
											<label>FL:</label>
											<input
												type="text"
												v-model="form.performance_fl"
												class="input-sm form-control"
											/>
										</div>
									</div>
								</div>
								<div class="col-md-4 form-group">
									<div class="row">
										<div class="col-xs-6 col-md-6 form-group">
											<label>TAT (°C):</label>
											<input
												type="number"
												v-model="form.performance_tat"
												class="input-sm form-control"
											/>
										</div>
										<div class="col-xs-6 col-md-6 form-group">
											<label>IAS (Knots):</label>
											<input
												type="number"
												v-model="form.performance_ias"
												class="input-sm form-control"
											/>
										</div>
									</div>
								</div>
								<div class="col-md-4 form-group">
									<div class="col-xs-6 col-md-6 form-group">
										<label>TAS (Knots):</label>
										<input
											type="number"
											v-model="form.performance_tas"
											class="input-sm form-control"
										/>
									</div>

									<div class="col-xs-6 col-md-6 form-group">
										<label>*Usou o boost? </label>
										<div
											class="btn-group no-print print-button-group"
											role="group"
											style="display: block"
										>
											<div class="btn-group print-button-group" role="group">
												<flSimNao
													v-model="form.performance_boost"
													:disabled="solicitacao_aprovada"
												/>
											</div>
										</div>
									</div>
								</div>
							</div>

							<div class="row">
								<div class="col-md-4 form-group">
									<div class="row">
										<div class="col-xs-6 col-md-6 form-group">
											<input-text
												:label="'Motor Esquerdo'"
												v-model="sn_motor_esquerdo"
												v-if="form.quantidadeMotores == 2"
												:disabled="true"
											/>
											<input-text
												:label="'Motor'"
												v-model="sn_motor_esquerdo"
												v-if="form.quantidadeMotores == 1"
												:disabled="true"
											/>
										</div>
										<div class="col-xs-6 col-md-6 form-group"></div>
									</div>

									<div class="row">
										<div class="col-xs-6 col-md-6 form-group">
											<label>Torque (%):</label>
											<money
												v-model="form.performance_torque_esq"
												class="input-sm form-control"
												v-bind="_vpercem(1)"
											>
											</money>
										</div>
										<div class="col-xs-6 col-md-6 form-group">
											<label>NP (%):</label>
											<money
												type="text"
												v-model="form.performance_np_esq"
												v-bind="_vpercem(1)"
												class="input-sm form-control"
											></money>
										</div>
									</div>

									<div class="row">
										<div class="col-xs-6 col-md-6 form-group">
											<label>ITT:</label>
											<input
												type="number"
												v-model="form.performance_itt_esq"
												class="input-sm form-control"
											/>
										</div>
										<div class="col-xs-6 col-md-6 form-group">
											<label>NH/N1 (%):</label>
											<money
												type="text"
												v-model="form.performance_nh_esq"
												v-bind="_vpercem(1)"
												class="input-sm form-control"
											></money>
										</div>
									</div>
									<div class="row">
										<div class="col-xs-6 col-md-6 form-group">
											<label>F/Flow (KG/H):</label>
											<input
												type="number"
												v-model="form.performance_flow_esq"
												class="input-sm form-control"
											/>
										</div>
										<div class="col-xs-6 col-md-6 form-group">
											<label>NL (%):</label>
											<input
												type="number"
												v-model="form.performance_nl_esq"
												class="input-sm form-control"
											/>
										</div>
									</div>
								</div>

								<div
									v-if="form.quantidadeMotores == 2"
									style="border-left: 1px solid #2196f3"
									class="col-md-4 form-group"
								>
									<div class="row">
										<div class="col-xs-6 col-md-6 form-group">
											<input-text
												:label="'Motor Direito'"
												v-model="sn_motor_direito"
												:disabled="true"
											/>
										</div>
										<div class="col-xs-6 col-md-6 form-group"></div>
									</div>

									<div class="row">
										<div class="col-xs-6 col-md-6 form-group">
											<label>Torque (%):</label>
											<money
												v-model="form.performance_torque_dir"
												class="input-sm form-control"
												v-bind="_vpercem(1)"
											>
											</money>
										</div>
										<div class="col-xs-6 col-md-6 form-group">
											<label>NP (%):</label>
											<money
												type="text"
												v-model="form.performance_np_dir"
												v-bind="_vpercem(1)"
												class="input-sm form-control"
											></money>
										</div>
									</div>

									<div class="row">
										<div class="col-xs-6 col-md-6 form-group">
											<label>ITT:</label>
											<input
												type="number"
												v-model="form.performance_itt_dir"
												class="input-sm form-control"
											/>
										</div>
										<div class="col-xs-6 col-md-6 form-group">
											<label>NH/N1 (%):</label>
											<money
												type="text"
												v-model="form.performance_nh_dir"
												v-bind="_vpercem(1)"
												class="input-sm form-control"
											></money>
										</div>
									</div>
									<div class="row">
										<div class="col-xs-6 col-md-6 form-group">
											<label>F/Flow (KG/H):</label>
											<input
												type="number"
												v-model="form.performance_flow_dir"
												class="input-sm form-control"
											/>
										</div>
										<div class="col-xs-6 col-md-6 form-group">
											<label>NL (%):</label>
											<input
												type="number"
												v-model="form.performance_nl_dir"
												class="input-sm form-control"
											/>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

					<!-- TRIPULAÇÃO -->
					<div>
						<flCabecalhoForm
							class="print-titulo-form-20"
							:texto="_traducao('global', 'tripulacao')"
						/>

						<AlertInfo>{{ _traducao('global', 'oPrimeiroAssina') }}</AlertInfo>

						<div class="row">
							<div style="display: flex; flex-wrap: wrap">
								<template v-for="(item, index) in form.tripulacao">
									<div
										class="col-lg-3 col-sm-6 col-xs-12"
										style="display: flex; min-height: 380px"
									>
										<div
											class="trecho-borda"
											style="margin-bottom: 10px; width: 100%"
										>
											<div class="row no-print">
												<div class="col-xs-12">
													<div
														style="
															margin-top: 0px;
															margin-bottom: 0px;
															font-size: 13px;
														"
													>
														<div v-if="index == 0" style="height: 40px">
															<span >{{
																exibeFuncao()
															}}</span>
														
															<div
																class="dropup"
																style="float: left; margin-right: 6px"
															>
																<a
																	href="#"
																	id="dropdownMenu1"
																	data-toggle="dropdown"
																	aria-haspopup="true"
																	aria-expanded="true"
																>
																	<svg
																		xmlns="http://www.w3.org/2000/svg"
																		fill="none"
																		viewBox="0 0 24 24"
																		stroke-width="1.5"
																		stroke="currentColor"
																		style="width: 20px"
																	>
																		<path
																			stroke-linecap="round"
																			stroke-linejoin="round"
																			d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99"
																		/>
																	</svg>
																</a>
																<ul
																	class="dropdown-menu dropdown-content"
																	aria-labelledby="dropdownMenu1"
																>
																	<li
																		:class="{
																			active: f.active
																		}"
																		v-for="f in funcoesQueAssinam"
																	>
																		<a
																			@click.prevent="
																				trocarPiloto(
																					'0',
																					f.descricao,
																					index,
																					false,
																					false
																				)
																			"
																			href="#"
																			>{{f.descricao.toUpperCase()}}</a
																		>
																	</li>
																</ul>
															</div>
														</div>
														<div v-else style="height: 40px">
															<span> {{ item.funcao.toUpperCase() }}</span>
														</div>
														<br />
														<a
															href="#"
															class="pull-right"
															v-if="index >= 1"
															@click.prevent="
																form.tripulacao.splice(index, 1)
																form.pob--
															"
															style="
																color: red;
																font-size: 14px;
																margin-top: 2px;
															"
														>
															<i class="fa fa-fw fa-trash-o"></i>
															{{ _traducao('global', 'remover') }}
														</a>

														<p
															class="pull-right"
															v-if="index == 0"
															style="
																color: #f9f9f9;
																font-size: 14px;
																margin-top: 2px;
																margin-bottom: 0px;
															"
														>
															<span>{{
																_traducao('global', 'piloto').toUpperCase()
															}}</span>
														</p>
													</div>
												</div>

												<div v-if="item.funcao == ''">
													<div
														class="col-xs-12 form-group"
														:class="{'has-error': item.erroFuncao != ''}"
														style="margin-top: 70px; margin-bottom: 97px"
													>
														<label>
															<span class="no-print">*</span>
															{{
																_traducao('global', 'escolhaAFuncaoTripulante')
															}}:</label
														>
														<select
															class="form-control input-sm"
															v-model="item.funcao"
															@change="
																carregaUsuariosTripulacao(
																	item.funcao,
																	index,
																	true,
																	false
																)
															"
														>
															<option value="">
																{{
																	_traducao('global', 'escolha').toUpperCase()
																}}
															</option>
															<option
																v-for="funcao of listaDeFuncoes"
																:key="'8' + funcao.id"
																:value="funcao.descricao"
															>
																{{ funcao.nome }}
															</option>
														</select>
														<p
															class="help-block"
															v-show="item.erroFuncao != ''"
														>
															{{ item.erroFuncao }}
														</p>
													</div>
												</div>

												<div v-if="item.funcao != ''">
													<!-- nome -->
													<div
														class="col-xs-12 form-group"
														:class="{'has-error': item.erroUsuario != ''}"
														v-if="item.usuarios && item.usuarios.length > 0"
													>
														<label
															><span class="no-print">*</span>
															{{ _traducao('global', 'nome') }}:</label
														>
														<template
															v-if="utilizaTrigrama && item.usuarios.length > 0"
														>
															<select-items
																v-show="!item.load"
																@select="
																	(po) => {
																		item.trigrama = po ? po.trigrama : null
																		carregaANACTrigrama(
																			item.usuarios,
																			item.trigrama,
																			index
																		)
																	}
																"
																show-disabled
																:items="item.usuarios"
																:label="(po) => po.trigrama + ' - ' + po.nome"
																:active="
																	(po) => item && po.trigrama == item.trigrama
																"
																:filter-disabled="(po) => po && po.status == 0"
															/>
														</template>
														<template v-else>
															<select-items
																v-show="!item.load"
																@select="
																	(po) => {
																		item.id_usuario = po ? po.id : null
																		carregaANAC(
																			item.usuarios,
																			item.id_usuario,
																			index
																		)
																	}
																"
																show-disabled
																:items="item.usuarios"
																:label="(po) => po.nome"
																:active="
																	(po) => item && po.id == item.id_usuario
																"
																:filter-disabled="(po) => po && po.status == 0"
															/>
														</template>

														<flCarregando v-show="item.load" />
														<p
															class="help-block"
															v-show="item.erroUsuario != ''"
														>
															{{ item.erroUsuario }}
														</p>
													</div>

													<!-- anac -->
													<div class="col-xs-12 form-group">
														<label>ANAC:</label>
														<input
															type="text"
															v-model="item.anac"
															disabled="disabled"
															class="form-control input-sm"
														/>
													</div>

													<!-- base -->
													<div class="col-xs-12 form-group">
														<label>Base:</label>
														<input
															type="text"
															v-model="item.base_contratual"
															disabled="disabled"
															class="form-control input-sm"
														/>
													</div>

													<!-- apresentacao -->
													<div
														class="col-xs-12 form-group"
														:class="{
															'has-error': item.erroApresentacao != ''
														}"
													>
														<label
															>* {{ _traducao('global', 'apresentacao') }}
															<small
																v-if="
																	_fusoHorarioAeronave(aeronave.fuso_horario) !=
																	''
																"
																>(UTC{{
																	_fusoHorarioAeronave(aeronave.fuso_horario)
																}})</small
															>
															<flHorarioUtc
																v-if="
																	_fusoHorarioAeronave(aeronave.fuso_horario) ==
																	''
																"
																:fuso-horario="fusoHorario"
															/>
															:</label
														>
														<a
															href="#"
															class="pull-right"
															v-if="index > 0"
															@click.prevent="
																item.apresentacao =
																	form.tripulacao[0].apresentacao
															"
														>
															{{ _traducao('global', 'copiar') }}
														</a>
														<div>
															<flDateTime
																@v-model="
																	(val) => {
																		item.apresentacao = val
																	}
																"
																:value="item.apresentacao"
																name="dtOrdemInicio"
																time="HH:mm"
																:lang="_getLangDp"
																:format="_formatDate"
																:max-date="maxDate"
																:completa-campo="false"
															/>
														</div>
														<p
															class="help-block"
															v-if="item.erroApresentacao != ''"
														>
															{{ item.erroApresentacao }}
														</p>
													</div>

													<div
														class="col-xs-12 form-group"
														:class="{'has-error': item.erroUsoOvn != ''}"
														v-if="
															aeronave.habilita_ovn &&
															aeronave.habilita_ovn != '0' &&
															aeronave.tipo == 'H' &&
															habilitaOVN(item.funcao)
														"
													>
														<label
															><span class="no-print"> *</span>
															{{ _traducao('global', 'usoDeOvn') }}:</label
														>
														<br />
														<div
															class="btn-group print-button-group"
															role="group"
														>
															<button
																type="button"
																@click="selectOvnTrue(item)"
																:class="{'btn-info': item.uso_ovn}"
																class="btn btn-default btn-sm"
															>
																{{ _traducao('global', 'sim') }}
															</button>
															<button
																type="button"
																@click="
																	selectOvnFalse(item)
																	item.tempoOvn = '00:00'
																	item.id_ovn = null
																	item.erroTempoOvn = ''
																	item.erroDataCadastro = ''
																	item.erroIdOvn = ''
																"
																:class="{'btn-info': !item.uso_ovn}"
																class="btn btn-default btn-sm"
															>
																{{ _traducao('global', 'nao') }}
															</button>
														</div>
														<p class="help-block" v-if="item.erroUsoOvn != ''">
															{{ item.erroUsoOvn }}
														</p>
													</div>
													<div
														v-if="
															item.uso_ovn == true && habilitaOVN(item.funcao)
														"
														class="col-xs-6 form-group"
														:class="{'has-error': item.erroIdOvn != ''}"
													>
														<label
															><span class="no-print"> *</span>
															{{ _traducao('global', 'sn') }}:</label
														>
														<div
															:class="{
																'has-error':
																	item.erroDataCadastro &&
																	item.erroDataCadastro != ''
															}"
														>
															<select
																v-model="item.id_ovn"
																class="form-control input-sm"
															>
																<option value="">
																	{{
																		_traducao('global', 'escolha').toUpperCase()
																	}}
																</option>
																<option
																	v-for="item in ovns"
																	:key="item.sn"
																	:value="item.id"
																>
																	{{ item.sn }}
																</option>
															</select>
															<p
																class="help-block"
																v-if="
																	item.erroDataCadastro &&
																	item.erroDataCadastro != ''
																"
															>
																{{ item.erroDataCadastro }}
															</p>
															<p class="help-block" v-if="item.erroIdOvn != ''">
																{{ item.erroIdOvn }}
															</p>
														</div>
													</div>
													<div
														v-if="
															item.uso_ovn == true && habilitaOVN(item.funcao)
														"
														class="col-xs-6 form-group"
														:class="{
															'has-error':
																item.erroTempoOvn && item.erroTempoOvn != ''
														}"
													>
														<input-time
															:label="'*' + _traducao('global', 'tempoUso')"
															v-model="item.tempoOvn"
														/>
														<p
															class="help-block"
															v-if="
																item.erroTempoOvn && item.erroTempoOvn != ''
															"
														>
															{{ item.erroTempoOvn }}
														</p>
													</div>

													<div
														class="col-xs-12 form-group"
														:class="{'has-error': erro.instrutor_voo != ''}"
													>
														<p
															class="help-block"
															v-if="erro.instrutor_voo != '' && index == 0"
														>
															{{ erro.instrutor_voo }}
														</p>
													</div>
												</div>
											</div>

											<div class="row" v-if="index == 0 && larguraTela > 768">
												<div
													class="inveter-tripulacao"
													v-tooltip="'Inverter Tripulação'"
													@click="inveterPilotoCopiloto()"
												>
													<span style="font-size: 11px">
														<svg
															xmlns="http://www.w3.org/2000/svg"
															fill="none"
															viewBox="0 0 24 24"
															stroke-width="1.5"
															stroke="currentColor"
															style="width: 20px"
														>
															<path
																stroke-linecap="round"
																stroke-linejoin="round"
																d="M7.5 21 3 16.5m0 0L7.5 12M3 16.5h13.5m0-13.5L21 7.5m0 0L16.5 12M21 7.5H7.5"
															/>
														</svg>
													</span>
												</div>
											</div>
										</div>
									</div>
									<div
										class="col-lg-3 col-sm-6 col-xs-12"
										v-if="index == 0 && larguraTela <= 768"
										style="margin-bottom: 10px"
									>
										<div class="text-center">
											<a
												href="#"
												class="btn btn-link"
												@click.prevent="inveterPilotoCopiloto()"
											>
												<span style="font-size: 11px">
													<svg
														xmlns="http://www.w3.org/2000/svg"
														fill="none"
														viewBox="0 0 24 24"
														stroke-width="1.5"
														stroke="currentColor"
														style="width: 20px"
													>
														<path
															stroke-linecap="round"
															stroke-linejoin="round"
															d="M3 7.5 7.5 3m0 0L12 7.5M7.5 3v13.5m13.5 0L16.5 21m0 0L12 16.5m4.5 4.5V7.5"
														/>
													</svg>
												</span>
												<p class="ellipsis-label">
													INVERTER DADOS DO PILOTO E COPILOTO
												</p>
											</a>
										</div>
									</div>
								</template>

								<div class="col-lg-3 col-sm-6 col-xs-12" style="display: flex">
									<div
										class="trecho-borda text-center add"
										@click="clickAddTripulante()"
										style="
											margin-bottom: 10px;
											cursor: pointer;
											display: flex;
											align-items: center;
											justify-content: center;
											width: 100%;
											min-height: 360px;
										"
									>
										<h3>
											{{ _traducao('global', 'adicionar').toUpperCase() }}
											<br />
											{{ _traducao('global', 'tripulacao').toUpperCase() }}
											<BR />
											<i class="fa fa-fw fa-plus"></i>
										</h3>
									</div>
								</div>
							</div>
						</div>
					</div>

					<!-- PASSAGEIROS -->
					<div>
						<flCabecalhoForm
							class="print-titulo-form-20"
							:texto="
								labelPassageiro == 1 && tripulacaoTecnica == '1'
									? _traducao('global', 'tripulacaoTecnica')
									: labelPassageiro == 1
									? _traducao('global', 'passageiros')
									: _traducao('global', 'passageiros') +
									  '/' +
									  _traducao('global', 'vitimas')
							"
						/>

						<div class="dropdown">
							<a
								:style="
									'margin-bottom: 5px; cursor: pointer; position: absolute; top: -40px; left: ' +
									(tripulacaoTecnica == '1' ? '130px' : '130px')
								"
								v-show="form.passageiro.length > 0"
								title="Imprimir Passageiro"
								class="dropdown dropdown-toggle"
								type="button"
								id="dropdownMenuButton"
								data-toggle="dropdown"
								aria-haspopup="true"
								aria-expanded="false"
							>
								<i
									class="icon-imprimir"
									style="font-size: 18px; color: #2196f3"
									aria-hidden="true"
								></i>
							</a>
							<div
								class="dropdown-menu pull-right"
								aria-labelledby="dropdownMenuButton"
								style="
									position: absolute;
									left: 80px;
									top: -20px;
									background: rgba(999, 999, 999, 1);
									border: none;
									width: 80px !important;
									box-shadow: none;
									margin-right: 14%;
									padding: 10px;
									border: 1px solid #ccc;
								"
							>
								<a
									href="#"
									@click.prevent="
										clickPrintPassageiro(form, 'imprimir_passageiro', form.id)
									"
									style="display: block"
								>
									<i
										class="fa fa-print"
										style="color: #2196f3; font-size: 12px"
										aria-hidden="true"
									></i>
									{{ _traducao('global', 'simples') }}
								</a>
								<a
									href="#"
									@click.prevent="
										clickPrintPassageiro(
											form,
											'imprimir_passageiro_completo',
											form.id
										)
									"
									style="display: block"
								>
									<i
										class="fa fa-print"
										style="color: #2196f3; font-size: 12px"
										aria-hidden="true"
									></i>
									{{ _traducao('global', 'completo') }}
								</a>
								<a
									href="#"
									@click.prevent="
										clickPrintPassageiro(
											form,
											'imprimir_passageiro_anac',
											form.id
										)
									"
									style="display: block; color: #2196f3"
								>
									<i
										class="fa fa-print"
										style="font-size: 12px"
										aria-hidden="true"
									></i>
									{{ _traducao('global', 'anac') }}
								</a>
							</div>
						</div>

						<div class="row">
							<div style="display: flex; flex-wrap: wrap">
								<div
									class="col-lg-3 col-md-4 col-xs-12"
									v-for="(item, indexPass) in form.passageiro"
									:key="indexPass"
									style="min-height: 260px; display: flex"
									v-if="item.tipo == 'P' || item.tipo == 'O'"
								>
									<!-- PASSAGEIRO -->
									<div
										class="trecho-borda"
										style="margin-bottom: 10px; width: 100%"
										v-if="item.tipo == 'P'"
									>
										<form autocomplete="false">
											<div class="row">
												<div class="col-xs-12 form-group">
													<label
														style="color: #1976d2"
														v-if="
															labelPassageiro == 1 && tripulacaoTecnica != '1'
														"
													>
														{{
															_traducao('global', 'passageiro').toUpperCase()
														}}
													</label>
													<label
														style="color: #1976d2"
														v-else-if="
															labelPassageiro == 1 && tripulacaoTecnica == '1'
														"
													>
														{{
															_traducao(
																'global',
																'tripulanteTecnico'
															).toUpperCase()
														}}
													</label>
													<label style="color: #1976d2" v-else>{{
														_traducao('global', 'passageiro').toUpperCase()
													}}</label>
													<a
														href="#"
														class="pull-right"
														@click.prevent="removePass(item, indexPass, 1)"
														style="color: red; font-size: 14px; margin-top: 2px"
													>
														<i class="fa fa-fw fa-trash-o"></i
														>{{ _traducao('global', 'remover') }}
													</a>
												</div>
											</div>
											<div class="row no-print">
												<!-- nome -->
												<div
													class="col-xs-12 form-group"
													:class="{'has-error': item.nomeErro}"
												>
													<label
														><span class="no-print">* </span>
														{{ _traducao('global', 'nome') }}:</label
													>

													<div>
														<vue-select
															ref="scrollPassageiros"
															class="form-control input-sm"
															label="nome"
															:filterable="false"
															@input="
																(val) => carregarPassageiro(val, indexPass)
															"
															:value="item"
															:options="listaFiltrada"
															@open="onOpen()"
															@close="onClose()"
															@search="(query) => buscaServeSide(query)"
															style="
																max-height: 70px;
																width: calc(100% - 37px);
																float: left;
															"
														>
															<template #list-footer>
																<li
																	ref="loadPassageiro"
																	class="loader"
																	v-show="hasNextPage"
																>
																	{{
																		_traducao('global', 'carregandoMaisOpcoes')
																	}}...
																</li>
															</template>
															<template #no-options>
																<li
																	@click.prevent=""
																	v-if="tripulacaoTecnica == '1'"
																>
																	{{
																		_traducao('global', 'semTripulacaoTecnica')
																	}}
																</li>
																<li @click.prevent="" v-else>
																	{{ _traducao('global', 'semPassageiros') }}
																</li>
															</template>
														</vue-select>
														<button
															type="button"
															class="btn btn-sm btn-info input-group-append"
															@click="abrirCadastroPassageiro(indexPass)"
														>
															<i class="fa fa-plus fa-fw"></i>
														</button>
														<p class="help-block" v-show="item.nomeErro">
															{{ item.nomeErro }}
														</p>
													</div>
												</div>
											</div>
											<div class="row">
												<!-- orgao -->
												<div
													class="col-xs-12 form-group"
													:class="{'has-error': item.orgaoErro}"
													v-if="enableOrgao"
												>
													<label>
														<span class="no-print">*</span>
														{{ centrodeCusto }}:</label
													>
													<input
														type="text"
														v-model="item.orgao"
														class="form-control input-sm"
													/>
													<p class="help-block" v-show="item.orgaoErro">
														{{ item.orgaoErro }}
													</p>
												</div>

												<!-- cargo -->
												<div
													class="col-xs-12 form-group"
													:class="{'has-error': item.cargoErro}"
													v-if="enableCargo"
												>
													<label>
														<span class="no-print">*</span>
														{{
															_traducao('menuSolicitaApoio', 'menuCargo')
														}}:</label
													>
													<input
														type="text"
														v-model="item.cargo"
														class="form-control input-sm"
													/>
													<p class="help-block" v-show="item.cargoErro">
														{{ item.cargoErro }}
													</p>
												</div>
											</div>
											<div class="row">
												<!-- CPF -->
												<div
													class="col-xs-6 form-group"
													:class="{'has-error': item.cpfErro}"
												>
													{{ passCpfObrigatorio ? '*' : '' }}
													<label
														>{{
															_traducao('menuAGnovoUsuario', 'menuAGcpf')
														}}:</label
													>
													<input
														type="text"
														v-model="item.cpf"
														v-mask="_vdocumento"
														class="form-control input-sm"
													/>
													<p class="help-block" v-show="item.cpfErro">
														{{ item.cpfErro }}
													</p>
												</div>

												<!-- telefone -->

												<div
													class="col-xs-6 form-group"
													:class="{'has-error': item.telefoneErro}"
												>
													<label>{{ _traducao('global', 'telefone') }}:</label>
													<input
														autocomplete="false"
														type="text"
														v-model="item.telefone"
														v-mask="_vtelefone"
														class="form-control input-sm"
													/>
													<p class="help-block" v-show="item.telefoneErro">
														{{ item.telefoneErro }}
													</p>
												</div>
											</div>
											<div class="row">
												<div class="col-xs-12 form-group" v-if="exibeOutro">
													<label>{{ nomeOutroDocumento }}</label>
													<input
														autocomplete="false"
														type="text"
														v-model="item.outro"
														class="form-control input-sm"
													/>
												</div>
											</div>
											<div class="row" v-if="parametroTipoPassageiro">
												<div class="col-sm-7 form-group">
													<label>
														{{ _traducao('global', 'tipoPassageiro') }}?
													</label>
													<div>
														<div
															class="btn-group"
															data-toggle="buttons"
															style="width: 100%"
														>
															<button
																disabled
																class="btn"
																style="width: calc(100% / 2)"
																:class="{
																	'btn-primary': item.tipo_passageiro == 1
																}"
															>
																<small>{{
																	_traducao('global', 'interno')
																}}</small>
															</button>
															<button
																disabled
																class="btn"
																style="width: calc(100% / 2)"
																:class="{
																	'btn-primary': item.tipo_passageiro == 2
																}"
															>
																<small>{{
																	_traducao('global', 'externo')
																}}</small>
															</button>
														</div>
													</div>
												</div>
											</div>
										</form>
									</div>
									<div class="trecho-borda" style="margin-bottom: 10px; width: 100%" v-if="item.tipo == 'O'">
										<div class="row">
											<div class="col-xs-12 form-group">
												<label style="color: #1976d2">
													{{ _traducao('global', 'passageiro').toUpperCase() }}
												</label>
												<a
													href="#"
													class="pull-right"
													@click.prevent="removePass(item, index, 1)"
													style="color: red; font-size: 14px; margin-top: 2px"
												>
													<i class="fa fa-fw fa-trash-o"></i
													>{{ _traducao('global', 'remover') }}
												</a>
											</div>
										</div>
										<div class="row">
											<div
												class="col-xs-12 form-group"
												:class="{'has-error': item.nomeErro}"
											>
												<label>* {{ _traducao('global', 'nome') }}:</label>
												<input
													type="text"
													v-model="item.nome"
													class="form-control input-sm"
												/>
												<p class="help-block" v-show="item.nomeErro">
													{{ item.nomeErro }}
												</p>
											</div>
										</div>
										<div class="row">
											<div class="col-xs-12 form-group">
												<label>CPF:</label>
												<input
													type="text"
													v-model="item.cpf"
													v-mask="_vdocumento"
													class="form-control input-sm"
												/>
											</div>
										</div>
									</div>
								</div>

								<div class="col-lg-3 col-md-4 col-xs-12" style="display: flex">
									<div
										class="trecho-borda text-center add"
										@click="clickAdicionaPassageiro('P')"
										style="
											margin-bottom: 10px;
											cursor: pointer;
											width: 100%;
											display: flex;
											align-items: center;
											justify-content: center;
											min-height: 260px;
										"
									>
										<h3 v-if="labelPassageiro == 1">
											{{ _traducao('global', 'adicionar').toUpperCase() }}
											<br />
											<span v-if="tripulacaoTecnica == '1'">{{
												_traducao('global', 'tripulanteTecnico').toUpperCase()
											}}</span>
											<span v-else>{{
												_traducao('global', 'passageiro').toUpperCase()
											}}</span>
											<BR />
											<i class="fa fa-fw fa-plus"></i>
										</h3>
										<h3 v-else>
											{{ _traducao('global', 'adicionar').toUpperCase() }}
											<br />
											{{ _traducao('global', 'passageiro').toUpperCase() }}
											<BR />
											<i class="fa fa-fw fa-plus"></i>
										</h3>
									</div>
								</div>
							</div>
						</div>
					</div>

					<!-- <tempoVoo
						ref="tempoVooRef"
						:form="form"
						:erro="erro"
						:aeronave="aeronave"
						:fuso-horario="fusoHorario"
						:label-tempo-acionamento-corte="labelTempoAcionamentoCorte"
						:valida-vfr="validaVfr"
						:preencher="preencher"
						:editar="editar"
						@tempo-voo-valido="dadosTempoVooValido"
						@tempo-voo-invalido="dadosTempoVooInvalido"
					/> -->
					<vitimas
						ref="vitimasRef"
						:form="form.passageiro"
						@atualiza-vitimas="clickAdicionaPassageiro"
						@excluir-vitimas="removePass"
					/>
					<!-- <div>
						nelson mandela
					</div> -->
					<!-- CARGA TRANSPORTADA -->
					<div>
						<!-- CARGA TRANSPORTADA -->
						<div>
							<flCargaTransportada
								ref="cargaTransportada"
								:form="form"
								:solicitacao_aprovada="false"
								:carga-array="form.cargaArray"
								:passageiros="form.passageiro"
								:possui-trechos="false"
							/>
						</div>
					</div>

					<!-- DISCREPANCIAS -->
					<div>
						<flCabecalhoForm
							class="print-titulo-form-20"
							:texto="_traducao('global', 'discrepanciasTecnicas')"
						/>
						<div
							class="row"
							v-for="(item, index) in form.discrepancia"
							:key="item.id + 'discrepancia'"
						>
							<!-- nome -->
							<div class="col-md-4 col-xs-12 form-group">
								<div class="row">
									<div
										class="col-xs-12 form-group"
										:class="{'has-error': item.erroUsuario != ''}"
									>
										<label
											><span class="no-print">*</span>
											{{ _traducao('global', 'nome') }}:</label
										>
										<a
											href="#"
											class="pull-right"
											v-if="item.id == 0"
											@click.prevent="form.discrepancia.splice(index, 1)"
											style="color: red; font-size: 14px; margin-top: 2px"
										>
											<i class="fa fa-fw fa-trash-o"></i
											>{{ _traducao('global', 'remover') }}
										</a>
										<template v-if="utilizaTrigrama">
											<select
												v-if="_isMobile"
												v-model="item.trigrama"
												@blur="
													getANAC(_pilotos_mecanicos, item.trigrama, index)
												"
												class="form-control input-sm"
											>
												<option
													v-for="p in _pilotos_mecanicos"
													:key="p.id + 'pmecanicos'"
													:value="p.trigrama"
												>
													{{ p.trigrama }} - {{ p.nome }}
												</option>
											</select>
											<v-select
												v-if="!_isMobile"
												:value="item.trigrama"
												@input="
													({trigrama}) =>
														getANAC(_pilotos_mecanicos, trigrama, index)
												"
												class="form-control input-sm"
												label="descricao"
												:options="_pilotos_mecanicos"
											></v-select>
										</template>
										<template v-else>
											<select
												v-model="item.id_usuario"
												@blur="
													getANAC(_pilotos_mecanicos, item.id_usuario, index)
												"
												class="form-control input-sm"
											>
												<option
													v-for="p in _pilotos_mecanicos"
													:key="p.id + 'pmech'"
													:value="p.id_usuario"
												>
													{{ p.nome }}
												</option>
											</select>
										</template>

										<p class="help-block" v-show="item.erroUsuario != ''">
											{{ item.erroUsuario }}
										</p>
									</div>

									<!-- anac -->
									<div class="col-xs-12 form-group">
										<label>ANAC:</label>
										<input
											type="text"
											class="form-control input-sm"
											v-model="item.anac"
											disabled="disabled"
										/>
									</div>

									<div class="col-xs-12 form-group">
										<label>ATA SPEC 100:</label>
										<v-select
											:options="listaAtas"
											label="descricao_completa"
											v-model="item.ata"
											class="form-control input-sm"
										></v-select>
									</div>
								</div>
							</div>

							<!-- descricao -->
							<div
								class="col-md-8 col-xs-12"
								:class="{'has-error': item.erroDescricao != ''}"
							>
								<label>* {{ _traducao('global', 'descricao') }}:</label>
								<textarea
									v-model="item.descricao"
									class="form-control input-sm"
									rows="13"
								></textarea>
								<p class="help-block" v-show="item.erroDescricao != ''">
									{{ item.erroDescricao }}
								</p>
							</div>

							<!-- acoes tomadas -->
							<div class="col-xs-12">
								<div
									v-if="item.acao_discrepancia.length > 0"
									style="
										border: 1px solid #ddd;
										padding: 8px;
										margin-top: 4px;
										margin-bottom: 8px;
									"
								>
									<!-- <hr style="margin-bottom:4px; margin-top:4px" /> -->
									<div class="row" v-if="item.acao_discrepancia.length > 0">
										<div class="col-xs-12 text-center">
											<strong>{{
												_traducao('global', 'acoesTomadas').toUpperCase()
											}}</strong>
										</div>
									</div>
									<hr style="margin-bottom: 4px; margin-top: 4px" />

									<div
										v-for="itAcao in item.acao_discrepancia"
										:key="itAcao.id + 'itacao'"
									>
										<div class="row">
											<div class="col-xs-2">
												<strong>{{ _traducao('global', 'acao') }}:</strong>
												<br />
												<span v-if="itAcao.tipo_acao == 'C'">{{
													_traducao('global', 'acaoCorretiva').toUpperCase()
												}}</span>
												<span v-if="itAcao.tipo_acao == 'P'">{{
													_traducao('global', 'acaoPreventiva').toUpperCase()
												}}</span>
												<span v-if="itAcao.tipo_acao == 'M'">{{
													_traducao('global', 'monitoramento').toUpperCase()
												}}</span>
												<span v-if="itAcao.tipo_acao == 'I'">{{
													_traducao(
														'global',
														'indisponibilizarAeronave'
													).toUpperCase()
												}}</span>
											</div>
											<div class="col-xs-3">
												<strong>{{ _traducao('global', 'nome') }} - ANAC:</strong> <br />
												{{ itAcao.nome }} - {{ itAcao.codigo_anac }}
											</div>
											<div class="col-xs-3">
												<strong>Data:</strong> <br />
												{{ itAcao.data_cadastro | dataTempo }}
											</div>
											<div class="col-xs-4">
												<strong> {{ (_traducao('global', 'descricao')) }} :</strong> <br />
												{{ itAcao.descricao_acao }}
											</div>
										</div>
									</div>

									<div v-if="item.data_conclusao">
										<hr style="margin-bottom: 4px; margin-top: 4px" />
										<div class="row">
											<div class="col-xs-12 text-center">
												<strong>{{
													_traducao('global', 'conclusao').toUpperCase()
												}}</strong>
											</div>
										</div>
										<hr style="margin-bottom: 4px; margin-top: 4px" />

										<div class="row">
											<div class="col-xs-2">
												<strong>{{ _traducao('global', 'data') }}:</strong
												><br />
												{{ item.data_conclusao | dataTempo }}
											</div>
											<div class="col-xs-3">
												<strong
													>{{ _traducao('global', 'nome') }} - ANAC:</strong
												>
												<br />
												{{ item.nome_usuario_conclusao }} -
												{{ item.anac_usuario_conclusao | na }}
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>

						<div class="row">
							<div class="col-xs-12" style="margin-top: 10px">
								<button
									class="btn btn-info btn-sm"
									type="button"
									@click="clickAddDiscrepancia()"
								>
									<i class="fa fa-fw fa-plus"></i
									>{{
										_traducao('global', 'adicionarDiscrepancia').toUpperCase()
									}}
								</button>
							</div>
						</div>
					</div>

					<!-- OCORRÊNCIAS -->
					<div>
						<flCabecalhoForm
							class="print-titulo-form-20"
							:texto="_traducao('global', 'ocorrencias')"
						/>
						<div
							v-for="(item, index) in form.ocorrencias"
							:key="item.id + 'ocorrencias'"
						>
							<div class="row">
								<!-- data -->
								<div
									class="col-md-3 col-xm-12 form-group"
									:class="{'has-error': item.erro_data != ''}"
								>
									<label
										><span class="no-print">*</span>
										{{ _traducao('global', 'data') }}:</label
									>
									<a
										href="#"
										class="pull-right"
										v-if="item.id == 0"
										@click.prevent="form.ocorrencias.splice(index, 1)"
										style="color: red; font-size: 14px; margin-top: 2px"
									>
										<i class="fa fa-fw fa-trash-o"></i
										>{{ _traducao('global', 'remover') }}
									</a>
									<flDateTime
										@v-model="
											(val) => {
												item.data = val
											}
										"
										:value="item.data"
										name="dtOrdemInicio"
										:lang="_getLangDp"
										time="HH:mm"
										:format="_formatDate"
									/>
									<!-- <input type="text" class="form-control input-sm" v-model="item.data"> -->
									<p class="help-block" v-show="item.erro_data != ''">
										{{ item.erro_data }}
									</p>
								</div>

								<!-- LOCAL -->
								<div
									class="col-md-9 col-xm-12 form-group"
									:class="{'has-error': item.erro_local != ''}"
								>
									<label
										><span class="no-print">*</span>
										{{ _traducao('global', 'local') }}:
										<i
											class="fa fa-info-circle"
											v-tooltip="_traducao('global', 'tooltipLocalOcorrencia')"
										></i
									></label>
									<input
										type="text"
										class="form-control input-sm"
										v-model="item.local"
									/>
									<p class="help-block" v-show="item.erro_local != ''">
										{{ item.erro_local }}
									</p>
								</div>
							</div>
							<div class="row">
								<!-- CódiGo classificacao -->
								<div
									class="col-md-3 col-xm-12 form-group"
									:class="{'has-error': item.erro_codigo_classificacao != ''}"
								>
									<label
										><span class="no-print">*</span
										>{{ _traducao('global', 'codigoClassificacao') }}:</label
									>
									<select
										class="form-control input-sm"
										v-model="item.codigo_classificacao"
									>
										<option value="">
											{{ _traducao('global', 'escolha').toUpperCase() }}
										</option>
										<option value="HTSAN">
											HTSAN - {{ _traducao('global', 'saudeESanitarias') }}
										</option>
										<option value="AVSEC">
											AVSEC - {{ _traducao('global', 'segurancaRelativa') }}
										</option>
										<option value="PBSEC">
											PBSEC - {{ _traducao('global', 'segurancaPublica') }}
										</option>
										<option value="OTR">
											OTR - {{ _traducao('global', 'outrasClassificacao') }}
										</option>
									</select>
									<p
										class="help-block"
										v-show="item.erro_codigo_classificacao != ''"
									>
										{{ item.erro_codigo_classificacao }}
									</p>
								</div>

								<!-- Qualificação civil -->
								<div
									class="col-md-9 col-xm-12 form-group"
									:class="{'has-error': item.erro_qualificacao_civil != ''}"
								>
									<label
										><span class="no-print">*</span>
										{{ _traducao('global', 'qualificacaoCivil') }}:
										<i
											class="fa fa-info-circle"
											v-tooltip="
												_traducao('global', 'tooltipQualificacaoCivil')
											"
										></i
									></label>
									<input
										type="text"
										class="form-control input-sm"
										v-model="item.qualificacao_civil"
									/>
									<p
										class="help-block"
										v-show="item.erro_qualificacao_civil != ''"
									>
										{{ item.erro_qualificacao_civil }}
									</p>
								</div>
							</div>

							<div class="row">
								<!-- DESCRIÇÃO DOS FATOS -->
								<div
									class="col-md-12 col-xm-12 form-group"
									:class="{'has-error': item.erro_descricao_fatos != ''}"
								>
									<label
										><span class="no-print">*</span>
										{{ _traducao('global', 'descricaoDosFatos') }}:
										<i
											class="fa fa-info-circle"
											v-tooltip="_traducao('global', 'tooltipDescricaoFatos')"
										></i
									></label>
									<textarea
										type="text"
										class="form-control input-sm"
										v-model="item.descricao_fatos"
									></textarea>
									<p
										class="help-block"
										v-show="item.erro_descricao_fatos != ''"
									>
										{{ item.erro_descricao_fatos }}
									</p>
								</div>
							</div>
						</div>

						<div class="row">
							<div class="col-xs-12" style="margin-top: 10px">
								<button
									class="btn btn-info btn-sm"
									type="button"
									@click="clickAddOcorrencia()"
								>
									<i class="fa fa-fw fa-plus"></i>
									{{ _traducao('global', 'adicionarOcorrencia').toUpperCase() }}
								</button>
							</div>
						</div>
					</div>

					<!-- DADOS MISSAO -->
					<div>
						<flCabecalhoForm
							class="print-titulo-form-20"
							:texto="
								dbComercial
									? _traducao('global', 'dadosProgramacaoVoo')
									: _traducao('global', 'dadosDaMissao')
							"
						/>

						<form autocomplete="off">
							<div class="row">
								<div
									class="col-xs-12 col-md-2 form-group"
									:class="{'has-error': erro.base != ''}"
								>
									<label>* {{ _traducao('global', 'base') }}:</label>
									<select v-model="form.base" class="form-control input-sm">
										<option value="">
											{{ _traducao('global', 'escolha').toUpperCase() }}
										</option>
										<option
											v-for="item in bases"
											:key="item.descricao"
											:value="item.id"
										>
											{{ item.descricao }}
										</option>
									</select>
									<p class="help-block" v-if="erro.base">{{ erro.base }}</p>
								</div>
								<div
									class="col-xs-12 col-md-2 form-group"
									:class="{'has-error': erro.numero_chamada != ''}"
									v-if="
										exibeRedsSamu == 'Exibir apenas 1 campo' ||
										exibeRedsSamu == 'Exibir os 2 campos'
									"
								>
									<label>{{ this.numeroOcorrenciaSamu }}:</label>
									<input
										type="text"
										class="form-control input-sm"
										v-model="form.numero_chamada"
									/>
									<p class="help-block" v-if="erro.chamada != ''">
										{{ erro.numero_chamada }}
									</p>
								</div>
								<div
									class="col-xs-12 col-md-2 form-group"
									:class="{'has-error': erro.numero_bo != ''}"
									v-if="exibeRedsSamu == 'Exibir os 2 campos'"
								>
									<label
										><span v-if="this.form.ocorrencia193Obrigatoria">*</span>
										{{ this.numeroOcorrencia193 }}:</label
									>
									<input
										type="text"
										class="form-control input-sm"
										maxlength="100"
										v-model="form.numero_bo"
									/>
									<p class="help-block" v-if="erro.numero_bo != ''">
										{{ erro.numero_bo }}
									</p>
								</div>
								<div
									v-if="exibeObjetivosMissao == '1'"
									class="col-xs-12 col-md-6 form-group"
									:class="{'has-error': erro.objetivo_alcancado != ''}"
								>
									<label
										>*
										{{
											_traducao('global', 'objetivosMissaoAlcancados')
										}}</label
									>
									<br />
									<div class="btn-group print-button-group" role="group">
										<button
											type="button"
											@click="
												form.objetivo_alcancado = 'S'
												erro.objetivo_alcancado = ''
											"
											:class="{'btn-info': form.objetivo_alcancado == 'S'}"
											class="btn btn-default btn-sm"
										>
											{{ _traducao('global', 'sim') }}
										</button>
										<button
											type="button"
											@click="
												form.objetivo_alcancado = 'P'
												erro.objetivo_alcancado = ''
											"
											:class="{'btn-info': form.objetivo_alcancado == 'P'}"
											class="btn btn-default btn-sm"
										>
											{{ _traducao('global', 'parcial') }}
										</button>
										<button
											type="button"
											@click="
												form.objetivo_alcancado = 'N'
												erro.objetivo_alcancado = ''
											"
											:class="{'btn-info': form.objetivo_alcancado == 'N'}"
											class="btn btn-default btn-sm"
										>
											{{ _traducao('global', 'nao') }}
										</button>
									</div>
									<p class="help-block" v-if="erro.objetivo_alcancado">
										{{ erro.objetivo_alcancado }}
									</p>
								</div>
							</div>
						</form>

						<hr />

						<!-- SE FOR PMSP -->
						<div class="row" v-if="_idCliente == 14">
							<!-- AUTO LOCALIZACAO -->
							<div class="col-xs-8 col-md-2 form-group">
								<label>Auto Localização:</label>
								<br />
								<button
									type="button"
									class="pass-btn-mais-btn btn-link text-center"
									@click.prevent="form.auto_localizado += 1"
								>
									<i style="margin-top: 7px" class="fa fa-plus fa-fw"></i>
								</button>
								<button
									type="button"
									:disabled="form.auto_localizado == 0"
									class="pass-btn-menos-btn btn-link text-center"
									@click.prevent="form.auto_localizado -= 1"
								>
									<i style="margin-top: 8px" class="fa fa-minus fa-fw"></i>
								</button>
								<input
									type="text"
									:value="form.auto_localizado"
									style="cursor: default; background: #fff"
									v-mask="'00'"
									disabled="disabled"
									class="form-control text-center input-sm"
								/>
							</div>

							<!-- ARMAS APREENDIDAS -->
							<div class="col-xs-8 col-md-2 form-group">
								<label>Armas Apreendidas:</label>
								<br />
								<button
									type="button"
									class="pass-btn-mais-btn btn-link text-center"
									@click.prevent="form.arma_apreendida += 1"
								>
									<i style="margin-top: 7px" class="fa fa-plus fa-fw"></i>
								</button>
								<button
									type="button"
									:disabled="form.arma_apreendida == 0"
									class="pass-btn-menos-btn btn-link text-center"
									@click.prevent="form.arma_apreendida -= 1"
								>
									<i style="margin-top: 8px" class="fa fa-minus fa-fw"></i>
								</button>
								<input
									type="text"
									:value="form.arma_apreendida"
									style="cursor: default; background: #fff"
									v-mask="'00'"
									disabled="disabled"
									class="form-control text-center input-sm"
								/>
							</div>

							<!-- PESSOAS DETIDAS -->
							<div class="col-xs-8 col-md-2 form-group">
								<label>Pessoas Detidas:</label>
								<br />
								<button
									type="button"
									class="pass-btn-mais-btn btn-link text-center"
									@click.prevent="form.pessoa_detida += 1"
								>
									<i style="margin-top: 7px" class="fa fa-plus fa-fw"></i>
								</button>
								<button
									type="button"
									:disabled="form.pessoa_detida == 0"
									class="pass-btn-menos-btn btn-link text-center"
									@click.prevent="form.pessoa_detida -= 1"
								>
									<i style="margin-top: 8px" class="fa fa-minus fa-fw"></i>
								</button>
								<input
									type="text"
									:value="form.pessoa_detida"
									style="cursor: default; background: #fff"
									v-mask="'00'"
									disabled="disabled"
									class="form-control text-center input-sm"
								/>
							</div>

							<!-- PESSOAS SALVAS -->
							<div class="col-xs-8 col-md-2 form-group">
								<label>Pessoas Salvas:</label>
								<br />
								<button
									type="button"
									class="pass-btn-mais-btn btn-link text-center"
									@click.prevent="form.pessoa_salva += 1"
								>
									<i style="margin-top: 7px" class="fa fa-plus fa-fw"></i>
								</button>
								<button
									type="button"
									:disabled="form.pessoa_salva == 0"
									class="pass-btn-menos-btn btn-link text-center"
									@click.prevent="form.pessoa_salva -= 1"
								>
									<i style="margin-top: 8px" class="fa fa-minus fa-fw"></i>
								</button>
								<input
									type="text"
									:value="form.pessoa_salva"
									style="cursor: default; background: #fff"
									v-mask="'00'"
									disabled="disabled"
									class="form-control text-center input-sm"
								/>
							</div>

							<!-- VALOR RECUPERADO -->
							<div class="col-xs-8 col-md-2 form-group">
								<label>Valor Recuperado:</label>
								<br />
								<money
									type="text"
									v-model="form.valor_recuperado"
									v-bind="_vpercem(2)"
									class="form-control text-right input-sm"
								></money>
							</div>

							<div class="col-xs-12">
								<hr />
							</div>
						</div>

						<!-- TIPO DE MISSAO E DESCRICAO -->
						<div class="row">
							<div
								v-if="homologadoAnac"
								class="col-xs-12 col-md-6 form-group"
								:class="{'has-error': erro.tipo_natureza != ''}"
							>
								<label>* {{ _traducao('global', 'naturezaDoVoo') }}:</label>
								<v-select
									v-model="form.tipo_natureza"
									class="form-control input-sm"
									label="label"
									:options="tiposDeNaturezas"
								></v-select>

								<p class="help-block" v-if="erro.tipo_natureza != ''">
									{{ erro.tipo_natureza }}
								</p>
							</div>
						</div>

						<div class="row">
							<div
								class="col-xs-12 col-md-6 form-group"
								:class="{'has-error': erro.tipo_missao != ''}"
							>
								<label
									>*
									{{
										labelTipoMissao !== ''
											? labelTipoMissao
											: _traducao('global', 'tipoMissao')
									}}:</label
								>
								<v-select
									v-model="form.tipo_missao"
									class="form-control input-sm"
									label="descricao"
									:options="__tiposDeMissoes"
									@search:blur="limpaCamposDepoisDeSelecionar()"
									@change="filtraCampos()"
								></v-select>

								<p class="help-block" v-if="erro.tipo_missao != ''">
									{{ erro.tipo_missao }}
								</p>
							</div>
							<div
								v-if="habilitaDescMissao"
								class="col-xs-12 col-md-6 form-group"
							>
								<label>
									{{
										labelDescMissao === ''
											? _traducao('menuAGtipoMissao', 'menuAGdescMissao2')
											: labelDescMissao
									}}:</label
								>
								<v-select
									v-model="form.descricao"
									class="form-control input-sm"
									label="descricao"
									:options="descricaoMissaoAux"
									@input="checaMeioAmbiente()"
								></v-select>
							</div>
						</div>

						<!-- TRANSPLANTE DE ORGÃOS E TECIDOS -->
						<div
							class="row"
							v-if="form.tipo_missao"
							v-show="
								form.tipo_missao.descricao ==
									'TRANSPORTE DE ÓRGÃOS E TECIDOS' ||
								form.tipo_missao.descricao == 'SAÚDE / SOCORRO'
							"
						>
							<!-- CORACAO -->
							<div class="col-xs-12 col-md-2 form-group">
								<label>{{ _traducao('global', 'coracao') }}:</label>
								<br />
								<button
									type="button"
									class="pass-btn-mais-btn btn-link text-center"
									@click.prevent="form.coracao += 1"
								>
									<i style="margin-top: 7px" class="fa fa-plus fa-fw"></i>
								</button>
								<button
									type="button"
									:disabled="form.coracao == 0"
									class="pass-btn-menos-btn btn-link text-center"
									@click.prevent="form.coracao -= 1"
								>
									<i style="margin-top: 8px" class="fa fa-minus fa-fw"></i>
								</button>
								<input
									type="text"
									:value="form.coracao"
									style="cursor: default; background: #fff"
									v-mask="'00'"
									disabled="disabled"
									class="form-control text-center input-sm"
								/>
							</div>

							<!-- RIM -->
							<div class="col-xs-12 col-md-2 form-group">
								<label>{{ _traducao('global', 'rim') }}:</label>
								<br />
								<button
									type="button"
									class="pass-btn-mais-btn btn-link text-center"
									@click.prevent="form.rim += 1"
								>
									<i style="margin-top: 7px" class="fa fa-plus fa-fw"></i>
								</button>
								<button
									type="button"
									:disabled="form.rim == 0"
									class="pass-btn-menos-btn btn-link text-center"
									@click.prevent="form.rim -= 1"
								>
									<i style="margin-top: 8px" class="fa fa-minus fa-fw"></i>
								</button>
								<input
									type="text"
									:value="form.rim"
									style="cursor: default; background: #fff"
									v-mask="'00'"
									disabled="disabled"
									class="form-control text-center input-sm"
								/>
							</div>

							<!-- FIGADO -->
							<div class="col-xs-12 col-md-2 form-group">
								<label>{{ _traducao('global', 'figado') }}:</label>
								<br />
								<button
									type="button"
									class="pass-btn-mais-btn btn-link text-center"
									@click.prevent="form.figado += 1"
								>
									<i style="margin-top: 7px" class="fa fa-plus fa-fw"></i>
								</button>
								<button
									type="button"
									:disabled="form.figado == 0"
									class="pass-btn-menos-btn btn-link text-center"
									@click.prevent="form.figado -= 1"
								>
									<i style="margin-top: 8px" class="fa fa-minus fa-fw"></i>
								</button>
								<input
									type="text"
									:value="form.figado"
									style="cursor: default; background: #fff"
									v-mask="'00'"
									disabled="disabled"
									class="form-control text-center input-sm"
								/>
							</div>

							<!-- CORNEA -->
							<div class="col-xs-12 col-md-2 form-group">
								<label>{{ _traducao('global', 'cornea') }}:</label>
								<br />
								<button
									type="button"
									class="pass-btn-mais-btn btn-link text-center"
									@click.prevent="form.cornea += 1"
								>
									<i style="margin-top: 7px" class="fa fa-plus fa-fw"></i>
								</button>
								<button
									type="button"
									:disabled="form.cornea == 0"
									class="pass-btn-menos-btn btn-link text-center"
									@click.prevent="form.cornea -= 1"
								>
									<i style="margin-top: 8px" class="fa fa-minus fa-fw"></i>
								</button>
								<input
									type="text"
									:value="form.cornea"
									style="cursor: default; background: #fff"
									v-mask="'00'"
									disabled="disabled"
									class="form-control text-center input-sm"
								/>
							</div>

							<!-- ESCLERO -->
							<div class="col-xs-12 col-md-2 form-group">
								<label>{{ _traducao('global', 'esclero') }}:</label>
								<br />
								<button
									type="button"
									class="pass-btn-mais-btn btn-link text-center"
									@click.prevent="form.esclero += 1"
								>
									<i style="margin-top: 7px" class="fa fa-plus fa-fw"></i>
								</button>
								<button
									type="button"
									:disabled="form.esclero == 0"
									class="pass-btn-menos-btn btn-link text-center"
									@click.prevent="form.esclero -= 1"
								>
									<i style="margin-top: 8px" class="fa fa-minus fa-fw"></i>
								</button>
								<input
									type="text"
									:value="form.esclero"
									style="cursor: default; background: #fff"
									v-mask="'00'"
									disabled="disabled"
									class="form-control text-center input-sm"
								/>
							</div>

							<!-- PANCREAS -->
							<div class="col-xs-12 col-md-2 form-group">
								<label>{{ _traducao('global', 'pancreas') }}:</label>
								<br />
								<button
									type="button"
									class="pass-btn-mais-btn btn-link text-center"
									@click.prevent="form.pancreas += 1"
								>
									<i style="margin-top: 7px" class="fa fa-plus fa-fw"></i>
								</button>
								<button
									type="button"
									:disabled="form.pancreas == 0"
									class="pass-btn-menos-btn btn-link text-center"
									@click.prevent="form.pancreas -= 1"
								>
									<i style="margin-top: 8px" class="fa fa-minus fa-fw"></i>
								</button>
								<input
									type="text"
									:value="form.pancreas"
									style="cursor: default; background: #fff"
									v-mask="'00'"
									disabled="disabled"
									class="form-control text-center input-sm"
								/>
							</div>

							<!-- BAÇO -->
							<div class="col-xs-12 col-md-2 form-group">
								<label>{{ _traducao('global', 'baco') }}:</label>
								<br />
								<button
									type="button"
									class="pass-btn-mais-btn btn-link text-center"
									@click.prevent="form.baco += 1"
								>
									<i style="margin-top: 7px" class="fa fa-plus fa-fw"></i>
								</button>
								<button
									type="button"
									:disabled="form.baco == 0"
									class="pass-btn-menos-btn btn-link text-center"
									@click.prevent="form.baco -= 1"
								>
									<i style="margin-top: 8px" class="fa fa-minus fa-fw"></i>
								</button>
								<input
									type="text"
									:value="form.baco"
									style="cursor: default; background: #fff"
									v-mask="'00'"
									disabled="disabled"
									class="form-control text-center input-sm"
								/>
							</div>
						</div>

						<!-- MEIO AMBIENTE, BUSCA E SALVAMENTO E COMBATE A INCÊNCIDO -->
						<div class="row">
							<!-- BASE ORIGEM -->
							<div
								class="col-xs-12 col-md-2 form-group"
								v-if="form.tipo_missao"
								v-show="
									form.tipo_missao.descricao ==
									'MEIO AMBIENTE (INCLUINDO COMBATE A INCÊNDIO FLORESTAL)'
								"
							>
								<label>{{ _traducao('global', 'baseDeOrigem') }}:</label>
								<br />
								<select
									v-model="form.base_origem"
									class="form-control input-sm"
								>
									<option value="">
										{{ _traducao('global', 'escolha').toUpperCase() }}
									</option>
									<option
										v-for="it in basesOperacao"
										:value="it.descricao"
										:key="it.descricao"
									>
										{{ it.descricao }}
									</option>
								</select>
							</div>

							<!-- BRIGADISTAS -->
							<div
								class="col-xs-12 col-md-2 form-group"
								v-if="form.tipo_missao"
								v-show="
									form.tipo_missao.descricao ==
									'MEIO AMBIENTE (INCLUINDO COMBATE A INCÊNDIO FLORESTAL)'
								"
							>
								<label>{{ _traducao('global', 'brigadistas') }}:</label>
								<br />
								<button
									type="button"
									class="pass-btn-mais-btn btn-link text-center"
									@click.prevent="form.brigadista += 1"
								>
									<i style="margin-top: 7px" class="fa fa-plus fa-fw"></i>
								</button>
								<button
									type="button"
									:disabled="form.brigadista == 0"
									class="pass-btn-menos-btn btn-link text-center"
									@click.prevent="form.brigadista -= 1"
								>
									<i style="margin-top: 8px" class="fa fa-minus fa-fw"></i>
								</button>
								<input
									type="text"
									:value="form.brigadista"
									style="cursor: default; background: #fff"
									v-mask="'00'"
									disabled="disabled"
									class="form-control text-center input-sm"
								/>
							</div>

							<div
								class="col-xs-12 col-md-2 form-group"
								v-if="form.tipo_missao"
								v-show="
									form.tipo_missao.descricao ==
									'MEIO AMBIENTE (INCLUINDO COMBATE A INCÊNDIO FLORESTAL)'
								"
								:class="{'has-error': erro.existe_unidade_conservacao != ''}"
							>
								<label>* Unidade de Conservação?</label>
								<br />
								<div class="btn-group print-button-group" role="group">
									<button
										type="button"
										@click="
											form.existe_unidade_conservacao = '1'
											erro.existe_unidade_conservacao = ''
										"
										:class="{
											'btn-info': form.existe_unidade_conservacao == '1'
										}"
										class="btn btn-default btn-sm"
									>
										{{ _traducao('global', 'sim') }}
									</button>
									<button
										type="button"
										@click="
											form.existe_unidade_conservacao = '0'
											erro.existe_unidade_conservacao = ''
										"
										:class="{
											'btn-info': form.existe_unidade_conservacao == '0'
										}"
										class="btn btn-default btn-sm"
									>
										{{ _traducao('global', 'nao') }}
									</button>
								</div>
								<p
									class="help-block"
									v-if="erro.existe_unidade_conservacao != ''"
								>
									{{ erro.existe_unidade_conservacao }}
								</p>
							</div>

							<!-- UNIDADE DE CONSERVAÇÃO -->
							<div
								class="col-xs-12 col-md-6 form-group"
								v-if="form.tipo_missao"
								v-show="
									form.tipo_missao.descricao ==
									'MEIO AMBIENTE (INCLUINDO COMBATE A INCÊNDIO FLORESTAL)'
								"
							>
								<div
									class="row"
									v-for="un in form.unidade_conservacao"
									:key="un.id"
								>
									<div
										v-if="form.existe_unidade_conservacao == '1'"
										class="col-xs-12 form-group"
										:class="{'has-error': un.erro != ''}"
									>
										<label
											>*
											{{ _traducao('global', 'unidadeDeConservacao') }}:</label
										>
										<a
											href="#"
											class="pull-right"
											@click.prevent="form.unidade_conservacao.splice(idxUn, 1)"
											v-if="idxUn > 0"
											style="color: red; font-size: 12px"
										>
											<i class="fa fa-fw fa-trash-o"></i
											>{{ _traducao('global', 'remover').toUpperCase() }}
										</a>

										<v-select
											v-model="un.obj"
											class="form-control input-sm"
											:options="unidadesConservacao"
											label="sigla"
										></v-select>

										<p class="help-block" v-if="un.erro != ''">{{ un.erro }}</p>
									</div>
								</div>

								<div class="row" v-if="form.existe_unidade_conservacao == '1'">
									<div class="col-xs-12" style="margin-top: 10px">
										<button
											class="btn btn-info btn-sm"
											type="button"
											@click="
												form.unidade_conservacao.push({obj: '', erro: ''})
											"
										>
											<i class="fa fa-fw fa-plus"></i>ADICIONAR UNIDADE
										</button>
									</div>
								</div>
							</div>

							<!-- BUSCA E SALVAMENTO -->
							<div
								class="col-xs-12 col-md-2 form-group"
								v-if="form.tipo_missao"
								v-show="form.tipo_missao.descricao == 'BUSCA E SALVAMENTO'"
							>
								<label>{{ _traducao('global', 'socorridos') }}:</label>
								<br />
								<button
									type="button"
									class="pass-btn-mais-btn btn-link text-center"
									@click.prevent="form.socorrido += 1"
								>
									<i style="margin-top: 7px" class="fa fa-plus fa-fw"></i>
								</button>
								<button
									type="button"
									:disabled="form.socorrido == 0"
									class="pass-btn-menos-btn btn-link text-center"
									@click.prevent="form.socorrido -= 1"
								>
									<i style="margin-top: 8px" class="fa fa-minus fa-fw"></i>
								</button>
								<input
									type="text"
									:value="form.socorrido"
									style="cursor: default; background: #fff"
									v-mask="'00'"
									disabled="disabled"
									class="form-control text-center input-sm"
								/>
							</div>
						</div>

						<hr />

						<!-- CLASSIFICAÇÃO E SUBCLASSIFICAÇÃO -->
						<div v-if="_idCliente != 41 && exibeClassificacao">
							<div class="row">
								<div
									class="col-xs-12 form-group"
									:class="{'has-error': erro.classificacao != ''}"
								>
									<label>* {{ _traducao('global', 'classificacao') }}:</label>
									<v-select
										v-model="form.classificacao"
										class="form-control input-sm"
										:options="classificacaoAux"
										label="descricao"
										@search:blur="limpaCamposSubDepoisDeSelecionar()"
										@change="filtraSubclassificacao()"
									></v-select>
									<p class="help-block" v-if="erro.classificacao != ''">
										{{ erro.classificacao }}
									</p>
								</div>
								<div
									class="col-xs-12 form-group"
									:class="{'has-error': erro.subclassificacao != ''}"
								>
									<label>{{ _traducao('global', 'subclassificacao') }}:</label>
									<v-select
										v-model="form.subclassificacao"
										class="form-control input-sm"
										:options="subclassificacoesAux"
										label="descricao"
									></v-select>
								</div>
							</div>
							<hr />
						</div>

						<!-- CONTEXTO OPERATIVO -->
						<div v-if="exibeContextoOperativo">
							<div class="row">
								<div
									class="col-xs-12 form-group"
									:class="{'has-error': erro.houve_contexto != ''}"
								>
									<label
										>* {{ _traducao('global', 'haContextoOperativo') }}</label
									>
									<br />
									<div class="btn-group print-button-group" role="group">
										<button
											type="button"
											@click="
												form.houve_contexto = '1'
												erro.houve_contexto = ''
											"
											:class="{'btn-info': form.houve_contexto == '1'}"
											class="btn btn-default btn-sm"
										>
											{{ _traducao('global', 'sim') }}
										</button>
										<button
											type="button"
											@click="
												form.houve_contexto = '0'
												erro.houve_contexto = ''
											"
											:class="{'btn-info': form.houve_contexto == '0'}"
											class="btn btn-default btn-sm"
										>
											{{ _traducao('global', 'nao') }}
										</button>
									</div>
									<p class="help-block" v-if="erro.houve_contexto != ''">
										{{ erro.houve_contexto }}
									</p>
								</div>
							</div>
							<div class="row" v-if="form.houve_contexto == '1'">
								<div
									class="col-xs-12 col-md-6 form-group"
									:class="{'has-error': erro.contexto_operativo != ''}"
								>
									<label
										>* {{ _traducao('global', 'contextoOperativo') }}</label
									>
									<v-select
										v-model="form.contexto_operativo"
										class="form-control input-sm"
										:options="contextos"
										label="descricao"
									></v-select>
									<p class="help-block" v-if="erro.contexto_operativo != ''">
										{{ erro.contexto_operativo }}
									</p>
								</div>
							</div>
							<hr />
						</div>

						<!-- ORGÃOS APOIADOS E UNIDADES -->
						<div class="form-group">
							<label v-show="form.orgao.length == 0"
								>* {{ centrodeCusto }}:</label
							>
							<div v-for="(itOrgao, idxOrgao) in form.orgao" :key="itOrgao.id">
								<div class="row">
									<div
										class="col-xs-2 col-md-2 form-group"
										:class="{'has-error': itOrgao.erroTempoVoo != ''}"
										v-if="_idCliente == 14"
									>
										<label>* {{ _traducao('global', 'tempoDeVoo') }}:</label>
										<money
											type="text"
											v-model="itOrgao.tempo_voo"
											v-bind="_vpercem(2)"
											class="input-sm form-control"
										></money>
										<p class="help-block" v-if="itOrgao.erroTempoVoo != ''">
											{{ itOrgao.erroTempoVoo }}
										</p>
									</div>

									<!-- orgao -->
									<div
										class="col-xs-6 col-md-6 form-group"
										:class="{'has-error': itOrgao.erroOrgao != ''}"
									>
										<label>* {{ centrodeCusto }}:</label>
										<a
											href="#"
											class="pull-right btn-remover-orgao"
											@click.prevent="form.orgao.splice(idxOrgao, 1)"
											type="button"
										>
											<i class="fa fa-trash fa-fw"></i
											>{{ _traducao('global', 'remover') }}
										</a>

										<form>
											<div :class="idxOrgao == 0 ? 'input-group' : ''">
												<v-select
													v-model="form.orgao[idxOrgao].orgao"
													class="form-control"
													:options="orgaos"
													label="sigla"
												></v-select>
												<span class="input-group-btn" v-if="idxOrgao == 0">
													<button
														class="btn btn-info btn-sm btn-md"
														@click="abreModalOap"
													>
														<i class="fa fa-plus fa-fw"></i>
													</button>
												</span>
											</div>
										</form>

										<p class="help-block" v-if="itOrgao.erroOrgao != ''">
											{{ itOrgao.erroOrgao }}
										</p>
									</div>

									<!-- unidades -->
									<div
										class="col-xs-6 col-md-6 form-group"
										v-if="form.orgao[idxOrgao].orgao != ''"
									>
										<div v-if="form.orgao[idxOrgao].orgao.unidade.length > 0">
											<div
												class="form-group"
												:class="{'has-error': unid.erroUnidade != ''}"
												v-for="(unid, indexUnid) in form.orgao[idxOrgao]
													.unidade"
												:key="unid.id"
											>
												<label>{{ _traducao('global', 'unidade') }}:</label>
												<a
													href="#"
													class="pull-right btn-remover-orgao"
													@click.prevent="
														form.orgao[idxOrgao].unidade.splice(indexUnid, 1)
													"
													type="button"
												>
													<i class="fa fa-trash fa-fw"></i
													>{{ _traducao('global', 'remover') }}
												</a>
												<div :style="{'z-index': 1000 - indexUnid}">
													<v-select
														v-show="!loadUnidade"
														v-model="
															form.orgao[idxOrgao].unidade[indexUnid].unidade
														"
														class="form-control input-sm"
														:options="form.orgao[idxOrgao].orgao.unidade"
														label="descricao"
													></v-select>
												</div>
												<p class="help-block" v-if="unid.erroUnidade != ''">
													{{ unid.erroUnidade }}
												</p>
											</div>

											<div>
												<span v-if="form.orgao[idxOrgao].unidade.length == 0">
													<label style="color: #f9f9f9"
														>{{ _traducao('global', 'unidades') }}:</label
													>
													<br />
												</span>
												<button
													@click="
														form.orgao[idxOrgao].unidade.push({
															unidade: '',
															erroUnidade: ''
														})
													"
													class="btn btn-info btn-sm"
													type="button"
												>
													<i class="fa fa-plus fa-fw"></i
													>{{
														_traducao(
															'global',
															'adicionarUnidade'
														).toUpperCase()
													}}
												</button>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="row" :class="{'has-error': erro.orgao}">
								<div class="col-xs-12">
									<button
										class="btn btn-info btn-sm"
										type="button"
										@click="clickAddOrgao"
									>
										<i class="fa fa-plus fa-fw"></i
										>{{ centrodeCusto.toUpperCase() }}
									</button>

									<p class="help-block" v-if="erro.orgao != ''">
										{{ erro.orgao }}
									</p>
								</div>
							</div>
						</div>
					</div>

					<!-- OBSERVACAO -->
					<div>
						<flCabecalhoForm
							class="print-titulo-form-20"
							:texto="_traducao('global', 'observacao')"
						/>

						<div class="row">
							<div class="col-xs-12">
								<textarea
									v-model="form.observacao"
									class="form-control input-sm"
									rows="5"
								></textarea>
							</div>
						</div>
					</div>

					<!-- ANEXOS -->
					<div
						v-show="
							_idCliente == 62 &&
							(form.finalizar_despacho == '1' || form.anexos.length > 0)
						"
					>
						<flCabecalhoForm class="print-titulo-form-20" texto="Anexos" />
						<div class="row">
							<div class="col-xs-12 col-sm-6">
								<flUploadFile
									name="anexosDiario"
									:excluir-u-r-l="true"
									:excluir-adicionados="true"
									:excluir-por-id="true"
									:habilita-excluir="true"
									:url-excluir="urlExcluirAnexo"
									ref="anexosDiario"
									@upload-file="(files) => uploadFilesAnexos(files)"
									:url="urlEnvio"
									ext="jpg|jpeg|png|pdf|doc|docx|xls|xlsx"
								></flUploadFile>
							</div>
							<div v-if="_isMobile" class="col-xs-12 col-sm-6">
								<ButtonNew size="lg" @click="openCameraAnexos"
									>Tirar Foto</ButtonNew
								>
							</div>
						</div>
					</div>

					<!-- LISTA SOLICITACAO DE EDICAO -->
					<div v-if="solicitacaoEdicao.length > 0 && !editar">
						<flCabecalhoForm
							class="print-titulo-form-20"
							:texto="'Solicitações de Edição'"
						/>
						<fl-lista-solicitacoes-db :lista="solicitacaoEdicao" />
					</div>
					<hr />
					<!-- BTN SALVAR -->
					<div
						class="row"
						v-if="editar"
						style="margin-top: 20px; margin-bottom: 30px"
					>
						<div class="col-xs-12">
							<AlertDanger v-if="erro.diurnoNortuno != ''"
								>{{ erro.diurnoNortuno }}
							</AlertDanger>
							<AlertDanger v-if="erro.horimetroApu != ''"
								>{{ erro.horimetroApu }}
							</AlertDanger>
							<AlertDanger v-if="semAnexos">
								Gentileza anexar pelo menos um arquivo para finalizar.
							</AlertDanger>
						</div>
						<div class="col-xs-12 text-info form-group" v-if="assinar">
							<span v-if="!assinarESalvar">
								<i class="fa fa-fw fa-info-circle"></i>
								{{ _traducao('global', 'nenhumaAlteracao') }}.
							</span>
							<span v-if="assinarESalvar">
								<i class="fa fa-fw fa-info-circle"></i>
								{{ _traducao('global', 'todasAlteracoesSalvas') }}.
							</span>
						</div>
						<div class="col-md-3 col-xs-12 form-group">
							<button
								class="btn btn-block"
								:class="assinarESalvar ? 'btn-danger' : 'btn-primary'"
								v-if="assinar"
								@click="assinarESalvar = !assinarESalvar"
								type="button"
							>
								<span v-if="!assinarESalvar">
									<i class="fa fa-fw fa-pencil"></i>
									{{ _traducao('global', 'editarDiario').toUpperCase() }}
								</span>
								<span v-if="assinarESalvar">
									<i class="fa fa-fw fa-times"></i>
									{{ _traducao('global', 'cancelarDiario').toUpperCase() }}
								</span>
							</button>
						</div>
						<div class="col-md-5"></div>
						<div
							class="col-xs-12 col-md-4"
							:class="{
								'has-error':
									erro.horimetroApu != '' ||
									erro.diurnoNortuno != '' ||
									(erro.ifrVfr != '' && validaVfr == true) ||
									semAnexos
							}"
						>
							<ButtonConfirm
								size="lg"
								class="btn-block pull-left"
								v-if="assinar"
								@click="clickExibeModalSalvar()"
								:disabled="validaDisabledSalvar"
							>
								{{ _traducao('global', 'assinar') }}
							</ButtonConfirm>

							<ButtonConfirm
								size="lg"
								class="btn-block pull-right"
								v-if="!assinar"
								@click="clickExibeModalSalvar()"
								:disabled="validaDisabledSalvar"
							>
								{{ _traducao('global', 'salvar') }}
							</ButtonConfirm>
						</div>
					</div>

					<div
						class="row"
						v-if="!editar && !preencher"
						style="margin-top: 20px; margin-bottom: 30px"
					>
						<div class="col-xs-12">
							<AlertInfo
								>Após a assinatura do piloto, tem um prazo para edição de 15
								dias, esse prazo se encerrou, para editar, abra uma
								solicitação.</AlertInfo
							>
						</div>
						<div class="col-md-8"></div>
						<div
							class="col-xs-12 col-md-4"
							:class="{'has-error': erro.diurnoNortuno != ''}"
						>
							<ButtonLockOpen
								size="lg"
								@click="clickSolicitarEdicao()"
								class="btn-block pull-right"
								>Solicitar edição</ButtonLockOpen
							>
						</div>
					</div>

					<div
						v-if="!editar && preencher"
						style="margin-top: 20px; margin-bottom: 30px"
						:class="{
							'has-error': erro.diurnoNortuno != ''
						}"
					>
						<AlertDanger v-if="erro.horimetroApu != ''"
							>{{ erro.horimetroApu }}
						</AlertDanger>
						<AlertDanger v-if="erro.diurnoNortuno != ''"
							>{{ erro.diurnoNortuno }}
						</AlertDanger>
						<AlertDanger v-if="semAnexos">
							Gentileza anexar pelo menos um arquivo para finalizar.
						</AlertDanger>
						<div class="row">
							<div class="col-md-8"></div>
							<div class="col-md-4 col-xs-12">
								<ButtonConfirm
									size="lg"
									class="pull-right btn-block"
									@click="clickExibeModalSalvar()"
									:disabled="validaDisabledSalvar"
									>{{ _traducao('global', 'finalizar') }}</ButtonConfirm
								>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- PRINT DA SOLICITACAO -->
		<div class="print">
			<div class="col-xs-12">
				<flPrintDiario
					:id-motor-esquerdo="id_motor_esquerdo"
					:id-motor-direito="id_motor_direito"
					name="diario"
					ref="printDiario"
					:cabecalho="false"
					:voo="false"
				/>
			</div>
		</div>

		<div v-if="visualizar">
			<div class="container-fluid no-print">
				<!-- cabecalho -->
				<div class="fl-cabecalho" v-show="cabecalho">
					<div class="row">
						<div class="col-md-4 col-xs-12">
							<i class="icon icon-diario_bordo"></i>
							<h3>{{ _traducao('global', 'diarioDeBordo').toUpperCase() }}</h3>
							<h4>
								{{ _traducao('global', 'pilotoECopiloto').toUpperCase() }}
							</h4>
						</div>

						<div class="col-md-4 col-xs-12">
							<i class="icon icon-vizualizar icon-sub"></i>
							<h3>{{ _traducao('global', 'visualizar').toUpperCase() }}</h3>
							<h4>{{ _traducao('global', 'diarioDeBordo').toUpperCase() }}</h4>
						</div>

						<div class="col-md-4 col-xs-12">
							<button
								@click="voltaLista()"
								class="btn btn-default pull-right btn-lg"
								:title="_traducao('global', 'voltar')"
							>
								<i
									class="icon-left"
									style="font-size: 18px"
									aria-hidden="true"
								></i>
							</button>

							<button
								v-if="form.nome_arquivo == ''"
								class="btn btn-default pull-right btn-lg"
								:title="_traducao('global', 'imprimir')"
								style="margin-right: 20px"
								@click="clickPrintVisualizar()"
							>
								<i class="icon-imprimir" style="font-size: 18px"></i>
							</button>

							<a
								v-if="form.nome_arquivo != ''"
								:href="form.nome_arquivo"
								target="_blank"
								class="btn btn-default pull-right btn-lg"
								style="margin-right: 20px"
							>
								<i class="icon-imprimir" style="font-size: 18px"></i>
							</a>
						</div>
					</div>
				</div>
			</div>

			<!-- exibe o html caso não tenha pdf ainda -->
			<div class="col-xs-12">
				<ul
					v-if="form.nome_arquivo != ''"
					class="nav nav-tabs no-print"
					style="margin-top: 10px"
					role="tablist"
				>
					<li :class="{active: tab == 'SISTEMA'}">
						<a href="#" @click.prevent="tab = 'SISTEMA'">{{
							_traducao('global', 'sistema').toUpperCase()
						}}</a>
					</li>
					<li :class="{active: tab == 'PDF'}">
						<a href="#" @click.prevent="tab = 'PDF'">PDF</a>
					</li>
				</ul>
				<!-- <a :href="form.nome_arquivo" download="iPhone User's Guide.PDF">click me</a> -->
				<flPrintDiario
					:id-motor-esquerdo="id_motor_esquerdo"
					:id-motor-direito="id_motor_direito"
					name="visualizar"
					:exibe-historico-visualizar="exibeHistoricoVisualizar"
					v-show="tab == 'SISTEMA'"
					ref="printVisualizar"
					:cabecalho="false"
					:voo="voo"
					:is-visualizar-diario-operador-ou-piloto="
						isVisualizarDiarioOperadorOuPiloto
					"
					:fuso-horario="fusoHorario"
				/>

				<!-- exibe o pdf caso já tenha -->
				<embed
					type="application/pdf"
					:src="form.nome_arquivo"
					ref="pdfDocument"
					v-show="tab == 'PDF'"
					width="100%"
					:height="_height - 130"
				/>
			</div>
		</div>

		<!-- MODAL INCISOS RESOLUCAO 457, 457 -->
		<modal ref="modalDiario">
			<button
				type="button"
				class="close"
				@click="$refs.modalDiario.modalHide()"
			>
				<span aria-hidden="true">&times;</span>
			</button>

			<h4 class="modal-title" v-if="tipoDBModal == 'I'">
				INCISOS XIII A XVII DO ART. 4º DA RESOLUÇÃO 457
			</h4>

			<h4 class="modal-title" v-if="tipoDBModal == 'C'">
				{{ _traducao('global', 'diarioDeBordo').toUpperCase() }}
			</h4>

			<hr style="margin-top: 6px" />
			<flPrintDiario
				:id-motor-esquerdo="id_motor_esquerdo"
				:id-motor-direito="id_motor_direito"
				name="diario"
				ref="diarioModal"
				:cabecalho="false"
				:voo="false"
				:fuso-horario="fusoHorario"
			/>

			<div class="row text-center" v-if="tipoDBModal == 'I'">
				<div class="col-xs-12">
					<button
						class="btn btn-info"
						@click="clickExibeModalDiario('C', true)"
					>
						VER DIÁRIO DE BORDO COMPLETO
					</button>
				</div>
			</div>

			<div class="row text-center" v-if="tipoDBModal == 'C'">
				<div class="col-xs-12">
					<button
						class="btn btn-info"
						@click="clickExibeModalDiario('I', true)"
					>
						VER INCISOS XIII A XVII DO ART. 4º DA RESOLUÇÃO 457
					</button>
				</div>
			</div>
		</modal>

		<!-- MODAL COM A ESCOLA DA AERONAVE A SER SUBISTITIDA -->
		<modal ref="modalAero" @modal-fechou="() => carregaDadosAero()">
			<div style="min-height: 400px">
				<button
					type="button"
					class="close"
					@click="$refs.modalAero.modalHide()"
				>
					<span aria-hidden="true">&times;</span>
				</button>
				<h4 class="modal-title">
					{{ _traducao('global', 'selecioneUmaAeronave').toUpperCase() }}
				</h4>

				<hr style="margin-top: 6px" />

				<div class="row">
					<div class="col-md-1 col-xs-12 text-info">
						<i
							class="fa fa-fw fa-info-circle fa-3x"
							style="margin-top: 18px"
						></i>
					</div>
					<div class="col-md-10 col-xs-12 form-group">
						<h4 class="text-info" style="line-height: 30px">
							{{ _traducao('global', 'naoEncontramosSuaAero') }}
						</h4>
					</div>
				</div>

				<div class="row">
					<div class="col-xs-12">
						<div class="table-responsive">
							<table class="table table-siga table-hover">
								<thead>
									<tr>
										<th>{{ _traducao('cadAeronave', 'prefixo') }}</th>
										<th>{{ _traducao('cadAeronave', 'codinome') }}</th>
										<th>{{ _traducao('cadAeronave', 'tipo') }}</th>
										<th>{{ _traducao('cadAeronave', 'modelo') }}</th>
									</tr>
								</thead>
								<tbody v-if="aerosImport.length > 0">
									<tr
										style="cursor: pointer"
										class="table-hover-tr"
										@click="clickSetaAero(item)"
										v-for="item in aerosImport"
										:key="item.id"
									>
										<td>{{ item._aero.prefixo }}</td>
										<td>{{ item._aero.codinome }}</td>
										<td>{{ item._aero.modelo }}</td>
										<td>
											<span v-show="item._aero.tipo == 'A'">{{
												_traducao('cadAeronave', 'aviao')
											}}</span>
											<span v-show="item._aero.tipo == 'H'">{{
												_traducao('cadAeronave', 'helicoptero')
											}}</span>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</div>
		</modal>

		<!-- MODAL PARA ESCOLHER O PASSAGEIRO -->
		<modal name="modal-ordem-escolha-passageiros">
			<div>
				<button
					type="button"
					class="close"
					@click="_escondeModal('modal-ordem-escolha-passageiros')"
				>
					<span aria-hidden="true">&times;</span>
				</button>
				<h4 class="modal-title" v-if="tripulacaoTecnica == '1'">
					{{
						_traducao('global', 'selecioneOsTripulantesTrecho').toUpperCase()
					}}
				</h4>
				<h4 class="modal-title" v-else>
					{{
						_traducao('global', 'selecioneOsPassageirosTrecho').toUpperCase()
					}}
				</h4>

				<hr style="margin-top: 6px" />

				<div class="row">
					<div class="col-xs-12">
						<div class="table-responsive">
							<table class="table table-siga table-hover">
								<thead>
									<tr>
										<th
											v-if="tripulacaoTecnica == '1'"
											colspan="10"
											style="background: #eee"
											class="text-center"
										>
											TRIPULANTES TÉCNICOS
										</th>
										<th
											v-else
											colspan="10"
											style="background: #eee"
											class="text-center"
										>
											PASSAGEIROS
										</th>
									</tr>
									<tr>
										<th>{{ _traducao('global', 'nome') }}</th>
										<th>{{ _traducao('global', 'orgao') }}</th>
										<th>{{ _traducao('menuRGordemmissao', 'menuOMcargo') }}</th>
										<th v-if="exibeOutro">{{ nomeOutroDocumento }}</th>
										<th>{{ _traducao('menuMatricula', 'cpf') }}</th>
										<th>{{ _traducao('global', 'telefone') }}</th>
									</tr>
								</thead>
								<tbody>
									<tr
										class="table-hover-tr"
										style="cursor: pointer"
										@click="clickSelecionaPassageiro(index)"
										:class="{'bk-success': item.selecionado}"
										v-for="(item, index) in passageirosSelecao"
										:key="item.id"
									>
										<td>{{ item.nome | na }}</td>
										<td>{{ item.sigla_orgao | na }}</td>
										<td>{{ item.cargo | na }}</td>
										<td v-if="exibeOutro">{{ item.outro | na }}</td>
										<td>{{ item.cpf | na }}</td>
										<td>
											{{ item.telefone | na
											}}<i
												v-if="item.selecionado"
												class="text-success pull-right fa fa-fw fa-check-circle"
											></i>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>

				<hr />

				<div class="row">
					<div class="col-xs-12">
						<button
							class="btn btn-success pull-right"
							@click="exibeOrgaoPassageiro()"
						>
							<i class="fa fa-fw fa-check"></i> OK
						</button>
					</div>
				</div>
			</div>
		</modal>

		<modal name="modal-escolha-trecho">
			<div>
				<button
					type="button"
					class="close"
					@click="_escondeModal('modal-escolha-trecho')"
				>
					<span aria-hidden="true">&times;</span>
				</button>
				<h4 class="modal-title">
					{{ _traducao('global', 'selecioneTrecho').toUpperCase() }}
				</h4>

				<hr style="margin-top: 6px" />

				<div class="row">
					<div class="col-xs-12">
						<div class="table-responsive">
							<table class="table table-siga table-hover">
								<thead>
									<tr>
										<th
											colspan="10"
											style="background: #eee"
											class="text-center"
										>
											Trechos
										</th>
									</tr>
									<tr>
										<th></th>
										<th>Estado Origem</th>
										<th>Cidade Origem</th>
										<th>Designativo Origem</th>
										<th>Designativo Destino</th>
										<th>Cidade Destino</th>
										<th>Estado Destino</th>
									</tr>
								</thead>
								<tbody>
									<tr
										class="table-hover-tr"
										style="cursor: pointer"
										@click="clickSelecionarTrechoUnico(index)"
										:class="{'bk-success': item.selecionado}"
										v-for="(item, index) in trechosModal"
										:key="item.id"
									>
										<td>
											<i
												v-if="item.selecionado"
												class="text-success pull-right fa fa-fw fa-check-circle"
											></i>
										</td>
										<td>{{ item.nome_cidade_partida | na }}</td>
										<td>{{ item.nome_estado_partida | na }}</td>
										<td>{{ item.designativo_partida | na }}</td>
										<td>{{ item.designativo_destino | na }}</td>
										<td>{{ item.nome_cidade_destino | na }}</td>
										<td>{{ item.nome_estado_destino | na }}</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>

				<hr />

				<div class="row">
					<div class="col-xs-12">
						<button
							class="btn btn-success pull-right"
							@click="preencherDesignativosPorTrecho()"
						>
							<i class="fa fa-fw fa-check"></i> OK
						</button>
					</div>
				</div>
			</div>
		</modal>

		<!-- MODAL PARA ESCOLHER AS CARGAS -->
		<modal name="modal-ordem-escolha-cargas">
			<div>
				<button
					type="button"
					class="close"
					@click="_escondeModal('modal-ordem-escolha-cargas')"
				>
					<span aria-hidden="true">&times;</span>
				</button>
				<h4 class="modal-title">
					{{
						_traducao('global', 'selecioneAsCargasTransportadas').toUpperCase()
					}}
				</h4>

				<hr style="margin-top: 6px" />

				<div class="row">
					<div class="col-xs-12">
						<div class="table-responsive">
							<table class="table table-siga table-hover">
								<thead>
									<tr>
										<th
											colspan="10"
											style="background: #eee"
											class="text-center"
										>
											CARGAS
										</th>
									</tr>
									<tr>
										<th>{{ _traducao('global', 'tipo') }}</th>
										<th>{{ _traducao('global', 'descricao') }}</th>
										<th>{{ _traducao('global', 'peso') }}</th>
									</tr>
								</thead>
								<tbody>
									<tr
										class="table-hover-tr"
										style="cursor: pointer"
										@click="clickSelecionaCarga(idx)"
										:class="{'bk-success': carga.selecionado}"
										v-for="(carga, idx) in cargas"
										:key="carga.id"
									>
										<td>{{ carga.descricao_tipo_carga | na }}</td>
										<td>{{ carga.descricao | na }}</td>
										<td>
											{{ carga.peso | na
											}}<i
												v-if="carga.selecionado"
												class="text-success pull-right fa fa-fw fa-check-circle"
											></i>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>

				<hr />

				<div class="row">
					<div class="col-xs-12">
						<button
							class="btn btn-success pull-right"
							@click="clickImportaCargas()"
						>
							<i class="fa fa-fw fa-check"></i> OK
						</button>
					</div>
				</div>
			</div>
		</modal>

		<flOrigemVoo
			ref="origemVoo"
			@selecionou-ordem="(data) => ordemSelecionada(data)"
			@selecionou-despacho="(data) => despachoSelecionado(data)"
		/>

		<!-- MODAL COM A VOLTA PRA LISTA -->
		<modal name="modal-ordem-tempo-expirado">
			<h4 class="modal-title">
				{{ _traducao('global', 'tempoDePreenchimento').toUpperCase() }}
			</h4>

			<hr style="margin-top: 6px" />

			<div class="row">
				<div class="col-xs-12 text-center">
					<h3>
						{{ _traducao('global', 'desejaContinuarAPrrencher') }}
					</h3>
				</div>
			</div>

			<hr style="margin-top: 6px" />

			<div class="row">
				<div class="col-xs-6">
					<button
						class="btn pull-left btn-default"
						type="button"
						@click="voltaLista()"
					>
						<i class="fa fa-arrow-left fa-fw" aria-hidden="true"></i
						>{{ _traducao('global', 'voltar') }}
					</button>
				</div>
				<div class="col-xs-6">
					<button
						class="btn pull-right btn-success"
						type="button"
						@click="clickContinuaPreenchendo()"
					>
						<i class="fa fa-fw fa-check"></i
						>{{ _traducao('global', 'continuar') }}
					</button>
				</div>
			</div>
		</modal>

		<!-- MODAL PARA SALVAR MODIFICACOES -->
		<modal ref="modalSalvarModificacoes">
			<h4 class="modal-title">
				{{ _traducao('global', 'editarTrecho').toUpperCase() }}
			</h4>

			<hr style="margin-top: 6px" />

			<div class="row">
				<h3 class="text-center">
					<i class="fa fa-fw fa-info-circle"></i>
					{{ _traducao('global', 'desejaAtualizarTrecho') }} <BR />
					<strong>{{ trecho.numero_diario }}</strong>
				</h3>
			</div>

			<div class="row" style="margin-top: 10px">
				<div class="col-xs-6 text-center">
					<p style="margin-bottom: 0px">
						<strong>{{ label_acionamento.toUpperCase() }}</strong>
					</p>
					<p>{{ form.acionamento }}</p>
				</div>
				<div class="col-xs-6 text-center">
					<p style="margin-bottom: 0px">
						<strong>{{
							_traducao('global', 'decolagem').toUpperCase()
						}}</strong>
					</p>
					<p>{{ form.decolagem }}</p>
				</div>
			</div>
			<div class="row">
				<div class="col-xs-6 text-center">
					<p style="margin-bottom: 0px">
						<strong>{{ _traducao('global', 'pouso').toUpperCase() }}</strong>
					</p>
					<p>{{ form.pouso }}</p>
				</div>
				<div class="col-xs-6 text-center">
					<p style="margin-bottom: 0px">
						<strong>{{ _traducao('global', 'corteVoo').toUpperCase() }}</strong>
					</p>
					<p>{{ form.corte }}</p>
				</div>
			</div>

			<hr />

			<div class="row">
				<div class="col-xs-12 text-center">
					<p class="text-info">
						<strong>{{
							_traducao('global', 'horimetro').toUpperCase()
						}}</strong>
					</p>
				</div>
				<div class="col-xs-6 text-center">
					<p style="margin-bottom: 0px">
						<strong>{{ _traducao('global', 'inicial').toUpperCase() }}</strong>
					</p>
					<p>{{ form.horimetro_inicial | horimetro }}</p>
				</div>
				<div class="col-xs-6 text-center">
					<p style="margin-bottom: 0px">
						<strong>{{ _traducao('global', 'final').toUpperCase() }}</strong>
					</p>
					<p>{{ form.horimetro_final | horimetro }}</p>
				</div>
			</div>

			<div class="row">
				<div class="col-xs-12">
					<button
						class="btn btn-success pull-right"
						type="button"
						@click="clickSalvar()"
					>
						<i class="fa fa-fw fa-check"></i>
						{{ _traducao('global', 'atualizar').toUpperCase() }}
					</button>
				</div>
			</div>
		</modal>

		<!-- MODAL PARA CONFIRMAR A SALVACAO -->
		<modal
			ref="modalConfirmacao"
			@modal-fechou="() => (assinarESalvar ? modalCarregaAssinatura() : '')"
		>
			<button
				type="button"
				class="close"
				@click="
					revisar = true
					$refs.modalConfirmacao.modalHide()
				"
			>
				<span aria-hidden="true">&times;</span>
			</button>

			<h4 class="modal-title" v-if="!assinar && !editar">
				{{ _traducao('global', 'finalizarTracho').toUpperCase() }}
			</h4>
			<h4 class="modal-title" v-if="!assinar && editar">
				{{ _traducao('global', 'editarTrecho').toUpperCase() }}
			</h4>
			<h4 class="modal-title" v-if="assinar">
				{{ _traducao('global', 'assinarTrecho').toUpperCase() }}
			</h4>

			<hr style="margin-top: 6px" />

			<div class="row">
				<div class="col-xs-12 text-center text-info">
					<h3 v-if="!assinar && !editar">
						<i class="fa fa-fw fa-info-circle"></i>
						{{ _traducao('global', 'desejaFinalizarTrecho') }}<BR />
						<strong>{{ trecho.numero_diario }}</strong>
					</h3>
					<h3 v-if="!assinar && editar">
						<i class="fa fa-fw fa-info-circle"></i>
						{{ _traducao('global', 'desejaAtualizarTrecho') }} <BR />
						<strong>{{ trecho.numero_diario }}</strong>
					</h3>
					<h3 v-if="assinar">
						<i class="fa fa-fw fa-info-circle"></i>
						{{ _traducao('global', 'desejaAssinarEsseTrecho') }}?<BR />
						<strong>{{ trecho.numero_diario }}</strong>
					</h3>
				</div>
			</div>

			<div class="row" style="margin-top: 10px">
				<div class="col-xs-6 text-center">
					<p style="margin-bottom: 0px">
						<strong>{{ label_acionamento.toUpperCase() }}</strong>
					</p>
					<p>
						<span style="color: red">{{ acionamentoOld }}</span>
						<i
							class="fa fa-arrow-right"
							aria-hidden="true"
							v-show="acionamentoOld"
						></i>
						<span
							:style="{
								color: acionamentoOld ? 'green' : ''
							}"
							>{{ form.acionamento }}</span
						>
					</p>
				</div>
				<div class="col-xs-6 text-center">
					<p style="margin-bottom: 0px">
						<strong>{{
							_traducao('global', 'decolagem').toUpperCase()
						}}</strong>
					</p>
					<p>
						<span style="color: red">{{ decolagemOld }}</span>
						<i
							class="fa fa-arrow-right"
							aria-hidden="true"
							v-show="decolagemOld"
						></i>
						<span
							:style="{
								color: decolagemOld ? 'green' : ''
							}"
							>{{ form.decolagem }}</span
						>
					</p>
				</div>
			</div>

			<div class="row">
				<div class="col-xs-6 text-center">
					<p style="margin-bottom: 0px">
						<strong>{{ _traducao('global', 'pouso').toUpperCase() }}</strong>
					</p>
					<p>
						<span style="color: red">{{ pousoOld }}</span>
						<i
							class="fa fa-arrow-right"
							aria-hidden="true"
							v-show="pousoOld"
						></i>
						<span
							:style="{
								color: pousoOld ? 'green' : ''
							}"
							>{{ form.pouso }}</span
						>
					</p>
				</div>
				<div class="col-xs-6 text-center">
					<p style="margin-bottom: 0px">
						<strong>{{ _traducao('global', 'corteVoo').toUpperCase() }}</strong>
					</p>
					<p>
						<span style="color: red">{{ corteOld }}</span>
						<i
							class="fa fa-arrow-right"
							aria-hidden="true"
							v-show="corteOld"
						></i>
						<span
							:style="{
								color: corteOld ? 'green' : ''
							}"
							>{{ form.corte }}</span
						>
					</p>
				</div>
			</div>

			<hr />

			<div class="row">
				<div class="col-xs-12 text-center">
					<p class="text-info">
						<strong>{{ _traducao('global', 'horas').toUpperCase() }}</strong>
					</p>
				</div>
				<div class="col-xs-6 text-center">
					<p style="margin-bottom: 0px">
						<strong>{{ _traducao('global', 'inicial').toUpperCase() }}</strong>
					</p>
					<p>{{ form.horimetro_inicial | horimetro }}</p>
				</div>
				<div class="col-xs-6 text-center">
					<p style="margin-bottom: 0px">
						<strong>{{ _traducao('global', 'final').toUpperCase() }}</strong>
					</p>
					<p>{{ form.horimetro_final | horimetro }}</p>
				</div>
			</div>

			<hr />

			<div class="row" v-if="editar && form.id_assinatura_piloto != ''">
				<div class="col-xs-12">
					<AlertDanger>{{
						_traducao('global', 'seraNecessarioAssinatura')
					}}</AlertDanger>
				</div>
			</div>

			<div class="row" v-if="assinar">
				<div class="col-xs-12">
					<div class="checkbox pull-right">
						<label style="line-height: 20px">
							<input type="checkbox" v-model="cienteAssinatura" />
							{{ _traducao('global', 'estouCienteQuanto').toUpperCase() }}
							<a href="#" @click.prevent="clickExibeModalDiario('I', false)">{{
								_traducao('global', 'incisoss').toUpperCase()
							}}</a>
							{{ _traducao('global', 'doArtigo').toUpperCase() }}.
						</label>
					</div>
				</div>
			</div>

			<div class="row" v-if="temposEditados">
				<div class="col-xs-12">
					<AlertWarning>
						Devido à edição dos campos de horário, todos os trechos posteriores
						terão a assinatura do Piloto em Comando removidas. Ao clicar em
						atualizar você estará confirmando está ação.
					</AlertWarning>
				</div>
			</div>

			<div class="row">
				<div class="col-xs-12">
					<ButtonDefault
						size="lg"
						@click="
							revisar = true
							$refs.modalConfirmacao.modalHide()
						"
						>{{ _traducao('global', 'revisar') }}</ButtonDefault
					>

					<ButtonConfirm
						v-if="!editar && !assinar"
						class="pull-right"
						@click="clickSalvar()"
						size="lg"
					>
						{{ _traducao('global', 'finalizar') }}
					</ButtonConfirm>

					<ButtonConfirm
						v-if="editar && !assinar"
						class="pull-right"
						@click="clickSalvar()"
						size="lg"
					>
						{{ _traducao('global', 'atualizar') }}
					</ButtonConfirm>

					<ButtonConfirm
						v-if="assinar"
						:disabled="!cienteAssinatura"
						class="pull-right"
						@click="modalCarregaAssinatura()"
						size="lg"
					>
						{{ _traducao('global', 'assinarEFinalizar') }}
					</ButtonConfirm>
				</div>
			</div>
		</modal>

		<flModalAssinatura
			ref="assinatura"
			@assinado="(assinatura) => validaAssinatura(assinatura)"
		/>

		<flModalSolicitacaoEdicao
			ref="modalSolicitacaoEdicao"
			@solicitacao-salva="solicitacaoSalva"
		/>

		<fl-modal-motivo-assinatura ref="modalMotivoAssinatura" />

		<!-- MODAL DE ORGÃOS APOIADOS -->
		<modal ref="finalizarDespacho">
			<div class="row">
				<div class="col-xs-12">
					<h4 class="text-center">ATENÇÃO</h4>
					<hr />
					<div class="row">
						<div class="col-xs-12 text-center">
							<h3>
								{{
									dbComercial
										? _traducao('global', 'selecionouProgramacaoEncerrada')
										: _traducao('global', 'selecionouDespachoEncerrado')
								}}
								<br /><br />
								{{ _traducao('global', 'desejaContinuar') }}
							</h3>
						</div>
					</div>
					<hr />
					<div>
						<ButtonCancel
							size="lg"
							@click="
								$refs.finalizarDespacho.modalHide()
								form.finalizar_despacho = '0'
							"
							>Cancelar</ButtonCancel
						>
						<ButtonConfirm
							size="lg"
							class="pull-right"
							@click="$refs.finalizarDespacho.modalHide()"
							>Continuar</ButtonConfirm
						>
					</div>
				</div>
			</div>
		</modal>

		<!-- MODAL DE ORGÃOS APOIADOS -->
		<modal ref="orgaosApoiadosModal">
			<div :key="atualizaModal">
				<button
					type="button"
					class="close"
					@click="$refs.orgaosApoiadosModal.modalHide()"
				>
					<span aria-hidden="true">&times;</span>
				</button>

				<flOrgaosApoiados :eh-modal="true" />
			</div>
		</modal>

		<!-- MODAL DE PASSAGEIROS -->
		<modal ref="formCadastroPassageiro">
			<div class="row">
				<div class="col-xs-12">
					<h4>
						{{ _traducao('global', 'cadastroPassageiros').toUpperCase() }}
						<button
							type="button"
							class="close"
							@click="$refs.formCadastroPassageiro.modalHide()"
						>
							<span aria-hidden="true">&times;</span>
						</button>
					</h4>
					<hr />
				</div>
				<flFormCadastroPassageiro
					ref="componenteCadastroPassageiro"
					:is-not-modal="false"
					@passageiro-salvo="carregarPassageiroRecemSalvo"
				/>
			</div>
		</modal>

		<movimentacoes-combustivel
			ref="movimentacoesCombustivel"
			@selecionou-movimentacao="(data) => movimentacaoSelecionado(data)"
		/>
	</div>
</template>

<script>
import $click from './mixins/click.js'
import $carrega from './mixins/carrega.js'
import $tabela from '../../../../../mixins/tabela.js'
import flPrintDiario from '../print/main.vue'
import flOrigemVoo from './origem-voo.vue'
import flModalSolicitacaoEdicao from '../../components/solicitacao-edicao/modal-solicitacao.vue'
import flListaSolicitacoesDb from '../../components/solicitacao-edicao/lista-solicitacoes-db.vue'
import flModalMotivoAssinatura from '../../components/solicitacao-edicao/modal-motivo-assinatura.vue'
import flCabecalhoDbPiloto from './components/cabecalho-db-piloto.vue'
import flInformacoesAeronave from './components/informacoes-aeronave.vue'
import flInformacoesManutencao from './components/informacoes-manutencao.vue'
import flInformacoesCiclosTotais from './components/informacoes-ciclos-totais.vue'
import flDateTime from '@/modules/components/datetime/main.vue'
import flFormCadastroPassageiro from '@/modules/layout/admin-geral/cadastro-passageiros/form/main.vue'
import movimentacoesCombustivel from './components/informacoes-movimentacoes-combustivel.vue'
import Camera from '@/modules/componentsv2/camera/main.vue'
import abastecimentoBasico from './components/abastecimento/basico.vue'
import abastecimentoIntermediario from './components/abastecimento/intermediario.vue'
import abastecimentoMovimentacaoCombustivel from './components/abastecimento/movimentacaoCombustivel.vue'
import tempoVoo from './components/tempoVoo.vue'
import vitimas from './components/vitimas.vue'

import {isObject} from 'lodash'

export default {
	mixins: [$click, $carrega, $tabela],

	components: {
		flFormCadastroPassageiro,
		flPrintDiario,
		flOrigemVoo,
		flModalSolicitacaoEdicao,
		flListaSolicitacoesDb,
		flModalMotivoAssinatura,
		flCabecalhoDbPiloto,
		flInformacoesAeronave,
		flInformacoesManutencao,
		flInformacoesCiclosTotais,
		flDateTime,
		movimentacoesCombustivel,
		Camera,
		abastecimentoBasico,
		abastecimentoIntermediario,
		abastecimentoMovimentacaoCombustivel,
		tempoVoo,
		vitimas
	},

	props: {
		exibeHistoricoVisualizar: {
			type: Boolean,
			default: false,
			required: false
		},

		relacoesCombustivel: {
			type: Array,
			default: () => [],
			required: false
		},

		visualizar: {
			type: Boolean,
			default: false,
			required: false
		},

		cabecalho: {
			type: Boolean,
			default: true,
			required: false
		},

		voo: {
			type: Boolean,
			default: true,
			required: false
		},

		hasNextPageRotaer: {
			type: Boolean,
			default: true,
			required: false
		},

		isVisualizarDiarioOperadorOuPiloto: {
			type: Boolean,
			required: false,
			default: false
		},

		fusoHorario: {
			type: String,
			default: 'local',
			required: false
		},

		listaFuncoesPassageiros: {
			type: Array,
			default: () => []
		},

		rotaER: {
			type: Array,
			default: () => []
		},
		estados: {
			type: Array,
			default: () => []
		},
		classificacoes: {
			type: Array,
			default: () => []
		},
		subclassificacoes: {
			type: Array,
			default: () => []
		},
		unidadesConservacao: {
			type: Array,
			default: () => []
		},
		basesOperacao: {
			type: Array,
			default: () => []
		},
		listaAtas: {
			type: Array,
			default: () => []
		},
		pilotos: {
			type: Array,
			default: () => []
		},
		mecanicos: {
			type: Array,
			default: () => []
		},
		ovns: {
			type: Array,
			default: () => []
		},
		contextos: {
			type: Array,
			default: () => []
		},
		orgaos: {
			type: Array,
			default: () => []
		},
		bases: {
			type: Array,
			default: () => []
		},
		descricoes: {
			type: Array,
			default: () => []
		},
		tiposDeMissoes: {
			type: Array,
			default: () => []
		},
		tiposDeNaturezas: {
			type: Array,
			default: () => []
		},
		aeronaves: {
			type: Array,
			default: () => []
		}
	},

	data() {
		return {
			habilitaTemposParaEdicao: false,
			campoEncerrouCombustivel: false,
			temposEditados: false,
			acionamentoOld: '',
			corteOld: '',
			decolagemOld: '',
			pousoOld: '',
			exibeOutro: false,
			nomeOutroDocumento: '',
			abastecimentoIndex: 0,
			showCamera: false,
			showCameraAnexos: false,
			estadosDestino: [],
			componenteAbastecimento: false,
			larguraTela: window.innerWidth,
			classificacaoAux: [],
			subclassificacoesAux: [],
			descricaoMissaoAux: [],
			calculaParamAcionamentoCorte: '',
			vincularLista: false,
			limiteApresentacao: '',
			trechosModal: [],
			permitirDiarioMaior: false,
			integridadeHorarioAcionamento: true,
			integridadeHorimetroApu: null,
			flagComponenteCarga: $cliente.get('componente_carga_solicitacao'),
			horarioDB: $cliente.get('horario_db'),
			exibeFinalizarOrdemMissao: '',
			exibeNp: false,
			habilitaPartida: false,
			edicao_mecanico_oleo_lubrificante: '',
			label_acionamento: 'acionamento',

			diferenca_utc: '',

			exibeRedsSamu: '',

			indexCadastro: 0,
			centrodeCusto: '',
			atualizaModal: 0,
			atualizaDb: 0,
			cargas: [],

			listaPassageiros: [],
			observer: null,
			limit: 5,
			search: '',
			timeBusca: null,

			tab: 'SISTEMA',
			maxDate: '',
			validaVfr: '',

			exibeContextoOperativo: false,
			exibeClassificacao: false,
			numeroOcorrenciaSamu: '',
			numeroOcorrencia193: '',

			exibeObjetivosMissao: '',

			solicitacaoEdicao: [],

			listaDeFuncoes: [],
			funcoesQueAssinam: [],
			funcaoPrincipal: [],

			enableCargo: true,
			enableOrgao: true,
			passCpfObrigatorio: false,

			salvouSolicitacao: false,
			tipoDBModal: 'I',

			assinarESalvar: false,
			preencher: false,

			revisar: false,
			mostraacionamentoUTC: false,
			decolagemUTC: false,
			pousoUTC: false,
			corteUTC: false,
			tipoPassageiro: '',
			disablePaxPob: true,
			qtdEstPassageiros: 0,
			loadUnidade: false,
			timeOut: '',
			timeOutModal: '',
			dataNascimento: null,
			load: true,
			//exibirTriuplacao: false,
			itemCopiar: '',

			tipo_planejada: '',

			cienteAssinatura: false,

			aerosImport: [],

			ciclo_nf: '',
			id_motor_esquerdo: null,
			id_motor_direito: null,
			sn_motor_esquerdo: '',
			sn_motor_direito: '',

			aeronave: {
				prefixo: '',
				codinome: '',
				categoria: ''
			},

			aeronave_import: '',

			podemSerPilotos: [],
			loadDe: false,
			loadPara: false,
			loadVor: false,
			editar: false,

			titulo: '',
			ordem: '',
			despacho: '',
			cidadesDe: [],
			cidadesPara: [],
			cidadesVor: [],
			passageirosSelecao: [],
			trecho: {},

			formPost: {},
			retornoWS: {},

			loadSub: false,
			assinar: false,
			unidadesArmazenamento: [],
			volume: '',
			numero_ce: '',
			id_unidade_armazenamento: '',
			mostraDadosMotor: false,
			mostraVor: false,

			dadosOleoLubrificante: {},
			habilitaOleoLubrificante: '',
			fornecedores: [],
			loadedFiles: [],
			loadedFilesDiario: [],
			urlEnvio: this.getURL_WS('/Utilitarios/recebe_arquivo'),
			urlExcluir: 'mg-siga/Relatorio_voo_trecho/excluir_anexo_abastecimento',
			urlExcluirAnexo: 'mg-siga/Relatorio_voo_trecho/excluir_anexo',

			locaisOperacaoOrigem: [],
			locaisOperacaoDestino: [],
			liberarProgramacao: false,

			form: {
				id: 0,
				tipo_voo: '',
				auto_localizado: 0,
				milhas_navegacao: 0,
				trecho_motor: [],
				alteradoPeloMecanico: false,
				diferenca_fuso_horario: '',
				chave_validacao: '',
				descricao_ultima_inspecao: '',
				descricao_proxima_inspecao: '',

				labelPassageiro: '',
				despacho_emergencial: '',
				pax: 0,
				pob: 0,
				ultima_intervencao: '',
				proxima_intervencao: '',
				horimetro_proxima: '',
				id_responsavel_retorno: '',
				codigo_anac_usuario_retorno: '',
				nome_usuario_retorno: '',
				nome_usuario_inseriu: '',
				data_cadastro: '',
				arma_apreendida: 0,
				pessoa_salva: 0,
				pessoa_detida: 0,
				valor_recuperado: 0,
				//tempo_voo_celula: 0,
				voo_instrucao: '0',
				tempo_voo_motor: 0,
				finalizar_despacho: '0',
				id_aeronave_import: '',
				nome_usuario_assinou: '',
				data_assinatura_piloto: '',
				nome_mecanico_assinou: '',
				nome_operador_assinou: '',
				data_assinatura_mecanico: '',
				data_assinatura_operador: '',
				voo: null,
				de: '',
				base: '',
				base_contratual: '',
				de_select: '',
				nome_estado_de: '',
				nome_cidade_de: '',
				unidade_combustivel: '',
				acionamento: '',
				corte: '',
				acionamento_utc: '',
				decolagem_utc: '',
				apresentacao_utc: '',
				pouso_utc: '',
				corte_utc: '',
				ocorrencia: '0',
				ocorrencias: [],
				id_integracao_local_origem: null,
				id_integracao_local_destino: null,
				para: '',
				para_select: '',
				nome_estado_para: '',
				nome_cidade_para: '',

				lat_inicio: '',
				lat_fim: '',
				lng_inicio: '',
				lng_fim: '',

				hora_vfr_noturno: '',
				hora_vfr_diurno: '',
				hora_ifr: '',
				hora_vfr: '',
				hora_navegacao: '',
				hora_ifr_simulado: '',

				vfr_noturno: '',
				vfr_diurno: '',
				ifr: '',
				vfr: '',
				navegacao: '',
				ifr_simulado: '',

				houve_contexto: '',
				contexto_operativo: '',
				numero_diario_anac: '',

				cargaArray: [],
				cargaPadrao: {},

				carga: false,
				descricao_carga: '',
				peso_carga: '',
				carga_liquida: '',
				monitoramento_motor: [],

				verificacao_vor: '',
				existe_abastecimento: 0,
				vor: '',
				radial_vor: '',
				afastamento_vor: '',
				erro_vor: '',

				decolagem: '',
				pouso: '',

				natureza_voo: '',
				numero_atividade: '',
				numero_bo: '',
				numero_chamada: '',
				existe_unidade_conservacao: '',

				total_ciclo_torque: '',
				total_gancho: '',
				total_guincho: '',
				total_partidas: '',
				total_pousos: '',

				habilitaPerformanceMotor: 0,
				quantidadeMotores: 0,
				horario_performance_motor: null,
				performance_fl: '',
				performance_tat: 0,
				performance_ias: 0,
				performance_tas: 0,
				performance_boost: 0,
				performance_motor_esq: '',
				performance_motor_dir: '',
				performance_torque_esq: 0,
				performance_torque_dir: 0,
				performance_np_esq: 0,
				performance_np_dir: 0,
				performance_itt_esq: 0,
				performance_itt_dir: 0,
				performance_nh_esq: 0,
				performance_nh_dir: 0,
				performance_flow_esq: 0,
				performance_flow_dir: 0,
				performance_nl_esq: 0,
				performance_nl_dir: 0,

				ovn: '0',
				flir: '',
				ciclo_ng: '',
				ciclo_nf: '',
				ciclo_np: '',
				numero_voo: '',

				nome_arquivo: '',

				finalizar_ordem: '',
				ocorrencia193Obrigatoria: '',

				vfr_diurno: '',
				tempo_voo_piloto: '',

				vfr_noturno: '',
				ifr: '',
				navegacao: '',
				arquivo: '',
				total: '',

				horimetro_final: '',
				horimetro_inicial: '',

				horimetro_inicial_manutencao: '',
				horimetro_final_manutencao: '',

				id_apu: null,
				horimetro_apu: 0,
				horimetro_inicial_apu: 0,
				horimetro_final_apu: 0,
				ciclos_apu: 0,

				combustivel: '',
				partidas: 1,
				pousos: 1,

				objetivo_alcancado: '',

				tipo_missao: '',
				tipo_natureza: '',
				observacao: '',
				descricao: '',

				classificacao: '',
				subclassificacao: '',

				unidade_conservacao: [
					{
						obj: '',
						erro: ''
					}
				],
				base_origem: '',

				id_assinatura_piloto: '',

				coracao: 0,
				rim: 0,
				figado: 0,
				cornea: 0,
				pancreas: 0,
				esclero: 0,
				baco: 0,

				gancho: 0,
				guincho: 0,

				socorrido: 0,
				bambi: 0,
				brigadista: 0,

				tripulacao: [
					{
						id_usuario: '',
						erroUsuario: '',
						funcao: '',
						anac: '',
						base: '',
						apresentacao: '',
						erroApresentacao: '',
						codigo_ovn: '',
						erroOVN: '',
						trigrama: '',
						uso_ovn: '',
						tempoOvn: '',
						id_ovn: '',
						erroUsoOvn: '',
						erroIdOvn: '',
						erroTempoOvn: '',
						erroDataCadastro: ''
					}
				],
				discrepancia: [],
				abastecimentoCombustivel: [
					{
						anexos: [],
						combustiveis: [],
						contratos: [],
						contratoSelecionado: {},
						data_abastecimento: null,
						designativo_abastecimento: 'origem',
						empenhos: [],
						empenhoSelecionado: {},
						erro: {
							designativo_abastecimento: null,
							id_contrato: null,
							id_contrato_empenho: null,
							id_fornecedor: null,
							id_tipo_lancamento: null,
							numero_ce: null,
							origem_abastecimento: null,
							relacao_abastecimento: null,
							valor_total: null,
							valor_unitario: null,
							volume: null
						},
						forma_controle: null,
						id_combustivel: null,
						id_contrato_empenho: null,
						id_fornecedor: null,
						id_orgao: null,
						id_tipo_lancamento: null,
						id_unidade_armazenamento: null,
						nota_fiscal: null,
						numero_ce: null,
						relacao_abastecimento: null,
						unidadeArmazenamentoSelecionada: {},
						valor_total: 0,
						valor_unitario: 0,
						volume: 0
					}
				],

				anexos: [],

				passageiro: [],
				orgao: [],
				id_abastecimento_comprovante: null,

				adicao_oleo_lubrificante: '',
				fornecedor_oleo_lubrificante: '',
				numero_ce_oleo_lubrificante: '',
				campo_lubrificacao_1: '',
				campo_lubrificacao_2: '',
				campo_lubrificacao_3: '',
				campo_lubrificacao_4: '',
				campo_lubrificacao_5: '',
				observacoes_oleo_lubrificante: '',
				combustivelFinal: 0
			},

			listaApus: [],

			erro: {
				local_operacao_origem: '',
				local_operacao_destino: '',
				diurnoNortuno: '',
				ifrVfr: '',
				tempo_voo_piloto: '',
				id_ordem_trecho: '',
				tempo_voo_motor: '',
				numero_atividade: '',
				unidade_combustivel: '',
				numero_bo: '',
				ocorrencia193Obrigatoria: '',
				base: '',
				acionamento: '',
				instrutor_voo: '',
				corte: '',
				existe_unidade_conservacao: '',

				objetivo_alcancado: '',

				numero_chamada: '',

				finalizar_ordem: '',

				observacao: '',

				classificacao: '',
				subclassificacao: '',

				descricao: '',

				houve_contexto: '',
				contexto_operativo: '',

				finalizar_despacho: '',

				orgao: '',
				de: '',
				nome_estado_de: '',
				nome_cidade_de: '',

				para: '',
				nome_estado_para: '',
				nome_cidade_para: '',

				decolagem: '',
				pouso: '',

				tipo_missao: '',
				tipo_natureza: '',

				ovn: '',
				flir: '',

				pax: '',

				carga: '',
				descricao_carga: '',
				peso_carga: '',
				carga_liquida: '',

				aprovado: '',

				vfr_diurno: '',
				vfr_noturno: '',
				ifr: '',
				ifr_simulado: '',
				vfr: '',
				navegacao: '',
				total: '',
				ciclo_ng: '',
				ciclo_nf: '',
				ciclo_np: '',
				numero_voo: '',
				horimetro_final: '',
				horimetro_inicial: '',
				combustivel: '',
				partidas: '',
				pousos: '',
				existe_abastecimento: '',
				combustivelFinal: null,
				horimetroApu: ''
			},
			qtdProgramacoesValidas: false,
			utilizaTrigrama: true,
			homologadoAnac: false,
			labelTipoMissao: '',
			habilitaDescMissao: true,
			labelDescMissao: '',
			movimentacaoCombustivel: {
				exibeOrigem: false,
				origem: null,
				original: null
			},
			preenchimentoHouveAbastecimento: null,
			dbComercial: false,
			horasDeAcionamentoCorte: _traducao('global', 'horasAcionamentoCorte'),
			tripulacaoTecnica: false,
			mobile: false,
			preenchimentoAutomaticoCicloAsaFixa: false,
			parametroTipoPassageiro: false,
			validadorComponenteAbastecimento: false,
			validadorComponenteTempoVoo: false
		}
	},

	computed: {
		computedApuAeronave() {
			return this.aeronave.apu_aeronave.filter(
				(apu) =>
					apu.data_inicio <=
					this._dateTimeToDateSQL(this.form.acionamento, 'DD/MM/YYYY HH:MM:SS')
			)
		},
		disabledTempos() {
			return !this.preencher && !this.habilitaTemposParaEdicao
		},
		mascaraLatitude() {
			if (
				this.form.lat_inicio &&
				this.form.lat_inicio.length == 10 &&
				this.form.de === 'ZZZZ'
			) {
				return "S00º00'00"
			} else if (
				this.form.lat_inicio &&
				this.form.lat_inicio.length >= 11 &&
				this.form.de === 'ZZZZ'
			) {
				return "S00º00'00.00"
			} else {
				return "S00º00'00"
			}
		},

		mascaraLatitudeFinal() {
			if (
				this.form.lat_fim &&
				this.form.lat_fim.length <= 10 &&
				this.form.para === 'ZZZZ'
			) {
				return "S00º00'0.00"
			} else if (
				this.form.lat_fim &&
				this.form.lat_fim.length >= 11 &&
				this.form.para === 'ZZZZ'
			) {
				return "S00º00'00.00"
			} else {
				return "S00º00'00"
			}
		},
		__tiposDeMissoes() {
			const tiposDeMissoes = this.tiposDeMissoes.filter(
				(item) => item.visualizar == 0
			)
			for (let index = 0; index < this.tiposDeMissoes.length; index++) {
				if (tiposDeMissoes[index].descricao === 'COMBATE A INCÊNDIO') {
					tiposDeMissoes[index].descricao =
						tiposDeMissoes[index].descricao +
						' (URBANO – MISSÃO TÍPICA DE BOMBEIRO)'
				}

				if (tiposDeMissoes[index].descricao === 'MEIO AMBIENTE') {
					tiposDeMissoes[index].descricao =
						tiposDeMissoes[index].descricao +
						' (INCLUINDO COMBATE A INCÊNDIO FLORESTAL)'
				}
			}

			return tiposDeMissoes
		},

		listaFiltrada() {
			if (this.listaPassageiros._request) {
				return this.listaPassageiros.lista.filter(
					(pass) =>
						this.form.passageiro.findIndex(
							(pessoa) => pessoa.id_passageiro == pass.id_passageiro
						) == -1
				)
			} else {
				return this.listaPassageiros.lista
			}
		},

		hasNextPage() {
			return (
				this.listaPassageiros.pagination.page <
				this.listaPassageiros.pagination.pages
			)
		},

		_pilotos() {
			return this.pilotos.map((item) => {
				item.descricao = item.trigrama + ' - ' + item.nome
				return item
			})
		},

		_pilotos_mecanicos() {
			let pilotos = this.pilotos.find((item) => {
				if (item.id === $sessao.getId()) {
					item.descricao = item.trigrama + ' - ' + item.nome
					return item
				}
			})

			let mecanicos = this.mecanicos.find((item) => {
				if (item.id === $sessao.getId()) {
					item.descricao = item.trigrama + ' - ' + item.nome
					return item
				}
			})

			let result = _.concat(pilotos, mecanicos)

			//Remove duplicatas se necessário
			result = result
				.filter((item) => item !== undefined)
				.filter(
					(item, index, self) =>
						index === self.findIndex((t) => t.id === item.id)
				)

			return result
		},

		exibeForm() {
			if (this.form.tipo_voo != '') {
				return true
			} else if (this.edicao) {
				return true
			}

			return false
		},

		edicao() {
			return this.form.id == 0 ? false : true
		},

		calculoDePax() {
			if (this.disablePaxPob) {
				if (this.qtdEstPassageiros) {
					if (this.form.passageiro.length < Number(this.qtdEstPassageiros)) {
						return Number(this.qtdEstPassageiros)
					} else {
						return this.form.passageiro.length
					}
				} else {
					return this.form.passageiro.length
				}
			} else {
				return Number(this.qtdEstPassageiros)
			}
		},

		calculoDePob() {
			return this.calculoDePax + this.form.tripulacao.length
		},

		flagSimples() {
			return this.flagComponenteCarga === 'basico' || 'simples'
		},
		flagCompleto() {
			return this.flagComponenteCarga === 'completo'
		},
		flagPeso() {
			return this.flagComponenteCarga === 'peso'
		},

		semAnexos() {
			if (this._idCliente != 62) {
				return false
			}
			return this.form.finalizar_despacho == '1' && this.form.anexos.length == 0
		},
		msgHorimetroApuInvalido() {
			if (this.form.horimetro_inicial_apu > this.form.horimetro_final_apu) {
				return `APU - Horímetro inicial maior que o final.`
			}
			if (this.integridadeHorimetroApu) {
				const {anterior, posterior} = this.integridadeHorimetroApu
				if (anterior && posterior) {
					return `APU - O horímetro inicial e final deve estar entre ${anterior} e ${posterior}.`
				} else if (anterior) {
					return `APU - O horímetro inicial deve ser maior que ${anterior}.`
				}
				return `APU - O horímetro final deve ser menor que ${posterior}.`
			}
			return ''
		},
		validaDisabledSalvar() {
			if (this.form.acionamento == '') {
				return true
			}

			if (this.form.corte == '') {
				return true
			}

			if (this.semAnexos) {
				return true
			}

			let total_dn = this._somaTempos(
				this.form.hora_vfr_diurno ? this.form.hora_vfr_diurno : '00:00',
				this.form.hora_vfr_noturno ? this.form.hora_vfr_noturno : '00:00'
			)

			let total_iv = this._somaTempos(
				this.form.hora_ifr ? this.form.hora_ifr : '00:00',
				this.form.hora_vfr ? this.form.hora_vfr : '00:00'
			)

			let invalid = false
			if (total_dn === '00:00' && total_iv === '00:00') {
				this.erro.diurnoNortuno =
					_traducao('global', 'favorPreencherCamposDiurnoNoturno')
				invalid = true
			} else if (total_dn === '00:00') {
				this.erro.diurnoNortuno =
					'Favor preencher o campo "Diurno" ou "Noturno".'
				invalid = true
			} else if (total_iv === '00:00') {
				this.erro.diurnoNortuno = 'Favor preencher o campo "IFR Real" ou "VFR".'
				invalid = true
			} else {
				this.erro.diurnoNortuno = ''
			}

			if (this.msgHorimetroApuInvalido) {
				this.erro.horimetroApu = this.msgHorimetroApuInvalido
				invalid = true
			} else {
				this.erro.horimetroApu = ''
			}

			return invalid
		},
		activeFuncaoDescricao() {
			const activeFuncao = this.funcoesQueAssinam.find(
				(funcao) => funcao.active
			)
			return activeFuncao ? activeFuncao.descricao.toUpperCase() : ''
		},
		__permitirExcluir() {
			return this.form.abastecimentoCombustivel.length > 1
		},
		__exibePassageiro() {
			return this.form.passageiro.filter((passageiro) => {
				return passageiro.tipo == 'P'
			})
		},
		bloqueadoEdicao() {
			return !this.editar && !this.preencher
		}
	},

	watch: {
		'form.acionamento'(val, oldVal) {
			if (val !== oldVal) {
				this.validaHorimetroApu()
				//this.carregaDisponibilidade()
				if (this.preencher || this.habilitaTemposParaEdicao) {
					this.verificaIntegridadeHorario()
					if (oldVal && !this.preencher) {
						this.marcaTemposComoEditados()
						this.acionamentoOld = oldVal
					}
				}
			}
		},
		'form.corte'(val, oldVal) {
			if (val !== oldVal) {
				//this.carregaDisponibilidade()
				if (this.preencher || this.habilitaTemposParaEdicao) {
					this.verificaIntegridadeHorario()
					if (oldVal && !this.preencher) {
						this.marcaTemposComoEditados()
						this.corteOld = oldVal
					}
				}
			}
		},
		'form.decolagem'(val, oldVal) {
			if (val !== oldVal) {
				//this.carregaDisponibilidade()
				if (oldVal && !this.preencher && this.habilitaTemposParaEdicao) {
					this.marcaTemposComoEditados()
					this.decolagemOld = oldVal
				}
			}
		},
		'form.pouso'(val, oldVal) {
			if (val !== oldVal) {
				//this.carregaDisponibilidade()
				if (oldVal && !this.preencher && this.habilitaTemposParaEdicao) {
					this.marcaTemposComoEditados()
					this.pousoOld = oldVal
				}
			}
		},
		'form.de_select': async function (val, oldVal) {
			if (val != null) {
				this.estados = await this.getEstados(val?.pais ?? 'Brazil')
				if (val._default) {
					this.form.de = val.sigla
					if (!this.edicao) {
						this.nome_estado_de = ''
						this.nome_cidade_de = ''
					}
				} else {
					this.form.de = val.sigla
					this.form.nome_cidade_de = val.cidade
					this.form.nome_estado_de = val.uf
				}
				this.form.lat_inicio = this.form.de_select.grau_lat
				this.form.lng_inicio = this.form.de_select.grau_lng
				if (val.id_integracao_local) {
					this.form.id_integracao_local_origem = val.id_integracao_local
				}
			} else {
				this.form.de = ''
				this.form.id_integracao_local_origem = null
			}
			this.getLocaisOperacaoOrigem()
		},
		'form.para_select': async function (val, oldVal) {
			if (val != null) {
				this.estadosDestino = await this.getEstados(val?.pais ?? 'Brazil')
				if (val._default) {
					this.form.para = val.sigla
					if (!this.edicao) {
						this.form.nome_estado_para = ''
						this.form.nome_cidade_para = ''
					}
				} else {
					this.form.para = val.sigla
					this.form.nome_cidade_para = val.cidade
					this.form.nome_estado_para = val.uf
				}
				this.form.lat_fim = this.form.para_select.grau_lat
				this.form.lng_fim = this.form.para_select.grau_lng
				if (val.id_integracao_local) {
					this.form.id_integracao_local_destino = val.id_integracao_local
				}
			} else {
				this.form.para = ''
				this.form.id_integracao_local_destino = null
			}
			await this.getLocaisOperacaoDestino()
		},
		'form.horimetro_inicial': function (val, oldVal) {
			if (val != oldVal) {
				this.calculaTotal()
			}
		},
		'search'(novo, antigo) {
			if (novo != antigo) {
				clearTimeout(this.timeBusca)
				this.timeBusca = setTimeout(() => {
					this.listaPassageiros.pagination.page = 0
					this.listaPassageiros.pagination.pages = 1
					this.listaPassageiros.lista = []
				}, 400)
			}
		},
		'form.pax': {
			deep: true,
			handler(newVal) {
				this.form.pob = this.form.tripulacao.length + Number(newVal)
			}
		},
		'form.passageiro.length': {
			deep: true,
			handler(newVal) {
				if (this.disablePaxPob) {
					this.form.pax = Number(newVal)
				}
			}
		},
		'form.finalizar_despacho': function (val, oldVal) {
			if (
				val != oldVal &&
				oldVal == '0' &&
				val == '1' &&
				this.liberarProgramacao
			) {
				this.$refs.finalizarDespacho.modalShow(40)
			}
		},
		'form.horimetro_inicial_apu': function (val, oldVal) {
			if (val != oldVal) {
				this.validaHorimetroApu()
				this.calculaHorimetroApu()
			}
		},
		'form.horimetro_final_apu': function (val, oldVal) {
			if (val != oldVal) {
				this.validaHorimetroApu()
				this.calculaHorimetroApu()
			}
		}
	},

	beforeDestroy() {
		this.limpaTimeOuts()
		window.removeEventListener('beforeunload', this.limpaDiarioPreenchendo)
		window.removeEventListener('pagehide', this.limpaDiarioPreenchendo)
	},

	async mounted() {
		//cria um intersectionObserver para a pesquisa de passageiro
		this.componenteAbastecimento = (await this._getParametro(165)).trim()
		this._getParametro(172).then(
			(valor) => (this.habilitaTemposParaEdicao = Number(valor) == 1)
		)
		this._getParametro(180).then(
			(valor) => (this.campoEncerrouCombustivel = Number(valor) == 1)
		)
		this._getParametro(185).then((valor) => (this.titulo = valor))
		this.observer = new IntersectionObserver(this.getPassageiros)
		window.addEventListener('resize', this.handleResize)
		window.addEventListener('beforeunload', this.limpaDiarioPreenchendo)
		window.addEventListener('pagehide', this.limpaDiarioPreenchendo)
	},

	async created() {
		this.label_acionamento = await this._getParametro(74)
		this.parametros()
		this.utilizaTrigrama = $cliente.get('utiliza_trigrama') === '1'

		this._httpGet('Servico/get_data_atual', (retorno) => {
			if (retorno._request && retorno._status) {
				if (this.horarioDB == 'UTC') {
					if (this.aeronave.fuso_horario) {
						const index = retorno.aeronave.findIndex(
							(aero) => aero.id === this.aeronave.id
						)
						if (index !== -1) {
							var aeronaveEncontrada = retorno.aeronave[index]
							this.maxDate = this._SQLDateToDateTime(
								aeronaveEncontrada.data_com_fuso,
								$sessao.getDateFormat() + ' HH:MM'
							)
						}
					} else {
						this.maxDate = this._SQLDateToDateTime(
							retorno.data_utc,
							$sessao.getDateFormat() + ' HH:MM'
						)
					}
				} else {
					if (this.aeronave.fuso_horario) {
						const index = retorno.aeronave.findIndex(
							(aero) => aero.id === this.aeronave.id
						)
						if (index !== -1) {
							var aeronaveEncontrada = retorno.aeronave[index]
							this.maxDate = this._SQLDateToDateTime(
								aeronaveEncontrada.data_com_fuso,
								$sessao.getDateFormat() + ' HH:MM'
							)
						}
					} else {
						this.maxDate = this._SQLDateToDateTime(
							retorno.data,
							$sessao.getDateFormat() + ' HH:MM'
						)
					}
				}
			}
		})

		this.diferenca_utc = $cliente.get('diferenca_utc')

		this.carregaDados()
		this.clickAddOrgao()
		this.carregaUnidadesArmazenamento()
		this.listaFuncoes()
		this.getFornecedores()
	},

	methods: {
		habilitaOVN(funcao) {
			return this.listaDeFuncoes.find(
				(item) => item.descricao == funcao && item.habilita_ovn == '1'
			)
		},
		validaHorimetroApu() {
			this.debounceHorimetroApu(null, this)
		},
		debounceHorimetroApu: _.debounce((_, vm) => vm.validaIntegridadeApu(), 300),
		calculaHorimetroApu() {
			this.form.horimetro_apu = parseFloat(
				this.form.horimetro_final_apu - this.form.horimetro_inicial_apu
			).toFixed(1)
		},
		clearTemposAcionamentoCorte() {
			if (this.aeronave.tempo_calculo_diurno_noturno != 'DECOLAGEM AO POUSO') {
				this.form.hora_vfr_diurno = ''
				this.form.hora_vfr_noturno = ''
				this.form.hora_ifr = ''
				this.form.hora_vfr = ''
			}
		},
		clearTemposDecolagemPouso() {
			if (this.aeronave.tempo_calculo_diurno_noturno == 'DECOLAGEM AO POUSO') {
				this.form.hora_vfr_diurno = ''
				this.form.hora_vfr_noturno = ''
				this.form.hora_ifr = ''
				this.form.hora_vfr = ''
			}
		},
		marcaTemposComoEditados() {
			this.temposEditados = true
		},
		criarRegistroDeAbastecimento() {
			const idRelatorio = this.trecho.id
			const dadosAbastecimento = this.form.abastecimentoCombustivel
			this._axios(
				`mg-siga/Relatorio_voo_trecho/criar_registro_abastecimento/${idRelatorio}`,
				'post',
				{
					data: {
						dadosAbastecimento
					},
					callback: (response) => {
						if (response._request) {
							const ids = response.ids
							if (Array.isArray(ids) && ids.length > 0) {
								ids.forEach((id, index) => {
									this.form.abastecimentoCombustivel.splice(index, 1, {
										...this.form.abastecimentoCombustivel[index],
										id: id
									})
								})
							}
						}
					}
				}
			)
		},
		openCamera(index) {
			this.abastecimentoIndex = index
			this.showCamera = true
		},
		closeCamera() {
			this.showCamera = false
		},
		openCameraAnexos() {
			this.showCameraAnexos = true
		},
		closeCameraAnexos() {
			this.showCameraAnexos = false
		},
		getFornecedores() {
			this._httpGet('Fornecedor/get', (response) => {
				this.fornecedores = response.lista
			})
		},
		getEstados(local) {
			return new Promise((resolve) => {
				const link = `/Estado/get_estado_pais?pais=${escape(local)}`
				this._httpGet(link, (response) => {
					resolve(response.lista)
				})
			})
		},

		limpaCamposDepoisDeSelecionar() {
			this.form.descricao = ''
			this.form.classificacao = ''
			this.form.subclassificacao = ''
		},
		limpaCamposSubDepoisDeSelecionar() {
			this.form.subclassificacao = ''
		},
		filtraCampos() {
			this.filtraClassificacao()
			this.filtraDescricoes()
		},
		filtraClassificacao() {
			if (!this.vincularLista) {
				this.classificacaoAux = this.classificacoes
				return
			}
			if (!this.form.tipo_missao) return

			this.classificacaoAux = this.classificacoes.filter((item) => {
				return item.id_tipo_missao === this.form.tipo_missao.id
			})
		},

		filtraDescricoes() {
			if (!this.form.tipo_missao || !this.vincularLista) {
				this.descricaoMissaoAux = this.descricoes
			}

			let resultado = this.descricoes.filter((item) => {
				return item.id_tipo_missao === this.form.tipo_missao.id
			})
			if (resultado && resultado.length > 0) {
				this.descricaoMissaoAux = resultado
			} else {
				this.descricaoMissaoAux = this.descricoes
			}
		},

		filtraSubclassificacao() {
			if (!this.vincularLista) {
				this.subclassificacoesAux = this.subclassificacoes
				return
			}
			if (!this.form.classificacao) return

			this.subclassificacoesAux = this.subclassificacoes.filter((item) => {
				return item.id_classificacao == this.form.classificacao.id
			})
		},
		limpaDiarioPreenchendo(e) {
			e.preventDefault()
			e.returnValue = false
			this._httpGet(
				'Aeronave/limpa_diario_preenchendo/' +
					this.aeronave.id +
					'/' +
					window.$sessao.getId(),
				(response) => {
					// //console.log("lbera", response)
				}
			)
		},
		setLiberarEncerrarProg(idDespacho, idDiario) {
			if (!idDespacho || !idDiario) {
				return
			}
			this._axios(
				`mg-siga/Relatorio_voo_trecho/liberar_encerrar_programacao/${idDespacho}/${idDiario}`,
				'get',
				{
					callback: (response) => {
						if (response._request && response._status) {
							this.liberarProgramacao = response.liberar
						}
					}
				}
			)
		},
		setQtdProgramacoesValidas(idDespacho) {
			if (!idDespacho) {
				return
			}
			this._axios(
				`mg-siga/Relatorio_voo_trecho/valida_quantidade_trechos_programacao/${idDespacho}`,
				'get',
				{
					callback: (response) => {
						if (response._request && response._status) {
							this.qtdProgramacoesValidas = response.valido
						}
					}
				}
			)
		},
		asyncFetchLocaisOperacao(designativo) {
			return new Promise((resolve) => {
				this._axios('Servico/get_local_designativo/' + designativo, 'get', {
					callback: (response) => {
						if (
							response._request &&
							response._status &&
							Array.isArray(response.lista)
						) {
							resolve(response.lista)
						} else {
							resolve([])
						}
					}
				})
			})
		},
		getLocaisOperacaoOrigem() {
			this.debounceOrigem(this)
		},
		getLocaisOperacaoDestino() {
			this.debounceDestino(this)
		},
		debounceOrigem: _.debounce(
			async (vm) => await vm.setLocaisOperacaoOrigem(),
			700
		),
		debounceDestino: _.debounce(
			async (vm) => await vm.setLocaisOperacaoDestino(),
			700
		),
		async setLocaisOperacaoOrigem() {
			if (this._idCliente != 62) {
				return
			}
			if (this.form.de_select && this.form.de_select.sigla) {
				this.locaisOperacaoOrigem = await this.asyncFetchLocaisOperacao(
					this.form.de_select.sigla
				)
			}
		},
		async setLocaisOperacaoDestino() {
			if (this._idCliente != 62) {
				return
			}
			if (this.form.para_select && this.form.para_select.sigla) {
				this.locaisOperacaoDestino = await this.asyncFetchLocaisOperacao(
					this.form.para_select.sigla
				)
			}
		},
		nextPageRotaer() {
			bus.$emit('next-page-rotaer')
		},
		searchRotaerServer(val) {
			bus.$emit('search-rotaer', val)
		},
		handleResize() {
			this.larguraTela = window.innerWidth
		},

		clickSelecionarTrechoUnico(index) {
			for (var i = 0; i < this.trechosModal.length; i++) {
				this.trechosModal[i].selecionado = false
			}
			this.trechosModal[index].selecionado =
				!this.trechosModal[index].selecionado
			this.$forceUpdate()
		},

		limpaCampoTempoVoo(campo, decimal) {
			this.form[campo] = ''
			this.form[decimal] = ''
		},
		validaIntegridadeApu() {
			if (this.computedApuAeronave.length > 0 && this.form.acionamento) {
				const idApu = this.computedApuAeronave[0].id_apu
				const acionamento = this._dateTimeToDateSQL(
					this.form.acionamento,
					'DD/MM/YYYY HH:MM:SS'
				)
				const horInicialApu = this.form.horimetro_inicial_apu
				const horFinalApu = this.form.horimetro_final_apu
				const url = `mg-siga/Relatorio_voo_trecho/verifica_horimetro_apu/${idApu}/${acionamento}/${horInicialApu}/${horFinalApu}`
				this._axios(url, 'get', {
					callback: (response) => {
						this.integridadeHorimetroApu = response.data
					}
				})
			}
		},
		verificaIntegridadeHorario() {
			if (!this.form.acionamento || !this.form.corte) {
				return
			}
			let data = {
				id_relatorio_voo_trecho: this.trecho.id,
				id_aeronave: this.aeronave.id,
				acionamento: this._dateTimeToDateSQL(
					this.form.acionamento,
					'DD/MM/YYYY HH:MM:SS'
				),
				corte: this._dateTimeToDateSQL(this.form.corte, 'DD/MM/YYYY HH:MM:SS')
			}

			this._axios(
				'mg-siga/Relatorio_voo_trecho/verifica_integridade_horario',
				'post',
				{
					data: data,
					callback: (response) => {
						if (response.valida == false) {
							this.integridadeHorarioAcionamento = false
						} else {
							this.integridadeHorarioAcionamento = true
						}
					}
				}
			)
		},
		selectOvnTrue(item) {
			item.uso_ovn = true
			this.$forceUpdate()
		},

		selectOvnFalse(item) {
			item.uso_ovn = false
			this.$forceUpdate()
		},

		fetchRotaer(id) {
			if (!id) {
				return {sigla: 'ZZZZ', label: 'ZZZZ', _default: true}
			}
			return new Promise((resolve) => {
				this._httpGet(`Rotaer/busca_exata_id/${id}`, (response) => {
					if (response) {
						resolve(response.rotaer)
					}
				})
			})
		},
		preencherDesignativosPorTrecho() {
			var item = this.trechosModal.find((item) => item.selecionado == true)
			this._httpGet(
				`Rotaer/busca_exata_id/${item.id_rotaer_origem}`,
				(response) => {
					this.form.de_select = response.rotaer
					this.form.de = response.rotaer.id
				}
			)

			this._httpGet(
				`Rotaer/busca_exata_id/${item.id_rotaer_destino}`,
				(response) => {
					this.form.para_select = response.rotaer
					this.form.para = response.rotaer.id
				}
			)

			this._escondeModal('modal-escolha-trecho')
		},

		carregaDadosOleoLubrificante() {
			if (Object.keys(this.dadosOleoLubrificante).length == 0) {
				this._httpGet(
					`Aeronave/get_dados_oleo_lubrificante/${this.trecho.id_aeronave}`,
					(response) => {
						if (response._request && response._status) {
							this.dadosOleoLubrificante = response.lista
						}
					}
				)
			}
		},

		async preencherRotaer(response, tipo) {
			window.bus.$emit(
				'load-in',
				this._traducao('global', 'carregandoPosicaoDoVoo')
			)
			function ConvertDEGToDMS(deg, lat) {
				var absolute = Math.abs(deg)

				var degrees = Math.floor(absolute)
				var minutesNotTruncated = (absolute - degrees) * 60
				var minutes = Math.floor(minutesNotTruncated)
				var seconds = ((minutesNotTruncated - minutes) * 60).toFixed(2)

				if (lat) {
					var direction = deg >= 0 ? 'N' : 'S'
				} else {
					var direction = deg >= 0 ? 'E' : 'W'
				}

				return (
					direction +
					degrees.toString().padStart(lat ? 2 : 3, '0') +
					'°' +
					minutes +
					"'" +
					seconds
				)
			}
			if (response === 'ZZZZ') {
				const posicoes = await new Promise((resolve) =>
					this._axios(
						`/Aeronave/get_posicoes_data/${this.trecho.acionamento}/${this.trecho.corte}/${this.trecho.id_aeronave}`,
						'get',
						{
							callback: (retorno) => {
								resolve(retorno)
							}
						}
					)
				)
				window.bus.$emit('load-out')
				if (posicoes?.length > 0) {
					const {lat, lng} =
						tipo == 'de' ? posicoes[0] : posicoes[posicoes.length - 1]
					const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${this._googleKey}`
					this._httpGetExternal(url, (resposta) => {
						let endereco = procurarTipoEndereco(
							resposta.results,
							'administrative_area_level_2'
						)
						if (!endereco) {
							endereco = procurarTipoEndereco(
								resposta.results,
								'administrative_area_level_1'
							)
						}
						if (tipo == 'de') {
							this.form.nome_estado_de = procurarTipoEndereco(
								endereco.address_components,
								'administrative_area_level_1'
							).short_name.toUpperCase()
							this.blurCarregaCidades('de', false)
							this.form.nome_cidade_de = procurarTipoEndereco(
								endereco.address_components,
								'administrative_area_level_2'
							).long_name.toUpperCase()
						} else {
							this.form.nome_estado_para = procurarTipoEndereco(
								endereco.address_components,
								'administrative_area_level_1'
							).short_name.toUpperCase()
							this.blurCarregaCidades('para', false)
							this.form.nome_cidade_para = procurarTipoEndereco(
								endereco.address_components,
								'administrative_area_level_2'
							).long_name.toUpperCase()
						}
					})
					function procurarTipoEndereco(enderecos, tipo) {
						return enderecos.find((endereco) => endereco.types.includes(tipo))
					}
					if (tipo == 'de') {
						this.form.lat_inicio = ConvertDEGToDMS(lat, true)
						this.form.lng_inicio = ConvertDEGToDMS(lng, false)
					} else {
						this.form.lat_fim = ConvertDEGToDMS(lat, true)
						this.form.lng_fim = ConvertDEGToDMS(lng, false)
					}
				} else {
					window.bus.$emit('exibir-notificacao', {
						type: 'danger',
						text: this._traducao('global', 'nenhumaPosicaoEncontrada')
					})
				}
			}
		},

		abrirCadastroPassageiro(index) {
			this.$refs.formCadastroPassageiro.modalShow(80)
			this.indexCadastro = index
			this.$refs.componenteCadastroPassageiro.limpar()
		},

		carregarPassageiroRecemSalvo(passageiro) {
			this.$refs.formCadastroPassageiro.modalHide()
			passageiro.id_passageiro = passageiro.id
			this.carregarPassageiro(passageiro, this.indexCadastro)
		},
		buscaServeSide(search) {
			this.search = search
		},
		async onOpen() {
			if (this.hasNextPage) {
				await this.$nextTick()
				this.observer.observe(this.$refs.loadPassageiro[0])
			}
		},
		onClose() {
			this.observer.disconnect()
		},

		async getPassageiros() {
			const retorno = await new Promise((resolve) => {
				const page = Number(this.listaPassageiros.pagination.page) + 1
				const rota = this.search
					? `/Passageiro/lista?page=${page}&search=${this.search}`
					: `/Passageiro/lista?page=${page}`
				this._axios(rota, 'get', {
					callback: (retorno) => {
						if (retorno._request && retorno._status) {
							retorno.lista.map((passageiro, index) => {
								passageiro.id_passageiro = passageiro.id
								passageiro.orgao = passageiro.id_orgao_apoiado
								passageiro.peso = parseFloat(passageiro.peso, 2)
								return passageiro
							})

							resolve(retorno)
						}
					}
				})
			})
			this.listaPassageiros.lista = [
				...this.listaPassageiros.lista,
				...retorno.lista
			].map((item, index) => ({
				...item,
				_index: index
			}))
			this.listaPassageiros.pagination = retorno.pagination
		},

		async infiniteScroll([{isIntersecting, target}]) {
			if (isIntersecting) {
				const ul = target.offsetParent
				const scrollTop = target.offsetParent.scrollTop
				const retorno = await new Promise((resolve) => {
					const page = Number(this.listaPassageiros.pagination.page) + 1
					const rota = this.search
						? `/Passageiro/lista?page=${page}&search=${this.search}`
						: `/Passageiro/lista?page=${page}`
					this._axios(rota, 'get', {
						callback: (retorno) => {
							if (retorno._request && retorno._status) {
								retorno.lista.map((passageiro, index) => {
									passageiro.id_passageiro = passageiro.id
									passageiro.orgao = passageiro.id_orgao_apoiado
									passageiro.peso = parseFloat(passageiro.peso, 2)
									passageiro._index = index
									return passageiro
								})

								resolve(retorno)
							}
						}
					})
				})
				this.listaPassageiros.lista = [
					...this.listaPassageiros.lista,
					...retorno.lista
				]
				this.listaPassageiros.pagination = retorno.pagination
				await this.$nextTick()
				ul.scrollTop = scrollTop
			}
		},

		validarCPF(cpf, index) {
			if (cpf) {
				this._httpGet('/Usuario/validador_de_cpf/' + cpf, (retorno) => {
					if (retorno.status == 'error') {
						this.form.passageiro[index].cpfErro = this._traducao(
							'global',
							'cpfInvalido'
						)
					} else {
						this.form.passageiro[index].cpfErro = ''
					}
				})
			} else if (cpf == '') {
				this.form.passageiro[index].cpfErro = this._traducao(
					'global',
					'cpfInvalido'
				)
			} else {
				this.form.passageiro[index].cpfErro = ''
			}
		},

		parametros() {
			this._getParametro(3).then((valor) => {
				if (Number(valor)) {
					this.exibeOutro = Number(valor)
					this._getParametro(4).then((val) => {
						if (typeof val === 'string') {
							this.nomeOutroDocumento = val.capitalizeFirst()
						}
					})
				}
			})
			this._getParametro(88).then((valor) => (this.exibeNp = valor))
			this._getParametro(78).then(
				(valor) => (this.exibeObjetivosMissao = valor)
			)
			this._getParametro(18).then(
				(valor) => (this.numeroOcorrenciaSamu = valor)
			)

			this._getParametro(156).then(
				(valor) => (this.permitirDiarioMaior = valor)
			)

			this._getParametro(19).then((valor) => (this.numeroOcorrencia193 = valor))

			this._getParametro(20).then(
				(valor) => (this.form.ocorrencia193Obrigatoria = valor == 1)
			)

			this._getParametro(23).then(
				(valor) => (this.validaVfr = Boolean(Number(valor)))
			)

			this._getParametro(27).then(
				(valor) => (this.homologadoAnac = Number(valor) == 1)
			)
			this._getParametro(28).then((valor) => (this.labelTipoMissao = valor))
			this._getParametro(29).then(
				(valor) => (this.habilitaDescMissao = Number(valor) == 1)
			)
			this._getParametro(30).then((valor) => (this.labelDescMissao = valor))
			this._getParametro(31).then(
				(valor) => (this.vincularLista = Number(valor) == 1)
			)
			this._getParametro(22).then((valor) => (this.exibeRedsSamu = valor))

			this._getParametro(40).then(
				(valor) => (this.disablePaxPob = Boolean(Number(valor)))
			)

			this._getParametro(42).then(
				(valor) => (this.enableCargo = Boolean(Number(valor)))
			)

			this._getParametro(43).then(
				(valor) => (this.enableOrgao = Boolean(Number(valor)))
			)

			this._getParametro(47).then(
				(valor) => (this.passCpfObrigatorio = Boolean(Number(valor)))
			)

			this._getParametro(48).then(
				(valor) => (this.mostraDadosMotor = Number(valor) === 1)
			)

			this._getParametro(49).then(
				(valor) => (this.mostraVor = Number(valor) === 1)
			)
			this._getParametro(66).then((valor) => (this.centrodeCusto = valor))

			this._getParametro(70).then(
				(valor) => (this.labelPassageiro = Boolean(Number(valor)))
			)

			this._getParametro(75).then(
				(valor) => (this.habilitaPerformanceMotor = Boolean(Number(valor)))
			)

			this._getParametro(84).then(
				(valor) => (this.habilitaOleoLubrificante = valor)
			)

			this._getParametro(89).then(
				(valor) => (this.exibeContextoOperativo = Number(valor) == 1)
			)

			this._getParametro(90).then(
				(valor) => (this.exibeClassificacao = Number(valor) == 1)
			)

			this._getParametro(91).then(
				(valor) => (this.habilitaPartida = Number(valor) == 1)
			)
			this._getParametro(94).then(
				(valor) => (this.exibeAssinaturaMecanico = Number(valor) == 1)
			)

			this._getParametro(110).then(
				(valor) => (this.dbComercial = Number(valor) == 1)
			)
			this._getParametro(117).then(
				(valor) => (this.horasDeAcionamentoCorte = valor)
			)
			this._getParametro(116).then(
				(valor) => (this.labelTempoAcionamentoCorte = valor)
			)
			this._getParametro(122).then(
				(valor) => (this.exibeFinalizarOrdemMissao = valor)
			)

			this._getParametro(145).then((valor) => (this.tripulacaoTecnica = valor))

			this._getParametro(146).then((valor) => (this.limiteApresentacao = valor))

			this._getParametro(147).then(
				(valor) => (this.calculaParamAcionamentoCorte = valor)
			)
			this._getParametro(179).then(
				(valor) => (this.parametroTipoPassageiro = Number(valor) == 1)
			)
		},

		exibeOrgaoPassageiro() {
			this.clickImportaPassageiros()
			for (let i = 0; i < this.form.passageiro.length; i++) {
				this.form.passageiro[i].orgao =
					this.form.passageiro[i].orgao == this.passageirosSelecao[i].orgao &&
					this.passageirosSelecao[i].orgao != null
						? this.passageirosSelecao[i].sigla_orgao
						: _traducao('global', 'naoInformado')
			}
			if (!Boolean(Number(this.disablePaxPob))) {
				this.form.pax =
					this.form.passageiro < Number(this.qtdEstPassageiros)
						? Number(this.qtdEstPassageiros)
						: this.form.passageiro.length
				this.form.pob = Number(this.form.pax) + this.form.tripulacao.length
			}

			if (this.cargas[0]) {
				this._exibeModal('modal-ordem-escolha-cargas', 70)
			}
		},

		abreModalOap() {
			this.$refs.orgaosApoiadosModal.modalShow(80)
			this.atualizaModal++
		},

		removePass(item, index, qtd) {
			this.form.passageiro.splice(index, 1)
			if (this.form.passageiro.length >= Number(this.form.pax)) {
				this.form.pax = this.form.passageiro.length
			} else {
				this.form.pax--
			}
			this.form.pob = this.form.pax + this.form.tripulacao.length
		},

		carregaHorimetroApu() {
			this._axios('Apu/get_horimetro_by_aeronave/' + this.aeronave.id, 'get', {
				callback: (retorno) => {
					if (retorno._request && retorno._status) {
						if (retorno.data && retorno.data.horimetro_final_apu) {
							const horimetro = parseFloat(
								retorno.data.horimetro_final_apu
							).toFixed(1)
							this.form.horimetro_inicial_apu = horimetro
							this.form.horimetro_final_apu = horimetro
						}
					}
				}
			})
		},

		inveterPilotoCopiloto() {
			let stringSegundoEmComando = 'SEGUNDO EM COMANDO'
			const piloto = _.find(
				this.form.tripulacao,
				(o) => o.funcao.toUpperCase() == 'PILOTO EM COMANDO'
			)
			const copiloto = _.find(
				this.form.tripulacao,
				(o) =>
					o.funcao.toUpperCase().substring(0, stringSegundoEmComando.length) ==
					stringSegundoEmComando
			)

			const dadosPiloto = Object.assign({}, piloto)

			piloto.id_usuario = copiloto.id_usuario
			piloto.erroUsuario = copiloto.erroUsuario
			piloto.anac = copiloto.anac
			piloto.codigo_ovn = copiloto.codigo_ovn
			piloto.erroOVN = copiloto.erroOVN
			piloto.trigrama = copiloto.trigrama
			piloto.load = copiloto.load
			piloto.usuarios = copiloto.usuarios
			piloto.nome = copiloto.nome

			copiloto.id_usuario = dadosPiloto.id_usuario
			copiloto.erroUsuario = dadosPiloto.erroUsuario
			copiloto.anac = dadosPiloto.anac
			copiloto.codigo_ovn = dadosPiloto.codigo_ovn
			copiloto.erroOVN = dadosPiloto.erroOVN
			copiloto.trigrama = dadosPiloto.trigrama
			copiloto.load = dadosPiloto.load
			copiloto.usuarios = dadosPiloto.usuarios
			copiloto.nome = dadosPiloto.nome

			this.$forceUpdate()
		},

		async preencherDiario(data) {
			// se não tiver carregando chama a função que verifica se todas as listas foram carregadas
			if (!this.load) {
				this.editar = false
				this.preencher = true
				if (this.fusoHorario == 'UTC') {
					this.form.acionamento = data.trecho._dataAcionamentoUTC
					this.form.corte = data.trecho._dataCorteUTC
					if (data.trecho.gerado_pelo_service) {
						this.form.decolagem = this._SQLDateToDateTime(
							data.trecho.decolagem_utc,
							$sessao.getDateFormat() + ' HH:MM'
						)
						this.form.pouso = this._SQLDateToDateTime(
							data.trecho.pouso_utc,
							$sessao.getDateFormat() + ' HH:MM'
						)
					}
				} else {
					this.form.acionamento = data.trecho._dataAcionamento
					this.form.corte = data.trecho._dataCorte
					this.form.despacho_emergencial = data.trecho.despacho_emergencial
					if (data.trecho.gerado_pelo_service) {
						this.form.decolagem = this._SQLDateToDateTime(
							data.trecho.decolagem,
							$sessao.getDateFormat() + ' HH:MM'
						)
						this.form.pouso = this._SQLDateToDateTime(
							data.trecho.pouso,
							$sessao.getDateFormat() + ' HH:MM'
						)
					}
				}

				if (data.trecho.trecho_motor.length == 1) {
					this.id_motor_esquerdo = data.trecho.trecho_motor[0].id_motor
					this.sn_motor_esquerdo = data.trecho.trecho_motor[0].serial_number
					this.form.quantidadeMotores = 1
				} else if (data.trecho.trecho_motor.length == 2) {
					this.form.quantidadeMotores = 2
					this.id_motor_esquerdo = data.trecho.trecho_motor[1].id_motor
					this.sn_motor_esquerdo = data.trecho.trecho_motor[1].serial_number
					this.id_motor_direito = data.trecho.trecho_motor[0].id_motor
					this.sn_motor_direito = data.trecho.trecho_motor[0].serial_number
				}

				// seta true pra atualizar as datas
				this.mostraacionamentoUTC = true
				this.decolagemUTC = true
				this.pousoUTC = true
				this.corteUTC = true
				this.assinar = data.assinar
				this.aeronave = data.aero
				this.trecho = data.trecho

				if (this.aeronave.id_relacao_combustivel) {
					this.form.unidade_combustivel = this.relacoesCombustivel.find(
						(relacao) => relacao.id == this.aeronave.id_relacao_combustivel
					).descricao
				}
				this.relacao_abastecimento = this.aeronave.relacao_abastecimento
				this.form.trecho_motor = data.trecho.trecho_motor.map((item) => {
					item.erro_ciclo_nf = ''
					item.erro_ciclo_ng = ''
					item.erro_ciclo_np = ''
					item.ciclo_ng = this.toNumber2Casa(item.ciclo_ng)
					item.ciclo_nf = this.toNumber2Casa(item.ciclo_nf)
					if (
						item.tipo_aeronave == '1' &&
						this.preenchimentoAutomaticoCicloAsaFixa
					) {
						item.ciclo_nf = this.toNumber2Casa(1)
					}
					item.ciclo_np = this.toNumber2Casa(item.ciclo_np)
					return item
				})

				this.carregaHorimetro()
				this.carregaHorimetroApu()

				this.iniciaVerificacaoFechamento()
				this.carregaDisponibilidade()

				if (data.trechoCopiar != null) {
					this.itemCopiar = data.trechoCopiar
					this.getDadosEdicao(data.trechoCopiar, true) // false pra copiar
				}

				this.calculaTempoDeVooPiloto()
				this.calculaTempoManutencao()
				if (this.trecho.id_despacho_emergencial) {
					this.carregaDadosDb()
				}
				if (
					this.aeronave.gera_trecho_programacao == '1' &&
					this.form.despacho_emergencial
				) {
					const trecho = {
						id_rotaer_origem: data.trecho.id_rotaer_origem,
						id_rotaer_destino: data.trecho.id_rotaer_destino
					}
					this.$refs.origemVoo.validaDespacho(
						false,
						this.form.despacho_emergencial,
						trecho
					)
				}
			} else {
				this.editar = false
				this.preencher = true

				this.aeronave = data.aero
				this.trecho = data.trecho

				if (this.fusoHorario == 'UTC') {
					this.form.acionamento = data.trecho._dataAcionamentoUTC
					this.form.corte = data.trecho._dataCorteUTC
					this.form.decolagem = this._SQLDateToDateTime(
						data.trecho.decolagem_utc,
						$sessao.getDateFormat() + ' HH:MM'
					)
					this.form.pouso = this._SQLDateToDateTime(
						data.trecho.pouso_utc,
						$sessao.getDateFormat() + ' HH:MM'
					)
				} else {
					this.form.acionamento = data.trecho._dataAcionamento
					this.form.corte = data.trecho._dataCorte
					this.form.decolagem = this._SQLDateToDateTime(
						data.trecho.decolagem,
						$sessao.getDateFormat() + ' HH:MM'
					)
					this.form.pouso = this._SQLDateToDateTime(
						data.trecho.pouso,
						$sessao.getDateFormat() + ' HH:MM'
					)
				}

				this.form.despacho_emergencial = data.trecho.despacho_emergencial
				this.mostraacionamentoUTC = true
				this.decolagemUTC = true
				this.pousoUTC = true
				this.corteUTC = true
				this.assinar = data.assinar
				this.aeronave = data.aero
				this.trecho = data.trecho

				if (this.aeronave.id_relacao_combustivel) {
					this.form.unidade_combustivel = this.relacoesCombustivel.find(
						(relacao) => relacao.id == this.aeronave.id_relacao_combustivel
					).descricao
				}
				this.form.abastecimentoCombustivel.map(
					(item) =>
						(item.relacao_abastecimento = this.aeronave.relacao_abastecimento)
				)
				this.carregaHorimetro()
				this.carregaHorimetroApu()

				if (data.trecho.trecho_motor.length == 1) {
					this.id_motor_esquerdo = data.trecho.trecho_motor[0].id_motor
					this.sn_motor_esquerdo = data.trecho.trecho_motor[0].serial_number
					this.form.quantidadeMotores = 1
				} else if (data.trecho.trecho_motor.length == 2) {
					this.form.quantidadeMotores = 2
					this.id_motor_esquerdo = data.trecho.trecho_motor[1].id_motor
					this.sn_motor_esquerdo = data.trecho.trecho_motor[1].serial_number
					this.id_motor_direito = data.trecho.trecho_motor[0].id_motor
					this.sn_motor_direito = data.trecho.trecho_motor[0].serial_number
				}

				this.form.trecho_motor = data.trecho.trecho_motor.map((item) => {
					item.erro_ciclo_nf = ''
					item.erro_ciclo_ng = ''
					item.erro_ciclo_np = ''
					item.ciclo_ng = this.toNumber2Casa(item.ciclo_ng)
					item.ciclo_nf = this.toNumber2Casa(item.ciclo_nf)
					item.ciclo_np = this.toNumber2Casa(item.ciclo_np)
					return item
				})

				this._httpGet(
					`Aeronave/get_dados_oleo_lubrificante/${this.trecho.id_aeronave}`,
					(response) => {
						if (response._request && response._status) {
							this.dadosOleoLubrificante = response.lista
						}
					}
				)

				if (this._idCliente == 62 && this.form.despacho_emergencial) {
					const trecho = {
						id_rotaer_origem: data.trecho.id_rotaer_origem,
						id_rotaer_destino: data.trecho.id_rotaer_destino
					}
					this.$refs.origemVoo.validaDespacho(
						false,
						this.form.despacho_emergencial,
						trecho
					)
				}

				this.preenchimentoAutomaticoHouveAbastecimento()

				bus.$emit('load-in', {
					text: this._traducao('global', 'carregandoListas')
				})
				this.carregando(data, 'preencherDiario') // função que verivica se todas as listas foram carregadas
				window.bus.$emit('load-out')
			}
		},

		carregando(data, funcao) {
			// seta um timeout de 1 segundo pra ficar verificando se todas as listas foram carregadas
			setTimeout(() => {
				if (
					this.basesOperacao.length > 0 &&
					this.bases.length > 0 &&
					this.tiposDeMissoes.length > 0 &&
					this.tiposDeNaturezas.length > 0 &&
					this.descricoes.length > 0 &&
					this.unidadesConservacao.length > 0 &&
					this.contextos.length > 0 &&
					this.orgaos.length > 0 &&
					this.estados.length > 0 &&
					this.rotaER.length > 0 &&
					this.pilotos.length > 0 &&
					this.aeronaves.length > 0 &&
					this.subclassificacoes.length > 0 &&
					this.mecanicos.length > 0
				) {
					this.load = false
					this[funcao](data) // caso sim, chama a função
				} else {
					this.carregando(data, funcao)
				}
			}, 1000)
		},

		avisoObrigatorio(data) {
			data = data.filter((item) => item.length == 0)
		},

		editarDiarioDeBordo(data) {
			if (!this.load) {
				this.aeronave = data.aero
				this.trecho = data.trecho
				if (this.fusoHorario == 'UTC') {
					this.form.acionamento = data.trecho._dataAcionamentoUTC
					this.form.corte = data.trecho._dataCorteUTC
				} else {
					this.form.acionamento = data.trecho._dataAcionamento
					this.form.corte = data.trecho._dataCorte
				}

				this.editar = !data.trecho.bloqueado_editar
				this.assinar = data.assinar
				//this.carregaDisponibilidade()
				if (data.trecho.trecho_motor.length == 1) {
					this.id_motor_esquerdo = data.trecho.trecho_motor[0].id_motor
					this.sn_motor_esquerdo = data.trecho.trecho_motor[0].serial_number
					this.form.quantidadeMotores = 1

					if (data.trecho.trecho_motor[0].data != null) {
						data.trecho.trecho_motor[0].data = new moment(
							data.trecho.trecho_motor[0].data
						).format('DD/MM/YYYY HH:mm')
					} else {
						data.trecho.trecho_motor[0].data = null
					}

					this.form.horario_performance_motor = data.trecho.trecho_motor[0].data
					this.form.performance_fl = data.trecho.trecho_motor[0].fl
					this.form.performance_tat = data.trecho.trecho_motor[0].tat
					this.form.performance_ias = data.trecho.trecho_motor[0].ias
					this.form.performance_tas = data.trecho.trecho_motor[0].tas
					this.form.performance_boost = data.trecho.trecho_motor[0].boost

					this.form.performance_torque_esq = parseFloat(
						data.trecho.trecho_motor[0].tq
					).toFixed(1)
					this.form.performance_np_esq = parseFloat(
						data.trecho.trecho_motor[0].np
					).toFixed(1)
					this.form.performance_itt_esq = data.trecho.trecho_motor[0].itt
					this.form.performance_nh_esq = parseFloat(
						data.trecho.trecho_motor[0].nh
					).toFixed(1)
					this.form.performance_flow_esq = data.trecho.trecho_motor[0].fuel_flow
					this.form.performance_nl_esq = data.trecho.trecho_motor[0].nl
				} else if (data.trecho.trecho_motor.length == 2) {
					this.form.quantidadeMotores = 2
					this.id_motor_esquerdo = data.trecho.trecho_motor[1].id_motor
					this.sn_motor_esquerdo = data.trecho.trecho_motor[1].serial_number
					this.id_motor_direito = data.trecho.trecho_motor[0].id_motor
					this.sn_motor_direito = data.trecho.trecho_motor[0].serial_number

					if (data.trecho.trecho_motor[1].data != null) {
						data.trecho.trecho_motor[1].data = new moment(
							data.trecho.trecho_motor[1].data
						).format('DD/MM/YYYY HH:mm')
					} else {
						data.trecho.trecho_motor[1].data = null
					}

					this.form.horario_performance_motor = data.trecho.trecho_motor[1].data
					this.form.performance_fl = data.trecho.trecho_motor[1].fl
					this.form.performance_tat = data.trecho.trecho_motor[1].tat
					this.form.performance_ias = data.trecho.trecho_motor[1].ias
					this.form.performance_tas = data.trecho.trecho_motor[1].tas
					this.form.performance_boost = data.trecho.trecho_motor[1].boost

					this.form.performance_torque_esq = parseFloat(
						data.trecho.trecho_motor[1].tq
					).toFixed(1)
					this.form.performance_np_esq = parseFloat(
						data.trecho.trecho_motor[1].np
					).toFixed(1)
					this.form.performance_itt_esq = data.trecho.trecho_motor[1].itt
					this.form.performance_nh_esq = parseFloat(
						data.trecho.trecho_motor[1].nh
					).toFixed(1)
					this.form.performance_flow_esq = data.trecho.trecho_motor[1].fuel_flow
					this.form.performance_nl_esq = data.trecho.trecho_motor[1].nl

					this.form.performance_torque_dir = parseFloat(
						data.trecho.trecho_motor[0].tq
					).toFixed(1)
					this.form.performance_np_dir = parseFloat(
						data.trecho.trecho_motor[0].np
					).toFixed(1)
					this.form.performance_itt_dir = data.trecho.trecho_motor[0].itt
					this.form.performance_nh_dir = parseFloat(
						data.trecho.trecho_motor[0].nh
					).toFixed(1)
					this.form.performance_flow_dir = data.trecho.trecho_motor[0].fuel_flow
					this.form.performance_nl_dir = data.trecho.trecho_motor[0].nl
				}
				this.form.hora_vfr = data.trecho.hora_vfr
				this.form.hora_ifr = data.trecho.hora_ifr
				this.getDadosEdicao(this.trecho, false) // false pra copiar

				if (this.visualizar) {
					bus.$emit('load-in', {
						text: this._traducao('global', 'carregandoDiario')
					})
				} else {
					this.iniciaVerificacaoFechamento()
				}
			} else {
				bus.$emit('load-in', {
					text: this._traducao('global', 'carregandoListas')
				})
				this.carregando(data, 'editarDiarioDeBordo')
				window.bus.$emit('load-out')
			}
		},

		carregaHistorico(data) {
			if (!this.load) {
				this.aeronave = data.aeronave
				this.trecho = data.trecho
				if (this.fusoHorario == 'UTC') {
					this.form.acionamento = this._SQLDateToDateTime(
						data.trecho.acionamento_utc,
						$sessao.getDateFormat() + ' HH:MM'
					)
					this.form.corte = this._SQLDateToDateTime(
						data.trecho.corte_utc,
						$sessao.getDateFormat() + ' HH:MM'
					)
				} else {
					this.form.acionamento = this._SQLDateToDateTime(
						data.trecho.acionamento,
						$sessao.getDateFormat() + ' HH:MM'
					)
					this.form.corte = this._SQLDateToDateTime(
						data.trecho.corte,
						$sessao.getDateFormat() + ' HH:MM'
					)
				}

				this.editar = true
				this.assinar = false
				this.carregaDadosEdicao(data.trecho, false)
			} else {
				bus.$emit('load-in', {text: 'Carregando listas'})
				this.carregando(data, 'carregaHistorico')
			}
		},

		carregaDisponibilidade() {
			let url = 'Disponibilidade/get_ultima_by_data/' + this.aeronave.id
			if (this.form.acionamento) {
				url +=
					'/' +
					this._dateTimeToDateSQL(
						this.form.acionamento,
						$sessao.getDateFormat() + ' HH:MM:SS'
					).split(' ')[0]
			}
			this._httpGet(url, (retorno) => {
				//.log("disponibilidade", retorno)
				if (retorno._status && retorno._request) {
					this.form.ultima_intervencao = retorno.lista.data_ultima
					this.form.proxima_intervencao = retorno.lista.data_proxima
					this.form.horimetro_proxima = retorno.lista.horimetro_proxima
					this.form.id_responsavel_retorno =
						retorno.lista.id_usuario_responsavel
					this.form.nome_usuario_retorno =
						retorno.lista.nome_usuario_responsavel
					this.form.descricao_ultima_inspecao = retorno.lista.descricao_ultima
					this.form.descricao_proxima_inspecao = retorno.lista.descricao
					this.form.codigo_anac_usuario_retorno =
						retorno.lista.codigo_anac_usuario_retorno
				}
			})
		},

		despachoSelecionado(despacho) {
			this.form.tipo_voo = despacho.tipo

			this._axios(
				`Motor_aeronave/get_by_aeronave/${this.trecho.id_aeronave}`,
				'get',
				{
					callback: ({lista}) => {
						if (lista) {
							this.form.monitoramento_motor = []
							for (let elem of lista) {
								this.form.monitoramento_motor.push({
									altitude: '',
									oat: '',
									ias: '',
									rpm: '',
									ng: '',
									id_motor: elem.id_motor,
									nl: '',
									fuel_flow: '',
									itt: '',
									tq: '',
									abastecimento_oleo: '',
									serial_number: elem.serial_number,
									descricao: elem.descricao
								})
							}
						}
					}
				}
			)

			bus.$emit('load-in', {text: this._traducao('global', 'carregando')})

			// CARREGA O DESPACHO PARA A EDICAO
			this._httpGet(
				'mg-siga/Despacho_emergencial/get/' + despacho.id,
				async (retorno) => {
					if (retorno._request && retorno._status) {
						bus.$emit('load-out')
						this.despacho = retorno.lista
						if (
							this.dbComercial &&
							this.despacho.aeronave[0].trecho.length == 1
						) {
							this.form.de_select = await this.fetchRotaer(
								this.despacho.aeronave[0].trecho[0].id_rotaer_origem
							)
							this.form.para_select = await this.fetchRotaer(
								this.despacho.aeronave[0].trecho[0].id_rotaer_destino
							)
						} else if (
							this.dbComercial &&
							this.despacho.aeronave[0].trecho.length > 1
						) {
							this.form.de_select = await this.fetchRotaer(
								this._isset(despacho.trechoMultiplo)
									? despacho.trechoMultiplo.id_rotaer_origem
									: despacho.trecho.id_rotaer_origem
							)
							this.form.para_select = await this.fetchRotaer(
								this._isset(despacho.trechoMultiplo)
									? despacho.trechoMultiplo.id_rotaer_destino
									: despacho.trecho.id_rotaer_destino
							)
						}

						this.form.numero_bo = retorno.lista.reds
						this.form.numero_chamada = retorno.lista.chamada
						this.form.numero_atividade = retorno.lista.atividade
						this.form.observacao = retorno.lista.historico
						this.form.tripulacao = retorno.lista.aeronave[0].tripulacao.map(
							(item, idx) => {
								;(item.erroUsuario = ''),
									(item.erroApresentacao = ''),
									(item.erroIdOvn = '')
								item.uso_ovn = false
								this.form.id == 0 ? (item.apresentacao = '') : item.apresentacao
								this.carregaUsuariosTripulacao(item.funcao, idx, false, true)
								return item
							}
						)

						for (var i = 0; i < this.despacho.aeronave[0].trecho.length; i++) {
							this.despacho.aeronave[0].trecho[i].selecionado = false
						}
						this.trechosModal = this.despacho.aeronave[0].trecho

						if (
							(this._idCliente != 62 &&
								this.despacho.aeronave[0].trecho.length > 1) ||
							(despacho.showTrechos &&
								this.despacho.aeronave[0].trecho.length > 1)
						) {
							this._exibeModal('modal-escolha-trecho', 70)
						}

						this.form.pob = this.calculoDePob
						this.form.pax = this.calculoDePax
						if (retorno.lista.aeronave[0].tripulacao.length) {
							this.form.voo_instrucao =
								retorno.lista.aeronave[0].tripulacao[0].funcao.toLowerCase() ==
								'piloto em comando'
									? '0'
									: '1'
						} else {
							this.form.voo_instrucao = '0'
						}
						// se não tiver editando importa os dados
						if (!this.edicao) {
							// se existir ordem, carrega os dados da ordem, tripulação, passageiros e orgão apoiados
							if (
								despacho.id_ordem_missao != null &&
								despacho.id_ordem_missao != '0'
							) {
								bus.$emit('load-in', {
									text: this._traducao('global', 'carregando')
								})

								// CARREGA O DESPACHO PARA A EDICAO
								this._httpGet(
									'mg-siga/Ordem_missao/editar/' + despacho.id_ordem_missao,
									(retorno) => {
										if (retorno._request) {
											bus.$emit('load-out')
											this.carregaCamposOrdem(retorno, false)
											this.qtdEstPassageiros =
												retorno.aeronave[0].quantidade_estimada_passageiros
										}
									}
								)
							} else {
								// caso não tenha ordem, importa os dados do despacho

								retorno.lista.aeronave = retorno.lista.aeronave.map((item) => {
									item._aero = _.find(this.aeronaves, (o) => {
										return o.id == item.id_aeronave
									})

									return item
								})

								var aero = _.find(retorno.lista.aeronave, (o) => {
									return o.id_aeronave == this.aeronave.id
								})
								this.form.houve_contexto = this.validaNull(
									despacho.houve_contexto
								)

								if (_.isNil(aero)) {
									this.aerosImport = retorno.lista.aeronave
									this.$refs.modalAero.modalShow(50)
								} else {
									this.aeronave_import = aero
									this.form.base = aero.base ? aero.base : aero.base_aeronave
									this.carregaDadosAero(null, despacho.showTrechos)
								}

								if (this.form.houve_contexto != '0') {
									for (var i in this.contextos) {
										if (
											this.contextos[i].id == despacho.id_contexto_operativo
										) {
											this.form.contexto_operativo = this.contextos[i]
										}
									}
								}
								if (retorno.lista.orgao.length > 0) {
									this.form.orgao[0].orgao = _.find(this.orgaos, (o) => {
										return o.id == retorno.lista.orgao[0].id_orgao_apoiado
									})
								}
							}

							this.form.tipo_missao = _.find(this.tiposDeMissoes, (o) => {
								return o.id == retorno.lista.id_tipo_missao
							})
							this.form.descricao = retorno.lista.ordem_descricao ?? ''
							if (this._idCliente != 41) {
								this.form.subclassificacao =
									despacho.id_subclassificacao != null
										? this.getSubclassificacaoById(despacho.id_subclassificacao)
										: ''

								this.form.classificacao =
									despacho.id_classificacao != null
										? this.getClassificacaoById(despacho.id_classificacao)
										: ''
							}
						}

						this.setLiberarEncerrarProg(despacho.id, this.trecho.id)
						this.setQtdProgramacoesValidas(despacho.id)
					}
				}
			)
		},

		setaAcionamento(val) {
			if (this.form.acionamento != val) {
				this.clearTemposAcionamentoCorte()
			}
			this.form.acionamento = val
			if (this.fusoHorario == 'UTC') {
				this.form.acionamento_utc = val

				this.calculaTempoDeVooPiloto()
				this.calculaTempoManutencao()
				this.calculaTotal()
			} else {
				if (val != '') {
					if (this.mostraacionamentoUTC && !this.edicao) {
						this.converteDataUTC(this.form.acionamento).then((res) => {
							this.form.acionamento_utc = res
							this.mostraacionamentoUTC = true
							this.$forceUpdate()
						})
					} else {
						this.mostraacionamentoUTC = true
					}

					this.calculaTempoDeVooPiloto()
					this.calculaTempoManutencao()
					this.calculaTotal()
				}
			}
		},

		setaDecolagem(val) {
			if (this.form.decolagem != val) {
				this.clearTemposDecolagemPouso()
			}
			this.form.decolagem = val
			if (this.fusoHorario == 'UTC') {
				this.form.decolagem_utc = val

				this.calculaTempoDeVooPiloto()
				this.calculaTempoManutencao()
				this.calculaTotal()
			} else {
				if (val != '') {
					if (this.decolagemUTC && !this.edicao) {
						this.converteDataUTC(this.form.decolagem).then((res) => {
							this.form.decolagem_utc = res
							this.decolagemUTC = true
							this.$forceUpdate()
						})
					} else {
						this.decolagemUTC = true
					}

					this.calculaTempoDeVooPiloto()
					this.calculaTempoManutencao()
					this.calculaTotal()
				}
			}
		},

		setaPouso(val) {
			if (this.form.pouso != val) {
				this.clearTemposDecolagemPouso()
			}
			this.form.pouso = val
			if (this.fusoHorario == 'UTC') {
				this.form.pouso_utc = val

				this.calculaTempoDeVooPiloto()
				this.calculaTempoManutencao()
				this.calculaTotal()
			} else {
				if (val != '') {
					if (this.pousoUTC && !this.edicao) {
						this.converteDataUTC(this.form.pouso).then((res) => {
							this.form.pouso_utc = res
							this.pousoUTC = true
							this.$forceUpdate()
						})
					} else {
						this.pousoUTC = true
					}

					this.calculaTempoDeVooPiloto()
					this.calculaTempoManutencao()
					this.calculaTotal()
				}
			}
		},

		setaCorte(val) {
			if (this.form.corte != val) {
				this.clearTemposAcionamentoCorte()
			}
			this.form.corte = val
			if (this.fusoHorario == 'UTC') {
				this.form.pouso_utc = val

				this.calculaTempoDeVooPiloto()
				this.calculaTempoManutencao()
				this.calculaTotal()
			} else {
				if (val != '') {
					if (this.corteUTC && !this.edicao) {
						this.calculaTempoDeVooPiloto()

						this.converteDataUTC(this.form.corte).then((res) => {
							this.form.corte_utc = res
							this.corteUTC = true
							this.$forceUpdate()
						})
						this.calculaTempoVooOrgao()
					} else {
						this.corteUTC = true
					}

					this.calculaTempoDeVooPiloto()
					this.calculaTempoManutencao()
					this.calculaTotal()
				}
			}
		},

		//recebe data utc
		converteDataUTC(data) {
			return new Promise((resolve) => {
				var dataRetorno
				data = this._dateTimeToDateSQL(
					data,
					$sessao.getDateFormat() + ' HH:MM:SS'
				)
				data = data + ':00'

				var dataEnvio = {
					data: data,
					id_aeronave: this.aeronave.id
				}
				this.mostraUTC = true
				// return data
				this._httpPost('Servico/converte_utc', dataEnvio, (resposta) => {
					dataRetorno = this._SQLDateToDateTime(
						resposta['data'],
						$sessao.getDateFormat() + ' HH:MM'
					)
					resolve(dataRetorno)
				})
			})
		},

		calculaIdade(ano_aniversario, mes_aniversario, dia_aniversario) {
			var d = new Date(),
				ano_atual = d.getFullYear(),
				mes_atual = d.getMonth() + 1,
				dia_atual = d.getDate(),
				ano_aniversario = +ano_aniversario,
				mes_aniversario = +mes_aniversario,
				dia_aniversario = +dia_aniversario,
				idade = ano_atual - ano_aniversario

			if (
				mes_atual < mes_aniversario ||
				(mes_atual == mes_aniversario && dia_atual < dia_aniversario)
			) {
				idade--
			}

			return idade < 0 ? 0 : idade
		},

		alteraIdade(dataNascimento) {
			var dia = dataNascimento.substring(0, 2)
			var mes = dataNascimento.substring(3, 5)
			var ano = dataNascimento.substring(6, 10)
			var idade = this.calculaIdade(ano, mes, dia)

			if (dataNascimento != '') {
				this.form.passageiro = this.form.passageiro.map((item) => {
					if (item.data_nascimento == dataNascimento) {
						item.idade_aparente = idade
					}
					return item
				})
			}
		},

		iniciaVerificacaoFechamento() {
			this.limpaTimeOuts()
			this.timeOut = setTimeout(() => {
				this._exibeModal('modal-ordem-tempo-expirado', 60)
			}, 600000)
			//this.timeOut = setTimeout(() => { this._exibeModal('modal-ordem-tempo-expirado', 60)}, 4000);
			this.timeOutModal = setTimeout(() => {
				this.voltaLista()
			}, 660000)
			//this.timeOut = setTimeout(() => { this.voltaLista() },4000);
		},

		clickPrintVisualizar() {
			this._print()
		},

		clickPrint() {
			this.$refs.printDiario.carregaDados({
				data: this.form,
				ovns: this.ovns,
				aero: this.aeronave,
				pilotos: this._pilotos_mecanicos,
				trecho: this.trecho,
				utilizaTrigrama: this.utilizaTrigrama,
				homologadoAnac: this.homologadoAnac,
				labelTipoMissao: this.labelTipoMissao,
				habilitaDescMissao: this.habilitaDescMissao,
				labelDescMissao: this.labelDescMissao,
				labelPassageiro: this.labelPassageiro
			})

			if (this.despacho != '' && this.form.nome_arquivo == '') {
				this.$refs.printDiario.carregaDespacho(this.despacho)
			}

			this.$nextTick(() => {
				window.print()
			})
		},

		getDadosEdicao(trecho, copiar) {
			if (copiar) {
				bus.$emit('load-in', {text: this._traducao('global', 'copiandoDiario')})
			} else {
				bus.$emit('load-in', {
					text: this._traducao('global', 'carregandoDiario')
				})
			}
			this._httpGet(
				'mg-siga/Relatorio_voo_trecho/get/' + trecho.id,
				(response) => {
					bus.$emit('load-out')
					if (response._request) {
						if (copiar) {
							delete response.lista.trecho_motor
						}
						this.carregaDadosEdicao(response.lista, copiar)
					}
				}
			)
		},

		async carregaDadosEdicao(data, copiar) {
			this.form.milhas_navegacao = parseFloat(data.milhas_navegacao).toFixed(1)

			if (!copiar) {
				// se o usuario fez alguma solicitacao de edicao de db
				if (!_.isNil(data.solicitacao_edicao)) {
					this.solicitacaoEdicao = data.solicitacao_edicao
				}

				// motivo da assinatura
				if (!_.isNil(data.solicitacao_edicao_bloqueada)) {
					this.$refs.modalMotivoAssinatura.exibeModal(
						data.solicitacao_edicao_bloqueada
					)
				}
			}

			this.form.id_aeronave_import =
				data.id_aeronave_import == null ? '' : data.id_aeronave_import
			this.form.tipo_voo = data.origem

			// carrega o despacho caso tenha
			if (data.id_despacho_emergencial != null) {
				this._httpGet(
					'mg-siga/Despacho_emergencial/get/' + data.id_despacho_emergencial,
					(retorno) => {
						bus.$emit('load-out')

						if (retorno._request) {
							this.despacho = retorno.lista

							if (this.visualizar) {
								this.$refs.printVisualizar.carregaDespacho(this.despacho)
							}
						}
					}
				)
			}
			this.form.total_ciclo_torque =
				data.total_ciclo_torque == null ? '' : data.total_ciclo_torque
			this.form.total_gancho =
				data.total_gancho == null ? '' : data.total_gancho
			this.form.total_guincho =
				data.total_guincho == null ? '' : data.total_guincho
			this.form.total_partidas =
				data.total_partidas == null ? '' : data.total_partidas
			this.form.total_pousos =
				data.total_pousos == null ? '' : data.total_pousos
			this.form.existe_unidade_conservacao = data.existe_unidade_conservacao

			this.form.horimetro_apu =
				data.horimetro_apu == null ? 0 : data.horimetro_apu
			this.form.horimetro_inicial_apu =
				data.horimetro_inicial_apu == null
					? 0
					: parseFloat(data.horimetro_inicial_apu).toFixed(1)
			this.form.horimetro_final_apu =
				data.horimetro_final_apu == null
					? 0
					: parseFloat(data.horimetro_final_apu).toFixed(1)
			this.form.ciclos_apu = data.ciclos_apu == null ? 0 : data.ciclos_apu

			this.form.volume = this.toNumber1Casa(data.volume)
			if (data.id_tipo_lancamento == 9 || data.id_tipo_lancamento == 10) {
				this.movimentacaoCombustivel.exibeOrigem = true
				this.movimentacaoCombustivel.origem = data.razao_social
				this.movimentacaoCombustivel.original =
					data.id_abastecimento_comprovante
			}

			this.form.verificacao_vor = data.verificacao_vor
			this.form.vor = data.vor
			this.form.radial_vor = data.radial_vor
			this.form.afastamento_vor = data.afastamento_vor
			this.form.erro_vor = data.erro_vor

			// se tiver editando
			if (!copiar) {
				if (!_.isNil(data.numero_diario_anac)) {
					this.form.numero_diario_anac =
						data.numero_diario_anac == ''
							? this.trecho.numero_diario
							: data.numero_diario_anac
				} else {
					this.form.numero_diario_anac = this.trecho.numero_diario
				}

				this.form.id_assinatura_piloto =
					data.id_assinatura_piloto == null ? '' : data.id_assinatura_piloto
				this.form.id_assinatura_mecanico =
					data.id_assinatura_mecanico == null ? '' : data.id_assinatura_mecanico
				this.form.arquivo = data.arquivo == null ? '' : data.arquivo

				this.form.nome_usuario_assinou =
					data.nome_usuario_assinou == null ? '' : data.nome_usuario_assinou
				this.form.nome_mecanico_assinou =
					data.nome_mecanico_assinou == null ? '' : data.nome_mecanico_assinou
				this.form.nome_operador_assinou =
					data.nome_operador_assinou == null ? '' : data.nome_operador_assinou

				this.form.data_assinatura_piloto =
					data.data_assinatura_piloto == null ? '' : data.data_assinatura_piloto
				this.form.data_assinatura_mecanico =
					data.data_assinatura_mecanico == null
						? ''
						: data.data_assinatura_mecanico
				this.form.data_assinatura_operador =
					data.data_assinatura_operador == null
						? ''
						: data.data_assinatura_operador
				this.form.nome_arquivo =
					data.nome_arquivo == null ? '' : data.nome_arquivo

				this.form.id = data.id
				this.form.finalizar_ordem = data.finalizar_ordem
				this.form.id_ordem = data.id_ordem_missao
				this.form.id_despacho = data.id_despacho_emergencial
				this.form.voo_instrucao = data.voo_instrucao
				this.form.finalizar_despacho = data.finalizar_despacho
				this.form.hora_vfr_diurno =
					data.hora_vfr_diurno == null ? '00:00' : data.hora_vfr_diurno
				this.form.hora_vfr_noturno =
					data.hora_vfr_noturno == null ? '00:00' : data.hora_vfr_noturno
				this.form.hora_ifr = data.hora_ifr == null ? '00:00' : data.hora_ifr
				this.form.hora_vfr = data.hora_vfr == null ? '00:00' : data.hora_vfr
				this.form.hora_navegacao =
					data.hora_navegacao == null ? '00:00' : data.hora_navegacao

				this.form.nome_usuario_inseriu = data.nome_usuario_inseriu
				this.form.data_cadastro = data.data_cadastro

				this.form.ultima_intervencao = data.ultima_intervencao
				this.form.proxima_intervencao = data.proxima_intervencao
				this.form.horimetro_proxima = data.horimetro_proxima
				this.form.descricao_ultima_inspecao =
					data.descricao_ultima_inspecao == null
						? ''
						: data.descricao_ultima_inspecao
				this.form.descricao_proxima_inspecao =
					data.descricao_proxima_inspecao == null
						? ''
						: data.descricao_proxima_inspecao

				this.form.id_responsavel_retorno = data.id_responsavel_retorno
				this.form.codigo_anac_usuario_retorno = data.codigo_anac_usuario_retorno
				this.form.nome_usuario_retorno = data.nome_usuario_retorno
				this.form.objetivo_alcancado =
					data.objetivo_alcancado == null ? '' : data.objetivo_alcancado

				// PMSP
				this.form.valor_recuperado = this.toNumber2Casa(data.valor_recuperado)
				this.form.auto_localizado = Number(data.auto_localizado)
				this.form.arma_apreendida = Number(data.arma_apreendida)
				this.form.pessoa_salva = Number(data.pessoa_salva)
				this.form.pessoa_detida = Number(data.pessoa_detida)
				// FIM PMSP

				this.form.numero_voo = Number(data.numero_voo)
				if (this.fusoHorario == 'UTC') {
					this.form.decolagem = this._SQLDateToDateTime(
						data.decolagem_utc,
						$sessao.getDateFormat() + ' HH:MM'
					)
					this.setaDecolagem(this.form.decolagem)
					this.form.pouso = this._SQLDateToDateTime(
						data.pouso_utc,
						$sessao.getDateFormat() + ' HH:MM'
					)
					this.setaPouso(this.form.pouso)
				} else {
					this.form.decolagem = this._SQLDateToDateTime(
						data.decolagem,
						$sessao.getDateFormat() + ' HH:MM'
					)
					this.setaDecolagem(this.form.decolagem)
					this.form.pouso = this._SQLDateToDateTime(
						data.pouso,
						$sessao.getDateFormat() + ' HH:MM'
					)
					this.setaPouso(this.form.pouso)
				}

				if (data.pouso_utc != null) {
					this.form.pouso_utc = this._SQLDateToDateTime(
						data.pouso_utc,
						$sessao.getDateFormat() + ' HH:MM'
					)
				} else {
					this.form.pouso_utc = ''
				}

				if (data.decolagem_utc != null) {
					this.form.decolagem_utc = this._SQLDateToDateTime(
						data.decolagem_utc,
						$sessao.getDateFormat() + ' HH:MM'
					)
				} else {
					this.form.decolagem_utc = ''
				}

				if (data.corte_utc != null) {
					this.form.corte_utc = this._SQLDateToDateTime(
						data.corte_utc,
						$sessao.getDateFormat() + ' HH:MM'
					)
				} else {
					this.form.corte_utc = ''
				}

				if (data.acionamento_utc != null) {
					this.form.acionamento_utc = this._SQLDateToDateTime(
						data.acionamento_utc,
						$sessao.getDateFormat() + ' HH:MM'
					)
				} else {
					this.form.acionamento_utc = ''
				}

				this.form.horimetro_inicial = this.toNumber1Casa(data.horimetro_partida)
				this.form.horimetro_final = this.toNumber1Casa(data.horimetro_corte)

				this.form.horimetro_inicial_manutencao = this.toNumber1Casa(
					data.horimetro_inicial_manutencao
				)
				this.form.horimetro_final_manutencao = this.toNumber1Casa(
					data.horimetro_final_manutencao
				)

				// ouve alteração do horimetro
				if (
					(
						this.form.horimetro_inicial_manutencao +
						Number(this.form.tempo_voo_motor)
					).toFixed(1) != this.form.horimetro_final_manutencao &&
					this.form.data_assinatura_mecanico
				) {
					this.form.alteradoPeloMecanico = true
				}

				this.form.combustivel = Number(data.combustivel).toFixed(0)
				this.form.combustivelFinal = Number(data.combustivel_final).toFixed(0)
				this.form.partidas = Number(data.partidas)
				this.form.gancho = Number(data.gancho)
				this.form.pousos = Number(data.pousos)
				this.form.guincho = Number(data.guincho)
				this.form.unidade_combustivel = data.unidade_combustivel
				this.form.flir = data.flir
				this.form.ovn = data.ovn
				this.form.voo = data.voo

				if (data.discrepancia.length > 0) {
					this.form.discrepancia = data.discrepancia.map((item) => {
						item.id_usuario = item.id_usuario_discrepancia
						item.descricao = item.descricao_discrepancia
						var pilot = _.find(this._pilotos_mecanicos, (o) => {
							return o.id_usuario == item.id_usuario_discrepancia
						})
						let ata = _.find(this.listaAtas, (o) => o.id == item.id_ata)

						item.trigrama = _.isNil(pilot) ? '' : pilot.trigrama
						item.anac = _.isNil(pilot)
							? ''
							: pilot.codigo_anac != ''
							? pilot.codigo_anac
							: 'N/A'
						item.nome = _.isNil(pilot) ? '' : pilot.nome
						item.erroUsuario = ''
						item.erroDescricao = ''
						item.erroTipo = ''
						item.ata = _.isNil(ata) ? '' : ata
						return item
					})
				}
			}

			if (!_.isNil(data.trecho_motor)) {
				this.form.monitoramento_motor = data.trecho_motor.map((item) => {
					item.rpm = Number(item.rpm)
					item.ng = Number(item.ng)
					item.nl = Number(item.nl)
					item.fuel_flow = Number(item.fuel_flow)
					item.itt = Number(item.itt)
					item.tq = Number(item.tq)
					return item
				})

				this.form.trecho_motor = data.trecho_motor.map((item) => {
					item.erro_ciclo_nf = ''
					item.erro_ciclo_ng = ''
					item.erro_ciclo_np = ''
					item.ciclo_ng = this.toNumber2Casa(item.ciclo_ng)
					item.ciclo_nf = this.toNumber2Casa(item.ciclo_nf)
					item.ciclo_np = this.toNumber2Casa(item.ciclo_np)
					item.total_horimetro = this.toNumber2Casa(item.total_horimetro)
					return item
				})
			}

			if (!_.isNil(data.ocorrencias) && !copiar) {
				if (data.ocorrencias.length > 0) {
					this.form.ocorrencias = data.ocorrencias.map((item) => {
						item.erro_data = ''
						item.erro_local = ''
						item.erro_codigo_classificacao = ''
						item.erro_qualificacao_civil = ''
						item.erro_descricao_fatos = ''
						item.data = this._SQLDateToDateTime(
							item.data,
							$sessao.getDateFormat() + ' HH:MM'
						)

						return item
					})
				}
			}

			this.form.para = data.para

			this.form.para_select = await this.fetchRotaer(data.id_rotaer_destino)
			this.estadosDestino = await this.getEstados(
				this.form.para_select?.pais ?? 'Brazil'
			)
			this.form.nome_estado_para = data.estado_termino_missao
			if (this.form.nome_estado_para) {
				var estado = _.find(this.estadosDestino, (o) => {
					return (
						o.sigla &&
						o.sigla.toUpperCase() == this.form.nome_estado_para.toUpperCase()
					)
				})
			}
			this.loadPara = true
			if (estado) {
				this.carregaCidades((callback) => {
					this.loadPara = false
					this.cidadesPara = callback.lista
					this.form.nome_cidade_para = data.cidade_termino_missao
					this.form.nome_estado_para = data.estado_termino_missao
					this.form.lat_fim = data.lat_fim
					this.form.lng_fim = data.lng_fim
				}, estado.id)
			}

			this.form.de = data.de

			this.form.de_select = await this.fetchRotaer(data.id_rotaer_origem)
			this.form.nome_estado_de = data.estado_inicio_missao
			if (this.form.nome_estado_de) {
				var estado = _.find(this.estados, (o) => {
					return (
						o.sigla &&
						o.sigla.toUpperCase() == this.form.nome_estado_de.toUpperCase()
					)
				})
			}

			if (data.id_integracao_local_origem) {
				this.form.id_integracao_local_origem = data.id_integracao_local_origem
			}

			if (data.id_integracao_local_destino) {
				this.form.id_integracao_local_destino = data.id_integracao_local_destino
			}

			this.loadDe = true
			if (estado) {
				this.carregaCidades((callback) => {
					this.loadDe = false
					this.cidadesDe = callback.lista
					this.form.nome_cidade_de = data.cidade_inicio_missao
					this.form.nome_estado_de = data.estado_inicio_missao
					this.form.lat_inicio = data.lat_inicio
					this.form.lng_inicio = data.lng_inicio
				}, estado.id)
			}
			// pega os dados do piloto
			if (
				!this.isVisualizarDiarioOperadorOuPiloto &&
				this.form.tripulacao.length > 0 &&
				data.tripulacao.length > 0
			) {
				this.form.tripulacao[0].id_usuario = data.tripulacao[0].id_usuario
				this.form.tripulacao[0].erroUsuario = ''
				if (this.fusoHorario == 'UTC') {
					this.form.tripulacao[0].apresentacao = this._SQLDateToDateTime(
						data.tripulacao[0].apresentacao_utc,
						$sessao.getDateFormat() + ' HH:MM'
					)
				} else {
					this.form.tripulacao[0].apresentacao = this._SQLDateToDateTime(
						data.tripulacao[0].apresentacao,
						$sessao.getDateFormat() + ' HH:MM'
					)
				}

				this.form.tripulacao[0].erroApresentacao = ''
				this.form.tripulacao[0].codigo_ovn = data.tripulacao[0].codigo_ovn
				this.form.tripulacao[0].erroOVN = ''
				this.form.tripulacao[0].usuarios = []

				this.form.tripulacao[0].uso_ovn =
					data.tripulacao[0].id_ovn == null ? false : data.tripulacao[0].uso_ovn
				this.form.tripulacao[0].tempoOvn = data.tripulacao[0].tempo_ovn

				this.form.tripulacao[0].erroTempoOvn = ''
				this.form.tripulacao[0].erroUsoOvn = ''
				this.form.tripulacao[0].id_ovn = data.tripulacao[0].id_ovn
				this.form.tripulacao[0].erroIdOvn = ''
				let indexFuncaoAtiva = this.funcoesQueAssinam.findIndex(
					(item) => item.descricao == this.form.tripulacao[0].funcao
				)
				if (indexFuncaoAtiva === -1) {
					indexFuncaoAtiva = this.funcoesQueAssinam.findIndex(
						(item) => item.descricao === 'piloto em comando'
					)
				}
				if (
					Array.isArray(this.funcoesQueAssinam) &&
					this.funcoesQueAssinam.length > 0
				) {
					this.funcoesQueAssinam[indexFuncaoAtiva].active = true
				}
				this.carregaUsuariosTripulacao(
					data.tripulacao[0].funcao,
					0,
					false,
					true
				)

				var verificaComando =
					this.form.voo_instrucao == 0
						? 'piloto em comando'
						: 'piloto em instrução'
				for (var i in data.tripulacao) {
					if (data.tripulacao[i].funcao != null) {
						if (
							Number(data.tripulacao[i].id_usuario) != 0 &&
							data.tripulacao[i].funcao.toLowerCase() != verificaComando && i != 0
						) {
							this.form.tripulacao.push({
								id_usuario: data.tripulacao[i].id_usuario,
								erroUsuario: '',
								funcao: data.tripulacao[i].funcao,
								anac: data.tripulacao[i].anac,
								apresentacao:
									this.fusoHorario == 'UTC'
										? this._SQLDateToDateTime(
												data.tripulacao[i].apresentacao_utc,
												$sessao.getDateFormat() + ' HH:MM'
										  )
										: this._SQLDateToDateTime(
												data.tripulacao[i].apresentacao,
												$sessao.getDateFormat() + ' HH:MM'
										  ),
								erroApresentacao: '',
								codigo_ovn: data.tripulacao[i].codigo_ovn,
								usuarios: [],
								nome: '',
								trigrama: '',
								erroFuncao: '',
								uso_ovn:
									data.tripulacao[i].id_ovn == null
										? false
										: data.tripulacao[i].uso_ovn,
								tempoOvn: data.tripulacao[i].tempo_ovn,
								erroUsoOvn: '',
								id_ovn: data.tripulacao[i].id_ovn,
								erroIdOvn: '',
								erroTempoOvn: '',
								erroOVN: ''
							})

							this.carregaUsuariosTripulacao(
								data.tripulacao[i].funcao,
								i,
								false,
								true
							)
						}
					}
				}
			} else {
				this.form.tripulacao = data.tripulacao.map((tripulacao) => ({
					...tripulacao,
					apresentacao:
						this.fusoHorario == 'UTC'
							? this._SQLDateToDateTime(
									tripulacao.apresentacao_utc,
									window.$sessao.getDateFormat() + ' HH:MM'
							  )
							: this._SQLDateToDateTime(
									tripulacao.apresentacao,
									window.$sessao.getDateFormat() + ' HH:MM'
							  ),
					erroUsuario: '',
					erroApresentacao: '',
					erroFuncao: '',
					erroUsoOvn: '',
					erroIdOvn: '',
					erroOVN: ''
				}))
			}

			this.form.passageiro = data.passageiro.map((it) => {
				it._tipo = it.tipo
				it.nomeErro = ''
				it.orgaoErro = ''
				it.cargoErro = ''
				it.cpfErro = ''
				it.telefoneErro = ''
				it.sexoErro = ''
				it.vitimaIdentificada = it.vitima_identificada

				if (!_.isNil(it.data_nascimento)) {
					it.data_nascimento = this._SQLDateToDate(
						it.data_nascimento,
						$sessao.getDateFormat()
					)
				}
				return it
			})
			if (Array.isArray(data.abastecimento)) {
				const qtd_abastecimentoCombustivel = data.abastecimento.length
				if (qtd_abastecimentoCombustivel > 0) {
					this.form.existe_abastecimento = 1
				}
			}
			this.form.abastecimentoCombustivel = await Promise.all(
				data.abastecimento.map(async (ab) => {
					const abastecimento = {
						...ab,
						designativo_abastecimento:
							ab.designativo_abastecimento == data.de
								? 'origem'
								: ab.designativo_abastecimento == data.para
								? 'destino'
								: 'origem',
						id_orgao: ab.id_orgao,
						volume: ab.volume ? parseFloat(ab.volume).toFixed(1) : 0,
						data_abastecimento:
							ab.designativo_abastecimento == data.de
								? this.form.acionamento
								: ab.designativo_abastecimento == data.para
								? this.form.corte
								: '',
						id_contrato_empenho: ab.id_contrato_empenho,
						erro: {
							designativo_abastecimento: null,
							id_contrato: null,
							id_contrato_empenho: null,
							id_tipo_lancamento: null,
							numero_ce: null,
							origem_abastecimento: null,
							relacao_abastecimento: null,
							valor_total: null,
							valor_unitario: null,
							volume: null
						},
						volumeAntesEdicao: ab.volume ? parseFloat(ab.volume).toFixed(1) : 0,
						valorTotalAntesEdicao: ab.valor_total
							? parseFloat(ab.valor_total).toFixed(3)
							: 0,
						combustiveis: [],
						contratos: [],
						contratoSelecionado: {},
						empenhos: [],
						empenhoSelecionado: {},
						forma_controle: null,
						unidadeArmazenamentoAntesEdicao: ab.id_unidade_armazenamento,
						unidadeArmazenmanetoSelecionada: {}
					}

					return abastecimento
				})
			)

			await Promise.all(
				data.abastecimento.map(async (ab, index) => {
					if (
						this.componenteAbastecimento == 'campos_movimentacao_combustivel'
					) {
						if (ab.id_tipo_lancamento == 6) {
							await this.selecionaUnidadeArmazenamento(
								ab.id_unidade_armazenamento,
								index
							)
						}

						if (ab.id_tipo_lancamento == 10) {
							await this.carregaContratos(ab.id_fornecedor, index)
							await this.carregaEmpenhos(ab.id_contrato, index)
							await this.preencherOrgao(ab.id_contrato_empenho, index)
							this.form.abastecimentoCombustivel[
								index
							].empenhoSelecionadoAntesEdicao =
								this.form.abastecimentoCombustivel[index].empenhoSelecionado
						}
					}
				})
			)

			this.carregaAnexosDiario()
			this.form.abastecimentoCombustivel.forEach(
				(abastecimento, indexAbastecimento) => {
					this.carregaAnexos(abastecimento.id, indexAbastecimento)
				}
			)
			if (Array.isArray(data.trecho_carga) && data.trecho_carga.length > 0) {
				this.form.carga = true
				this.form.peso_carga = parseFloat(
					data.trecho_carga.reduce(
						(acumulador, carga) =>
							parseFloat(acumulador) + parseFloat(carga.peso),
						0
					)
				)
			}

			if (data.descricao_carga) {
				this.form.cargaArray.push({
					id: 0,
					descricao: data.descricao_carga,
					carga_liquida: false,
					peso: data.peso_carga,
					volume: '',
					altura: '',
					comprimento: '',
					largura: '',
					tipo_embalagem: '',
					tipo_carga: '',
					carga_perigosa: false,
					carga_fragil: false,
					id_passageiro: '',
					selecionado: true,
					id_pass_erro: '',
					erroEmbalagem: '',
					descricaoErro: '',
					pesoErro: '',
					erro_tipo_carga: ''
				})

				this.form.descricao_carga = null
				this.form.carga_liquida = null
			}

			this.form.cargaArray = []

			if (Array.isArray(data.trecho_carga)) {
				this.form.cargaArray = data.trecho_carga.map((carga) => {
					carga.descricaoErro = ''
					carga.pesoErro = ''
					carga.erro_tipo_carga = ''
					carga.id_pass_erro = ''
					carga.erroEmbalagem = ''
					carga.tipo_carga = carga.id_tipo_carga
					carga.tipo_embalagem = carga.id_tipo_embalagem_carga
					carga.peso = parseFloat(carga.peso)
					carga.altura = parseFloat(carga.altura)
					carga.comprimento = parseFloat(carga.comprimento)
					carga.volume = parseFloat(carga.volume)
					carga.largura = parseFloat(carga.largura)
					return carga
				})
			}

			this.form.base = data.base
			this.form.numero_bo = data.numero_bo
			this.form.numero_chamada = data.numero_chamado
			this.form.numero_atividade = data.numero_atividade

			// para o histórico, antes tinha so a descrição, depois criamos uma tabela, então para não dar pau no histórico
			// verifico se o id e null, se for carrega pela descrição, se tiver id, carrega pelo id
			if (_.isNil(data.id_tipo_missao)) {
				this.form.tipo_missao = _.find(this.tiposDeMissoes, (o) => {
					return o.descricao == data.descricao_tipo_missao
				})
			} else {
				this.form.tipo_missao = _.find(this.tiposDeMissoes, (o) => {
					return o.id == data.id_tipo_missao
				})
			}

			if (!_.isNil(data.id_tipo_natureza)) {
				this.form.tipo_natureza = _.find(this.tiposDeNaturezas, (o) => {
					return o.id == data.id_tipo_natureza
				})
			}

			// this.form.tipo_missao = _.find(this.tiposDeMissoes, o => {return o.id == data.id_tipo_missao})
			this.form.descricao = data.descricao_missao
			if (this._idCliente != 41) {
				this.form.classificacao =
					data.id_classificacao != null
						? this.getClassificacaoById(data.id_classificacao)
						: ''

				this.form.subclassificacao =
					data.id_subclassificacao != null
						? this.getSubclassificacaoById(data.id_subclassificacao)
						: ''
			}
			this.form.houve_contexto = this.validaNull(data.houve_contexto)

			if (this.form.houve_contexto != null) {
				for (var i in this.contextos) {
					if (this.contextos[i].id == data.id_contexto_operativo) {
						this.form.contexto_operativo = this.contextos[i]
					}
				}
			}

			// orgaos recebidos
			this.form.orgao = []
			_.forEach(data.orgao, (org) => {
				var orgao_apoiado = {}
				var orgao = _.find(this.orgaos, (o) => {
					return o.id == org.id
				})
				orgao_apoiado.erroOrgao = ''
				orgao_apoiado.erroTempoVoo = ''
				orgao_apoiado.orgao = orgao
				orgao_apoiado.tempo_voo = Number(org.tempo_voo).toFixed(2)
				var unidades = []

				_.forEach(org.unidade, (unidade) => {
					var uni = _.find(orgao_apoiado.orgao.unidade, (o) => {
						return o.id == unidade.id_orgao_apoiado_unidade
					})

					if (!_.isNil(uni)) {
						uni.erroUnidade = ''
						unidades.push({unidade: uni, erroUnidade: ''})
					}
				})

				orgao_apoiado.unidade = unidades
				this.form.orgao.push(orgao_apoiado)
			})

			this.form.observacao = data.observacao

			this.form.coracao = Number(data.coracao)
			this.form.rim = Number(data.rim)
			this.form.figado = Number(data.figado)
			this.form.cornea = Number(data.cornea)
			this.form.esclero = Number(data.esclero)
			this.form.pancreas = Number(data.pancreas)
			this.form.baco = Number(data.baco)

			this.form.socorrido = Number(data.socorrido)
			this.form.bambi = Number(data.bambi)
			this.form.brigadista = Number(data.brigadista)
			this.form.natureza_voo = data.natureza_voo

			this.qtdEstPassageiros = data.quantidade_estimada_passageiros
			this.form.pax = data.pax ? data.pax : this.calculoDePax
			this.form.pob = data.pob ? data.pob : this.calculoDePob

			// se for um array
			if (_.isArray(data.unidade_conservacao)) {
				// se existir unidade de conservação
				if (data.unidade_conservacao.length > 0) {
					this.form.unidade_conservacao = data.unidade_conservacao.map(
						(item) => {
							return {
								obj: _.find(this.unidadesConservacao, (o) => {
									return item.id_unidade_conservacao == o.id
								}),
								erro: ''
							}
						}
					)

					//console.log(this.form.unidade_conservacao)
				}
			} else {
				// antes era uma string
				if (data.unidade_conservacao != '') {
					this.form.unidade_conservacao.push({
						obj: _.find(this.basesOperacao, (o) => {
							o.sigla == data.unidade_conservacao
						})
					})
				}
			}

			this.form.base_origem = data.base_origem

			this.calculaTempoDeVooPiloto()
			this.calculaTempoManutencao()

			if (this.visualizar) {
				this.$nextTick(() => {
					this.$refs.printVisualizar.carregaDados({
						data: this.form,
						aero: this.aeronave,
						pilotos: this._pilotos_mecanicos,
						trecho: this.trecho,
						ovns: this.ovns
					})
				})
			}

			this.form.adicao_oleo_lubrificante = data.adicao_oleo_lubrificante
			this.form.fornecedor_oleo_lubrificante =
				data.id_fornecedor_oleo_lubrificante
			this.form.numero_ce_oleo_lubrificante = data.numero_ce_oleo_lubrificante
			this.form.campo_lubrificacao_1 = data.campo_lubrificacao_1
			this.form.campo_lubrificacao_2 = data.campo_lubrificacao_2
			this.form.campo_lubrificacao_3 = data.campo_lubrificacao_3
			this.form.campo_lubrificacao_4 = data.campo_lubrificacao_4
			this.form.campo_lubrificacao_5 = data.campo_lubrificacao_5
			this.form.observacoes_oleo_lubrificante =
				data.observacoes_oleo_lubrificante
			this.edicao_mecanico_oleo_lubrificante =
				data.edicao_mecanico_oleo_lubrificante

			this.form.ifr_simulado = data.ifr_simulado
			this.form.hora_ifr_simulado = data.hora_ifr_simulado
			this.form.diferenca_fuso_horario = data.diferenca_fuso_horario

			this._httpGet(
				`Aeronave/get_dados_oleo_lubrificante/${this.trecho.id_aeronave}`,
				(response) => {
					if (response._request && response._status) {
						this.dadosOleoLubrificante = response.lista
					}
				}
			)

			this.setLiberarEncerrarProg(this.form.id_despacho, this.form.id)
			this.setQtdProgramacoesValidas(this.form.id_despacho)
		},

		selecionaUnidadeArmazenamento(id_unidade_armazenamento, index) {
			const unidade = this.unidadesArmazenamento.find(
				(unidade) => unidade.value == id_unidade_armazenamento
			)
			if (isObject(unidade)) {
				this.form.abastecimentoCombustivel[index].id_combustivel =
					unidade.id_combustivel
				this.$set(
					this.form.abastecimentoCombustivel[index],
					'unidadeArmazenamentoSelecionada',
					unidade
				)
			}
			return {}
		},

		carregaContratos(id_fornecedor, index) {
			return new Promise((resolve, reject) => {
				window.bus.$emit('load-in', this._traducao('global', 'carregando'))
				this._axios(
					`/Contrato/contrato_fornecedor_abastecimento/${id_fornecedor}`,
					'get',
					{
						callback: (response) => {
							if (response._status && response._request) {
								this.form.abastecimentoCombustivel[index].contratos =
									response.lista
								resolve()
							} else {
								reject('Erro ao carregar contratos')
							}
						}
					}
				)
				window.bus.$emit('load-out')
			})
		},

		carregaEmpenhos(id_contrato, index) {
			return new Promise((resolve, reject) => {
				const contrato = this.form.abastecimentoCombustivel[
					index
				].contratos.find((c) => c.id == id_contrato)
				if (contrato) {
					this.form.abastecimentoCombustivel[index].contratoSelecionado =
						contrato
					this.form.abastecimentoCombustivel[index].forma_controle =
						contrato.forma_controle
					window.bus.$emit('load-in', this._traducao('global', 'carregando'))
					this._axios(
						`/Contrato_empenho/get_by_contrato/${id_contrato}`,
						'get',
						{
							callback: (response) => {
								if (response._status && response._request) {
									this.form.abastecimentoCombustivel[index].empenhos =
										response.lista
									resolve()
								} else {
									reject('Erro ao carregar empenhos')
								}
							}
						}
					)
					window.bus.$emit('load-out')
				} else {
					reject('Contrato não encontrado')
				}
			})
		},

		preencherOrgao(id_contrato_empenho, index) {
			return new Promise((resolve, reject) => {
				const empenho = this.form.abastecimentoCombustivel[index].empenhos.find(
					(emp) => emp.id == id_contrato_empenho
				)
				if (empenho) {
					this.form.abastecimentoCombustivel[index].empenhoSelecionado = empenho
					this.form.abastecimentoCombustivel[index].id_orgao = empenho.id_orgao
					if (empenho.id_combustivel == null) {
						this._axios('/Combustivel/lista', 'get', {
							callback: (response) => {
								if (response._status && response._request) {
									this.form.abastecimentoCombustivel[index].combustiveis =
										response.lista
									resolve()
								} else {
									reject('Erro ao carregar combustíveis')
								}
							}
						})
					} else {
						resolve()
					}
				} else {
					reject('Empenho não encontrado')
				}
				window.bus.$emit('load-out')
			})
		},

		toNumber1Casa(val) {
			return Number(Number(val).toFixed(1))
		},

		toNumber2Casa(val) {
			return Number(Number(val).toFixed(2))
		},

		blurCarregaCidades(tipo, reseta) {
			if (tipo == 'de') {
				if (this.form.nome_estado_de != '') {
					if (reseta) {
						this.form.nome_cidade_de = ''
					}

					var estado = _.find(this.estados, (o) => {
						return (
							o.sigla &&
							o.sigla.toUpperCase() == this.form.nome_estado_de.toUpperCase()
						)
					})

					this.loadDe = true
					this.carregaCidades((callback) => {
						this.loadDe = false
						this.cidadesDe = callback.lista
						// this.cidadesDe.push({ id: '', descricao: 'ESCOLHA' })
					}, estado.id)
				}
			}

			if (tipo == 'para') {
				if (this.form.nome_estado_para != '') {
					if (reseta) {
						this.form.nome_cidade_para = ''
					}

					var estado = _.find(this.estadosDestino, (o) => {
						return (
							o.sigla &&
							o.sigla.toUpperCase() == this.form.nome_estado_para.toUpperCase()
						)
					})
					this.loadPara = true
					this.carregaCidades((callback) => {
						this.loadPara = false
						this.cidadesPara = callback.lista
						//this.cidadesPara.push({ id: '', descricao: 'ESCOLHA' })
					}, estado.id)
				}
			}

			if (tipo == 'vor' && this.mostraVor) {
				if (this.form.verificacao_vor[0].id_estado != '') {
					if (reseta) {
						this.form.verificacao_vor[0].id_cidade = ''
					}

					var estado = _.find(this.estados, (o) => {
						return o.id == this.form.verificacao_vor[0].id_estado
					})

					this.loadVor = true
					this.carregaCidades((callback) => {
						this.loadVor = false
						this.cidadesVor = callback.lista
						//this.cidadesPara.push({ id: '', descricao: 'ESCOLHA' })
					}, estado.id)
				}
			}
		},

		async clickExibeModalSalvar() {
			if (await this.validaForm()) {
				if (!this.editar) {
					this.assinar = false
					// se o piloto for quem estiver preenchendo o diário, pede pra assinar
					if (this.form.tripulacao[0].id_usuario == $sessao.getId()) {
						this.assinar = true
					}
				}

				this.revisar = false
				this.cienteAssinatura = false
				this.$refs.modalConfirmacao.modalShow(50)
				//this._exibeModal('modal-ordem-confirma-salvar', 50)
			} else {
				bus.$emit('exibir-notificacao', {
					type: 'danger',
					text: 'Corrija os campos em vermelho.'
				})
			}
		},

		clickSolicitarEdicao() {
			this.$refs.modalSolicitacaoEdicao.exibirModal(this.form.id, 'SOLICITACAO')
		},

		solicitacaoSalva() {
			if (this.editar && this.form.id_assinatura_piloto != '') {
				this.salvouSolicitacao = true
			}
		},

		async clickSalvar(assinarSalvar = null) {
			if (await this.validaForm()) {
				var id_usuario_piloto = 0
				if (this.editar && this.form.id_assinatura_piloto != '') {
					if (!this.salvouSolicitacao) {
						this.$refs.modalSolicitacaoEdicao.exibirModal(
							this.form.id,
							'ASSINATURA'
						)
						return false
					}
				}

				if (
					this.form.horimetro_inicial == '' ||
					this.form.horimetro_inicial == 0 ||
					_.isNil(this.form.horimetro_inicial) ||
					_.isNaN(this.form.horimetro_inicial)
				) {
					return false
				}

				if (
					this.form.horimetro_final == '' ||
					this.form.horimetro_final == 0 ||
					_.isNil(this.form.horimetro_final) ||
					_.isNaN(this.form.horimetro_final)
				) {
					return false
				}

				if (this.dbComercial) {
					this.form.finalizar_ordem = this.form.finalizar_despacho
				}
				this.formPost = {
					milhas_navegacao: this.form.milhas_navegacao,
					id_usuario: $sessao.getId(),
					id_aeronave: this.aeronave.id,
					//tempo_voo_celula: this.form.tempo_voo_celula,
					voo_instrucao: this.form.voo_instrucao,
					pax:
						this.disablePaxPob && this.tripulacaoTecnica == '1'
							? ''
							: this.form.pax,
					pob: this.disablePaxPob ? '' : this.form.pob,
					tempo_voo_motor: this.form.tempo_voo_motor,
					horimetro_inicial: this.form.horimetro_inicial,
					horimetro_final: this.form.horimetro_final,
					decolagem: this._dateTimeToDateSQL(
						this.form.decolagem,
						$sessao.getDateFormat() + ' HH:MM'
					),
					pouso: this._dateTimeToDateSQL(
						this.form.pouso,
						$sessao.getDateFormat() + ' HH:MM'
					),
					id: this.trecho.id,
					tipo_voo: this.form.tipo_voo,
					acionamento: this._dateTimeToDateSQL(
						this.form.acionamento,
						$sessao.getDateFormat() + ' HH:MM'
					),
					corte: this._dateTimeToDateSQL(
						this.form.corte,
						$sessao.getDateFormat() + ' HH:MM'
					),
					acionamento_utc: this._dateTimeToDateSQL(
						this.form.acionamento_utc,
						$sessao.getDateFormat() + ' HH:MM'
					),
					decolagem_utc: this._dateTimeToDateSQL(
						this.form.decolagem_utc,
						$sessao.getDateFormat() + ' HH:MM'
					),
					pouso_utc: this._dateTimeToDateSQL(
						this.form.pouso_utc,
						$sessao.getDateFormat() + ' HH:MM'
					),
					corte_utc: this._dateTimeToDateSQL(
						this.form.corte_utc,
						$sessao.getDateFormat() + ' HH:MM'
					),

					lat_inicio: this.form.lat_inicio,
					lat_fim: this.form.lat_fim,
					lng_inicio: this.form.lng_inicio,
					lng_fim: this.form.lng_fim,

					id_apu:
						this.computedApuAeronave.length > 0
							? this.computedApuAeronave[0].id_apu
							: null,
					horimetro_apu:
						this.computedApuAeronave.length > 0 ? this.form.horimetro_apu : 0,
					horimetro_inicial_apu:
						this.computedApuAeronave.length > 0
							? this.form.horimetro_inicial_apu
							: 0,
					horimetro_final_apu:
						this.computedApuAeronave.length > 0
							? this.form.horimetro_final_apu
							: 0,
					ciclos_apu:
						this.computedApuAeronave.length > 0 ? this.form.ciclos_apu : 0,

					id_aeronave_import:
						this.aeronave_import != ''
							? this.aeronave_import.id_aeronave
							: null,

					ultima_intervencao: this.form.ultima_intervencao,
					proxima_intervencao: this.form.proxima_intervencao,
					horimetro_proxima: this.form.horimetro_proxima,
					id_abastecimento_comprovante: this.form.id_abastecimento_comprovante,
					abastecimento_original: this.movimentacaoCombustivel.original,
					abastecimento_origem: this.movimentacaoCombustivel.origem,
					id_responsavel_retorno: this.form.id_responsavel_retorno,
					nome_usuario_retorno: this.form.nome_usuario_retorno,
					descricao_ultima_inspecao: this.form.descricao_ultima_inspecao,
					descricao_proxima_inspecao: this.form.descricao_proxima_inspecao,

					monitoramento_motor: this.form.monitoramento_motor.map((item) => {
						return {
							altitude: item.altitude,
							oat: item.oat,
							ias: item.ias,
							rpm: item.rpm,
							id_motor: item.id_motor,
							ng: item.ng,
							nl: item.nl,
							fuel_flow: item.fuel_flow,
							itt: item.itt,
							tq: item.tq,
							abastecimento_oleo: item.abastecimento_oleo
						}
					}),

					verificacao_vor: this.form.verificacao_vor,
					vor: this.form.vor,
					radial_vor: this.form.radial_vor,
					afastamento_vor: this.form.afastamento_vor,
					erro_vor: this.form.erro_vor,

					objetivo_alcancado: this.form.objetivo_alcancado,

					finalizar_ordem: this.form.finalizar_ordem,
					finalizar_despacho: this.form.finalizar_despacho,

					id_despacho: this.despacho != '' ? this.despacho.id : null,

					de: this.form.de,
					nome_estado_de: this.form.nome_estado_de,
					nome_cidade_de: this.form.nome_cidade_de,
					unidade_combustivel: this.form.unidade_combustivel,

					gancho: this.form.gancho,
					guincho: this.form.guincho,
					base: this.form.base,

					trecho_carga: this.form.cargaArray.map((carga) => {
						carga.id_tipo_embalagem_carga = carga.tipo_embalagem
						carga.id_tipo_carga = carga.tipo_carga
						return carga
					}),

					para: this.form.para,
					nome_estado_para: this.form.nome_estado_para,
					nome_cidade_para: this.form.nome_cidade_para,
					horimetro_inicial_manutencao: this.form.horimetro_inicial_manutencao,
					horimetro_final_manutencao: this.form.horimetro_final_manutencao,

					id_integracao_local_origem: this.form.id_integracao_local_origem,
					id_integracao_local_destino: this.form.id_integracao_local_destino,

					vfr_diurno: this.form.vfr_diurno,
					hora_vfr_diurno: this.form.hora_vfr_diurno,
					vfr_noturno: this.form.vfr_noturno,
					hora_vfr_noturno: this.form.hora_vfr_noturno,
					ifr: this.form.ifr,
					vfr: this.form.vfr,
					hora_ifr: this.form.hora_ifr,
					hora_vfr: this.form.hora_vfr,
					navegacao: this.form.navegacao,
					hora_navegacao: this.form.hora_navegacao,
					ifr_simulado: this.form.ifr_simulado,
					hora_ifr_simulado: this.form.hora_ifr_simulado,
					//instrucao: this.form.instrucao,
					total: this.form.total,
					// ciclo_ng: this.form.ciclo_ng,
					// ciclo_nf: this.form.ciclo_nf,
					numero_voo: this.form.numero_voo,

					combustivel: this.form.combustivel,
					partidas: this.form.partidas,
					pousos: this.form.pousos,

					id_tipo_missao: this.form.tipo_missao.id,
					id_tipo_natureza: this.form.tipo_natureza.id,
					observacao: this.form.observacao,

					// missao_inicio: this._dateTimeToDateSQL(this.form.missao_inicio, $sessao.getDateFormat() + ' HH:MM'),
					// missao_fim: this._dateTimeToDateSQL(this.form.missao_fim, $sessao.getDateFormat() + ' HH:MM'),
					natureza_voo: this.form.natureza_voo,
					descricao: this.form.descricao?.descricao ?? this.form.descricao ?? '',

					id_classificacao: this.form.classificacao
						? this.form.classificacao.id
						: '',

					id_subclassificacao: this.form.subclassificacao
						? this.form.subclassificacao.id
						: '',

					unidade_conservacao: this.form.unidade_conservacao.map((item) => {
						return {id: _.isNil(item.obj.id) ? 0 : item.obj.id}
					}),
					base_origem: this.form.base_origem,

					coracao: this.form.coracao,
					rim: this.form.rim,
					figado: this.form.figado,
					cornea: this.form.cornea,
					esclero: this.form.esclero,
					pancreas: this.form.pancreas,
					baco: this.form.baco,

					carga: this.form.carga,
					descricao_carga: this.form.descricao_carga,
					carga_liquida: this.form.carga_liquida,
					peso: this.form.peso_carga,

					socorrido: this.form.socorrido,
					existe_unidade_conservacao: this.form.existe_unidade_conservacao,
					bambi: this.form.bambi,
					brigadista: this.form.brigadista,

					auto_localizado: this.form.auto_localizado,
					arma_apreendida: this.form.arma_apreendida,
					pessoa_salva: this.form.pessoa_salva,
					pessoa_detida: this.form.pessoa_detida,
					valor_recuperado: this.form.valor_recuperado,

					houve_contexto: this.form.houve_contexto,
					contexto_operativo:
						this.form.contexto_operativo == ''
							? ''
							: this.form.contexto_operativo.id,

					numero_atividade: this.form.numero_atividade,
					numero_bo: this.form.numero_bo,
					numero_chamado: this.form.numero_chamada,

					ovn: this.form.ovn,
					flir: this.form.flir,

					adicao_oleo_lubrificante: this.form.adicao_oleo_lubrificante,
					id_fornecedor_oleo_lubrificante:
						this.form.fornecedor_oleo_lubrificante,
					numero_ce_oleo_lubrificante: this.form.numero_ce_oleo_lubrificante,
					campo_lubrificacao_1: this.form.campo_lubrificacao_1,
					campo_lubrificacao_2: this.form.campo_lubrificacao_2,
					campo_lubrificacao_3: this.form.campo_lubrificacao_3,
					campo_lubrificacao_4: this.form.campo_lubrificacao_4,
					campo_lubrificacao_5: this.form.campo_lubrificacao_5,
					observacoes_oleo_lubrificante:
						this.form.observacoes_oleo_lubrificante,

					trecho_motor: this.form.trecho_motor.map((item) => {
						return {
							id: item.id,
							ciclo_nf: item.ciclo_nf,
							ciclo_ng: item.ciclo_ng,
							ciclo_np: item.ciclo_np,
							descricao: item.descricao ? item.descricao : '',
							id_motor: item.id_motor,
							id_relatorio_voo_trecho: item.id_relatorio_voo_trecho,
							serial_number: item.serial_number,
							tempo_voo: item.tempo_voo,
							tipo_aeronave: item.tipo_aeronave
						}
					}),
					tripulacao: this.form.tripulacao.map((item) => {
						var trip = {
							id_usuario: item.id_usuario,
							apresentacao:
								item.apresentacao != ''
									? this._dateTimeToDateSQL(
											item.apresentacao,
											$sessao.getDateFormat() + ' HH:MM'
									  )
									: '',
							codigo_ovn: item.codigo_ovn,
							anac: item.anac,
							funcao: item.funcao,
							nome: item.nome,
							trigrama: item.trigrama,
							uso_ovn: item.uso_ovn,
							tempoOvn: item.tempoOvn,
							id_ovn: item.id_ovn
						}

						if (item.funcao.toUpperCase() == 'PILOTO EM COMANDO') {
							id_usuario_piloto = item.id_usuario
						}

						return trip
					}),

					discrepancia: this.form.discrepancia.map((item) => {
						return {
							id: item.id,
							id_usuario: item.id_usuario,
							descricao: item.descricao,
							anac: item.anac,
							tipo: item.tipo,
							id_ata: _.isNil(item.ata) ? '' : item.ata.id
						}
					}),

					abastecimentoCombustivel: this.form.abastecimentoCombustivel.map(
						(item) => {
							return {
								anexos: item.anexos,
								data_abastecimento: item.data_abastecimento,
								designativo_abastecimento: item.designativo_abastecimento,
								forma_controle: item.forma_controle,
								id: item.id,
								id_abastecimento_comprovante: item.id_abastecimento_comprovante,
								id_combustivel: item.id_combustivel,
								id_contrato: item.id_contrato,
								id_contrato_empenho: item.id_contrato_empenho,
								id_fornecedor: item.id_fornecedor,
								id_orgao: item.id_orgao,
								id_tipo_lancamento: item.id_tipo_lancamento,
								id_unidade_armazenamento: item.id_unidade_armazenamento,
								nota_fiscal: item.nota_fiscal,
								numero_ce: item.numero_ce,
								relacao_abastecimento: item.relacao_abastecimento,
								valor_total: item.valor_total,
								valor_unitario: item.valor_unitario,
								volume: parseFloat(item.volume).toFixed(1),
								volume_antes_edicao: item.volumeAntesEdicao,
								unidade_armazenamento_antes_edicao:
									item.unidadeArmazenamentoAntesEdicao,
								contrato_empenho_antes_edicao:
									item.empenhoSelecionadoAntesEdicao
							}
						}
					),

					anexos: this.form.anexos,

					passageiro: this.form.passageiro.map((item) => {
						var pass = {
							tipo: item.tipo,
							nome: item.nome,
							orgao: item.orgao,
							cargo: item.cargo,
							cpf: item.cpf,
							outro: item.outro,
							telefone: item.telefone,
							data_nascimento: this._dateToDateSQL(
								item.data_nascimento,
								$sessao.getDateFormat()
							),
							idade_aparente: item.idade_aparente,
							sexo: item.sexo,
							id_passageiro: item.id_passageiro,
							tipo_passageiro: item.tipo_passageiro,
							vitima_identificada: Number(item.vitimaIdentificada)
						}
						return pass
					}),

					ocorrencias: this.form.ocorrencias.map((item) => {
						return {
							id: item.id,
							data:
								item.data != ''
									? this._dateTimeToDateSQL(
											item.data,
											$sessao.getDateFormat() + ' HH:MM'
									  )
									: '',
							local: item.local,
							codigo_classificacao: item.codigo_classificacao,
							qualificacao_civil: item.qualificacao_civil,
							descricao_fatos: item.descricao_fatos
						}
					}),

					ocorrencia: this.form.ocorrencias.length > 0 ? '1' : '0',
					orgao: this.form.orgao.map((item) => {
						var org = {
							id: item.orgao.id,
							tempo_voo: item.tempo_voo,
							unidade: []
						}

						if (item.unidade.length > 0) {
							org.unidade = item.unidade.map((it) => {
								return {id: it.unidade.id}
							})
						}

						return org
					}),

					assinar_salvar: assinarSalvar,
					id_rotaer_origem: this.form.de_select.id,
					id_rotaer_destino: this.form.para_select.id,
					existe_abastecimento: Boolean(Number(this.form.existe_abastecimento)),
					combustivel_final: this.form.combustivelFinal
				}

				bus.$emit('load-in', {text: this._traducao('global', 'salvando')})

				if (this.habilitaPerformanceMotor == 1) {
					if (this.form.quantidadeMotores == 1) {
						const id_motor_esquerdo = this.form.monitoramento_motor[0].id_motor

						var monitoramentoMotorEsquerdo = new Object()
						monitoramentoMotorEsquerdo.data =
							this.form.horario_performance_motor
						monitoramentoMotorEsquerdo.id_motor = this.id_motor_esquerdo
						monitoramentoMotorEsquerdo.fl = this.form.performance_fl
						monitoramentoMotorEsquerdo.tat = this.form.performance_tat
						monitoramentoMotorEsquerdo.ias = this.form.performance_ias
						monitoramentoMotorEsquerdo.tas = this.form.performance_tas
						monitoramentoMotorEsquerdo.boost = this.form.performance_boost

						monitoramentoMotorEsquerdo.tq = this.form.performance_torque_esq
						monitoramentoMotorEsquerdo.np = this.form.performance_np_esq
						monitoramentoMotorEsquerdo.itt = this.form.performance_itt_esq
						monitoramentoMotorEsquerdo.nh = this.form.performance_nh_esq
						monitoramentoMotorEsquerdo.fuel_flow =
							this.form.performance_flow_esq
						monitoramentoMotorEsquerdo.nl = this.form.performance_nl_esq

						this.formPost.monitoramento_motor[0] = monitoramentoMotorEsquerdo
					} else if (this.form.quantidadeMotores == 2) {
						const id_motor_esquerdo = this.form.monitoramento_motor[1].id_motor
						const id_motor_direito = this.form.monitoramento_motor[0].id_motor

						var monitoramentoMotorEsquerdo = new Object()
						monitoramentoMotorEsquerdo.data =
							this.form.horario_performance_motor
						monitoramentoMotorEsquerdo.id_motor = this.id_motor_esquerdo
						monitoramentoMotorEsquerdo.fl = this.form.performance_fl
						monitoramentoMotorEsquerdo.tat = this.form.performance_tat
						monitoramentoMotorEsquerdo.ias = this.form.performance_ias
						monitoramentoMotorEsquerdo.tas = this.form.performance_tas
						monitoramentoMotorEsquerdo.boost = this.form.performance_boost

						monitoramentoMotorEsquerdo.tq = this.form.performance_torque_esq
						monitoramentoMotorEsquerdo.np = this.form.performance_np_esq
						monitoramentoMotorEsquerdo.itt = this.form.performance_itt_esq
						monitoramentoMotorEsquerdo.nh = this.form.performance_nh_esq
						monitoramentoMotorEsquerdo.fuel_flow =
							this.form.performance_flow_esq
						monitoramentoMotorEsquerdo.nl = this.form.performance_nl_esq
						this.formPost.monitoramento_motor[1] = monitoramentoMotorEsquerdo

						var monitoramentoMotorDireito = new Object()
						monitoramentoMotorDireito.data = this.form.horario_performance_motor
						monitoramentoMotorDireito.id_motor = this.id_motor_direito
						monitoramentoMotorDireito.fl = this.form.performance_fl
						monitoramentoMotorDireito.tat = this.form.performance_tat
						monitoramentoMotorDireito.ias = this.form.performance_ias
						monitoramentoMotorDireito.tas = this.form.performance_tas
						monitoramentoMotorDireito.boost = this.form.performance_boost

						monitoramentoMotorDireito.tq = this.form.performance_torque_dir
						monitoramentoMotorDireito.np = this.form.performance_np_dir
						monitoramentoMotorDireito.itt = this.form.performance_itt_dir
						monitoramentoMotorDireito.nh = this.form.performance_nh_dir
						monitoramentoMotorDireito.fuel_flow = this.form.performance_flow_dir
						monitoramentoMotorDireito.nl = this.form.performance_nl_dir
						this.formPost.monitoramento_motor[0] = monitoramentoMotorDireito
					}
				}

				this.formPost.id_usuario_piloto = id_usuario_piloto

				// se não for meio ambiente, limpa as unidades
				if (this.formPost.id_tipo_missao != 3) {
					this.formPost.unidade_conservacao = []
				} else {
					// se for meio ambiente, verifica se existe unidades
					if (this.formPost.existe_unidade_conservacao == '0') {
						this.formPost.unidade_conservacao = []
					}
				}

				// console.log("ESTOU LHE ENVIANDO", this.formPost)

				this._httpPost(
					'mg-siga/Relatorio_voo_trecho/salvar',
					this.formPost,
					(response) => {
						//console.log("ESTOU RECEBENDO", response)
						bus.$emit('load-out')

						if (response._request) {
							// ao fechar o modal roda a função modalCarregaAssinatura()
							this.$refs.modalConfirmacao.modalHide()
							this.limpaTimeOuts()

							// se for somente salvar, exibe a msg de diario salvo e volta pra lista
							if (this.assinarESalvar) {
								bus.$emit('exibir-notificacao', {
									type: 'success',
									text: `${_traducao('global', 'alteracoesEdicao')}`
								})
								bus.$off('modal-fechou')
								this.$refs.modalSalvarModificacoes.modalHide()
								this.voltaLista()
							} else {
								bus.$off('modal-fechou')
								this.$refs.modalSalvarModificacoes.modalHide()
								this.voltaLista()
							}
						}
					}
				)
			}
		},

		modalCarregaAssinatura() {
			this.$refs.modalConfirmacao.modalHide()

			if (!this.revisar) {
				if (this.assinar) {
					var obj = {
						id_usuario: $sessao.getId(),
						id_aeronave: this.aeronave.id,
						tempo_voo_celula: this.form.tempo_voo_celula,
						tempo_voo_motor: this.form.tempo_voo_motor,
						horimetro_inicial: this.form.horimetro_inicial,
						horimetro_final: this.form.horimetro_final,
						decolagem: this.form.decolagem,
						pouso: this.form.pouso,
						id: this.trecho.id,
						tipo_voo: this.form.tipo_voo,
						acionamento: this.form.acionamento,
						corte: this.form.corte
						//nome_pdf: this.aeronave.prefixo +'-'+ this.trecho.numero_diario + '.pdf'
					}

					// chama o component de assinatura
					this.$refs.assinatura.carregaAssinatura(obj)
				} else {
					bus.$emit('exibir-notificacao', {
						type: 'success',
						text: this._traducao('global', 'salvo')
					})
					//
					this.voltaLista()
				}
			}
		},

		// retorno da assinatura
		validaAssinatura(retorno) {
			bus.$emit('load-in', {text: this._traducao('global', 'assinando')})
			var data = {
				id_assinatura: retorno.assinatura.id,
				id_usuario: $sessao.getId(),
				id_relatorio_voo_trecho: retorno.data.id
			}

			//bus.$emit('load-in', {text: this._traducao('global', 'assinando')})
			if (this.form.tripulacao[0].id_usuario == data.id_usuario) {
				this.assinarESalvar = true
			}
			// salva a assinatura
			this._httpPost(
				'mg-siga/Relatorio_voo_trecho/assinatura_piloto',
				data,
				(response) => {
					bus.$emit('load-out')
					if (response._request) {
						if (this.assinarESalvar) {
							this.clickSalvar(data.id_assinatura)
						} else {
							this.voltaLista()
							bus.$emit('exibir-notificacao', {
								type: 'success',
								text: this._traducao('global', 'trechoAssinado')
							})
							bus.$off('modal-fechou')
						}
					}
				}
			)
		},

		calculaTempoDeVooPiloto() {
			if (this.form.acionamento != '' && this.form.corte != '') {
				this.form.tempo_voo_piloto = this._timeToDecimal(
					this.form.acionamento,
					this.form.corte
				)
			}
		},

		calculaTempoManutencao() {
			if (this.form.decolagem != '' && this.form.pouso != '') {
				this.form.tempo_voo_motor = this._timeToDecimal(
					this.form.decolagem,
					this.form.pouso
				)
			}
		},

		calculaTotal() {
			this.form.horimetro_final =
				this.form.horimetro_inicial + Number(this.form.tempo_voo_piloto)
			this.form.horimetro_final_manutencao =
				this.form.horimetro_inicial_manutencao +
				Number(this.form.tempo_voo_motor)
		},

		async validaForm() {
			var erroData = this._traducao('global', 'erroDataOvn')
			var passou = true
			var obrigatorio = this._traducao('global', 'campoObrigatorio')
			var obrig = this._traducao('global', 'obrigacao') + '.'
			var preenchaPeloMenosUmCampo = this._traducao(
				'global',
				'preenchaPeloMenosUmCampo'
			)
			var erroIntegridadeHorario = this._traducao(
				'global',
				'horarioAcionamentoInvalido'
			)

			// valida o corte e o acionamento do motor
			if (
				this.form.acionamento == '' ||
				this.integridadeHorarioAcionamento == false
			) {
				this.form.acionamento == ''
					? (this.erro.acionamento = obrig)
					: (this.erro.acionamento = erroIntegridadeHorario)
				passou = false
			} else {
				this.erro.acionamento = ''
			}

			if (this.form.ocorrencia193Obrigatoria) {
				if (this.form.numero_bo == '') {
					this.erro.numero_bo = obrigatorio
					passou = false
				} else {
					this.erro.numero_bo = ''
				}
			}

			// decolagem
			if (this.form.decolagem == '') {
				this.erro.decolagem = obrig
				passou = false
			} else {
				this.erro.decolagem = ''
			}

			if (this.form.corte == '') {
				this.erro.corte = obrig
				passou = false
			} else {
				this.erro.corte = ''
			}

			await this.$refs.tempoVooRef.validadorFormTempoVoo()

			if (!this.validadorComponenteTempoVoo) {
				passou = this.validadorComponenteTempoVoo
			}

			if (this._idCliente == 62) {
				if (this.form.id_integracao_local_origem) {
					this.erro.local_operacao_origem = ''
				} else {
					this.erro.local_operacao_origem = obrigatorio
					passou = false
				}

				if (this.form.id_integracao_local_destino) {
					this.erro.local_operacao_destino = ''
				} else {
					this.erro.local_operacao_destino = obrigatorio
					passou = false
				}
			}

			// pouso
			if (this.form.pouso == '') {
				this.erro.pouso = obrig
				passou = false
			} else {
				this.erro.pouso = ''
			}

			// quer dizer q todos campos tao preenchindos
			if (passou) {
				var dtAcionamento = this._criarMomentHHmm(this.form.acionamento)
				var dtDecolagem = this._criarMomentHHmm(this.form.decolagem)
				var dtPouso = this._criarMomentHHmm(this.form.pouso)
				var dtCorte = this._criarMomentHHmm(this.form.corte)

				if (moment(dtAcionamento).isAfter(dtDecolagem)) {
					this.erro.decolagem = 'Decolagem menor que acionamento.'
					passou = false
				} else {
					this.erro.decolagem = ''
				}

				if (moment(dtDecolagem).isAfter(dtPouso)) {
					this.erro.pouso = 'Pouso menor que decolagem.'
					passou = false
				} else {
					this.erro.pouso = ''
				}

				if (moment(dtPouso).isAfter(dtCorte)) {
					this.erro.corte = 'Corte menor que pouso.'
					passou = false
				} else {
					this.erro.corte = ''
				}
			}

			if (
				this.permitirDiarioMaior == false ||
				this.permitirDiarioMaior == '0' ||
				this.permitirDiarioMaior == 0
			) {
				if (this.form.tempo_voo_motor > 8) {
					this.erro.tempo_voo_motor = 'Tempo de voo muito grande'
					passou = false
				} else {
					this.erro.tempo_voo_motor = ''
				}

				if (this.form.tempo_voo_piloto > 8) {
					this.erro.tempo_voo_piloto = 'Tempo de voo muito grande'
					passou = false
				} else {
					this.erro.tempo_voo_piloto = ''
				}
			}

			// valida base
			if (this.form.base == '') {
				passou = false
				this.erro.base = obrigatorio
			} else {
				this.erro.base = ''
			}

			// combustivel
			if (this.form.combustivel == 0) {
				this.erro.combustivel = obrig
				passou = false
			} else {
				this.erro.combustivel = ''
			}
			if (this.campoEncerrouCombustivel && this.form.combustivelFinal == 0) {
				this.erro.combustivelFinal = obrig
				passou = false
			} else {
				this.erro.combustivelFinal = null
			}

			// unidade de combustivel
			if (this.form.unidade_combustivel == '') {
				this.erro.unidade_combustivel = obrig
				passou = false
			} else {
				this.erro.unidade_combustivel = ''
			}

			// de
			if (this.form.de == '') {
				this.erro.de = obrig
				passou = false
			} else {
				this.erro.de = ''
			}

			// para
			if (this.form.para == '') {
				this.erro.para = obrig
				passou = false
			} else {
				this.erro.para = ''
			}

			if (this.form.horimetro_inicial == 0) {
				this.erro.horimetro_inicial = this._traducao('global', 'erroHorimetro')
				passou = false
			} else {
				this.erro.horimetro_inicial = ''
			}

			// nome_cidade_de
			if (this.form.nome_cidade_de == '') {
				this.erro.nome_cidade_de = obrig
				passou = false
			} else {
				this.erro.nome_cidade_de = ''
			}

			// nome_cidade_para
			if (this.form.nome_cidade_para == '') {
				this.erro.nome_cidade_para = obrig
				passou = false
			} else {
				this.erro.nome_cidade_para = ''
			}

			// nome_estado_de
			if (this.form.nome_estado_de == '') {
				this.erro.nome_estado_de = obrig
				passou = false
			} else {
				this.erro.nome_estado_de = ''
			}

			// nome_estado_para
			if (this.form.nome_estado_para == '') {
				this.erro.nome_estado_para = obrig
				passou = false
			} else {
				this.erro.nome_estado_para = ''
			}

			// valida flir
			if (this.aeronave.tipo == 'H' && this.aeronave.habilita_flir == '1') {
				if (this.form.flir == '') {
					this.erro.flir = obrig
					passou = false
				} else {
					this.erro.flir = ''
				}
			}

			if (this.aeronave.ciclo_total == '1' && this.aeronave.numero_voo == '1') {
				if (this.form.numero_voo == '') {
					this.erro.numero_voo = obrig
					passou = false
				} else {
					this.erro.numero_voo = ''
				}
			}

			// insere os ciclos manuais
			if (this.aeronave.ciclo_total == '1') {
				_.forEach(this.form.trecho_motor, (item) => {
					if (item.ciclo_ng === '' && this.aeronave.tipo == 'H') {
						item.erro_ciclo_ng = obrig
						passou = false
					} else {
						item.erro_ciclo_ng = ''
					}

					if (item.ciclo_nf === '') {
						item.erro_ciclo_nf = obrig
						passou = false
					} else {
						item.erro_ciclo_nf = ''
					}

					if (item.ciclo_np === '') {
						item.erro_ciclo_np = obrig
						passou = false
					} else {
						item.erro_ciclo_np = ''
					}
				})
			}

			// PILOTO
			if (this.form.tripulacao[0].id_usuario == '') {
				this.form.tripulacao[0].erroUsuario = obrigatorio
				passou = false
			} else {
				this.form.tripulacao[0].erroUsuario = ''
			}
			// valida apresentacao do piloto
			if (this.form.tripulacao[0].apresentacao == '') {
				this.form.tripulacao[0].erroApresentacao = obrigatorio
				passou = false
			} else {
				this.form.tripulacao[0].erroApresentacao = ''

				var dtAcionamento = new moment(
					this._dateTimeToDateSQL(
						this.form.acionamento,
						$sessao.getDateFormat() + ' HH:MM'
					)
				)
				var apresentacao = new moment(
					this._dateTimeToDateSQL(
						this.form.tripulacao[0].apresentacao,
						$sessao.getDateFormat() + ' HH:MM'
					)
				)
				if (Number(this.limiteApresentacao) > 0) {
					if (
						moment(dtAcionamento).diff(apresentacao, 'minutes') <
						Number(this.limiteApresentacao)
					) {
						if (moment(dtAcionamento).diff(apresentacao, 'minutes') >= 0) {
							this.form.tripulacao[0].erroApresentacao = `O horário de apresentação deve ser pelo menos ${this.limiteApresentacao} min anterior ao acionamento`
						} else {
							this.form.tripulacao[0].erroApresentacao =
								'Maior que o acionamento'
						}
						passou = false
					} else {
						this.form.tripulacao[0].erroApresentacao = ''
					}
				} else {
					if (moment(apresentacao).isAfter(dtAcionamento)) {
						this.form.tripulacao[0].erroApresentacao =
							'Maior que o acionamento.'
						passou = false
					} else {
						this.form.tripulacao[0].erroApresentacao = ''
					}
				}
			}

			//passa a propriedade data_cadastro para a lista de tripulantes para verificacao individual
			for (let tripulante of this.form.tripulacao) {
				const ovnObj = this.ovns.find((ovn) => ovn.id === tripulante.id_ovn)
				if (ovnObj) {
					tripulante.data_cadastro = ovnObj.data_cadastro
				}
			}

			if (
				this.form.tripulacao[0].uso_ovn == null &&
				this.aeronave.habilita_ovn &&
				this.aeronave.tipo == 'H'
			) {
				this.form.tripulacao[0].erroUsoOvn = obrig
				passou = false
			} else {
				this.form.tripulacao[0].erroUsoOvn = ''
			}

			if (
				this.form.tripulacao[0].uso_ovn &&
				this.aeronave.habilita_ovn != '0' &&
				this.aeronave.tipo == 'H'
			) {
				if (
					this.form.tripulacao[0].id_ovn == null ||
					this.form.tripulacao[0].id_ovn == ''
				) {
					this.form.tripulacao[0].erroIdOvn = obrig
					passou = false
				} else {
					this.form.tripulacao[0].erroIdOvn = ''
				}
			}

			if (
				this.form.tripulacao[0].uso_ovn &&
				this.aeronave.habilita_ovn != 0 &&
				this.aeronave.tipo == 'H'
			) {
				if (
					this.form.tripulacao[0].tempoOvn == null ||
					this.form.tripulacao[0].tempoOvn == 0
				) {
					this.form.tripulacao[0].erroTempoOvn = obrig
					passou = false
				} else {
					this.form.tripulacao[0].erroTempoOvn = ''
				}
			}
			if (
				this.form.tripulacao[0].uso_ovn &&
				this.aeronave.habilita_ovn != '0' &&
				this.aeronave.tipo == 'H'
			) {
				let arrayDataAcionamento = this.form.acionamento.split('/')
				arrayDataAcionamento[2] = arrayDataAcionamento[2].slice(0, 4)
				let dataAcionamento =
					arrayDataAcionamento[2] +
					'-' +
					arrayDataAcionamento[1] +
					'-' +
					arrayDataAcionamento[0]

				let dataAcionamentoDate = new Date(dataAcionamento)
				let dataCadastro = new Date(this.form.tripulacao[0].data_cadastro)

				if (dataCadastro > dataAcionamentoDate) {
					this.form.tripulacao[0].erroDataCadastro = erroData
					passou = false
				} else {
					this.form.tripulacao[0].erroDataCadastro = ''
				}
			}

			// se tiver mais de 2 tripulantes, quer dizer q tem trip op, valida os campos
			if (this.form.tripulacao.length > 1) {
				for (var i = 1; i < this.form.tripulacao.length; i++) {
					if (this.form.tripulacao[i].funcao == '') {
						this.form.tripulacao[i].erroFuncao = obrigatorio
						passou = false
					} else {
						this.form.tripulacao[i].erroFuncao = ''
					}
					// valida o nome
					if (this.form.tripulacao[i].id_usuario == '') {
						this.form.tripulacao[i].erroUsuario = obrigatorio
						passou = false
					} else {
						this.form.tripulacao[i].erroUsuario = ''

						var pass = true
						_.forEach(this.form.tripulacao, (value, key) => {
							if (key != i) {
								if (value.id_usuario == this.form.tripulacao[i].id_usuario) {
									pass = false
								}
							}
						})

						if (!pass) {
							this.form.tripulacao[i].erroUsuario = 'Tripulante repetido.'
							passou = false
						} else {
							this.form.tripulacao[i].erroUsuario = ''
						}
					}
					const funcao = this.form.tripulacao[i].funcao.toLowerCase()

					// valida a apresentacao
					if (this.form.tripulacao[i].apresentacao == '') {
						this.form.tripulacao[i].erroApresentacao = obrigatorio
						passou = false
					} else {
						this.form.tripulacao[i].erroApresentacao = ''
						var dtAcionamento = new moment(
							this._dateTimeToDateSQL(
								this.form.acionamento,
								$sessao.getDateFormat() + ' HH:MM'
							)
						)
						var apresentacao = new moment(
							this._dateTimeToDateSQL(
								this.form.tripulacao[i].apresentacao,
								$sessao.getDateFormat() + ' HH:MM'
							)
						)

						if (moment(apresentacao).isAfter(dtAcionamento)) {
							this.form.tripulacao[i].erroApresentacao =
								'Maior que o acionamento.'
							passou = false
						} else {
							if (moment(apresentacao).isAfter(dtAcionamento)) {
								this.form.tripulacao[i].erroApresentacao =
									'Maior que o acionamento.'
								passou = false
							} else {
								this.form.tripulacao[i].erroApresentacao = ''
							}
						}

						if (Number(this.limiteApresentacao) > 0) {
							if (
								moment(dtAcionamento).diff(apresentacao, 'minutes') <
								Number(this.limiteApresentacao)
							) {
								if (moment(dtAcionamento).diff(apresentacao, 'minutes') >= 0) {
									this.form.tripulacao[
										i
									].erroApresentacao = `O horário de apresentação deve ser pelo menos ${this.limiteApresentacao} min anterior ao acionamento`
								} else {
									this.form.tripulacao[i].erroApresentacao =
										'Maior que o acionamento'
								}
								passou = false
							} else {
								this.form.tripulacao[i].erroApresentacao = ''
							}
						} else {
							if (moment(apresentacao).isAfter(dtAcionamento)) {
								this.form.tripulacao[i].erroApresentacao =
									'Maior que o acionamento.'
								passou = false
							} else {
								this.form.tripulacao[i].erroApresentacao = ''
							}
						}
					}

					if (
						this.form.tripulacao[i].uso_ovn == null &&
						this.aeronave.habilita_ovn != '0' &&
						this.aeronave.tipo == 'H'
					) {
						this.form.tripulacao[i].erroUsoOvn = obrig
						passou = false
					} else {
						this.form.tripulacao[i].erroUsoOvn = ''
					}

					if (
						this.form.tripulacao[i].uso_ovn &&
						this.aeronave.habilita_ovn != '0' &&
						this.aeronave.tipo == 'H'
					) {
						if (
							this.form.tripulacao[i].id_ovn == null ||
							this.form.tripulacao[i].id_ovn == ''
						) {
							this.form.tripulacao[i].erroIdOvn = obrig
							passou = false
						} else {
							this.form.tripulacao[i].erroIdOvn = ''
						}
					}

					if (
						this.form.tripulacao[i].uso_ovn &&
						this.aeronave.habilita_ovn != '0' &&
						this.aeronave.tipo == 'H'
					) {
						if (
							this.form.tripulacao[i].tempoOvn == null ||
							this.form.tripulacao[i].tempoOvn === 0
						) {
							this.form.tripulacao[i].erroTempoOvn = obrig
							passou = false
						} else {
							this.form.tripulacao[i].erroTempoOvn = ''
						}
					}
					if (
						this.form.tripulacao[i].uso_ovn &&
						this.aeronave.habilita_ovn != '0' &&
						this.aeronave.tipo == 'H'
					) {
						let arrayDataAcionamento_ = this.form.acionamento.split('/')
						arrayDataAcionamento_[2] = arrayDataAcionamento_[2].slice(0, 4)
						let dataAcionamento_ =
							arrayDataAcionamento_[2] +
							'-' +
							arrayDataAcionamento_[1] +
							'-' +
							arrayDataAcionamento_[0]

						const dataAcionamentoData = new Date(dataAcionamento_)
						let dataCadastro = new Date(this.form.tripulacao[i].data_cadastro)
						if (dataCadastro > dataAcionamentoData) {
							this.form.tripulacao[i].erroDataCadastro = erroData
							passou = false
						} else {
							this.form.tripulacao[i].erroDataCadastro = ''
						}
					}
				}
			}
			if (this.form.tipo_missao) {
				if (
					this.form.existe_unidade_conservacao == '' &&
					this.form.tipo_missao.descricao ==
						'MEIO AMBIENTE (INCLUINDO COMBATE A INCÊNDIO FLORESTAL)'
				) {
					this.erro.existe_unidade_conservacao = 'Obrigatório.'
					passou = false
				} else {
					this.erro.existe_unidade_conservacao = ''
				}

				// obriga a inserir unidades de conservação
				if (
					this.form.existe_unidade_conservacao == '1' &&
					this.form.tipo_missao.descricao ==
						'MEIO AMBIENTE (INCLUINDO COMBATE A INCÊNDIO FLORESTAL)'
				) {
					this.form.unidade_conservacao = this.form.unidade_conservacao.map(
						(item) => {
							if (item.obj == '') {
								item.erro = 'Campo obrigatório.'
								passou = false
							} else {
								item.erro = ''
							}
							return item
						}
					)
				}
			}

			// se for um voo de instrucao
			/*if (this.form.voo_instrucao == '1') {
				var pilotoInstrucao = _.find(this.form.tripulacao, function (o) {
					return o.funcao.toLowerCase() == 'piloto em instrução'
				})

				if (_.isNil(pilotoInstrucao)) {
					passou = false
					this.erro.instrutor_voo = _traducao('global', 'vooDeveConterPiloto')
				} else {
					this.erro.instrutor_voo = ''
				}
			} TIREI PORQUE AGORA QUALQUER FUNCAO PODE ASSINAR*/

			// valida os passageiros
			if (this.form.passageiro.length > 0) {
				for (var i in this.form.passageiro) {
					if (this.form.passageiro[i].tipo == 'P') {
						// valida nome
						if (this.form.passageiro[i].nome == '') {
							this.form.passageiro[i].nomeErro = obrig
							passou = false
						} else {
							this.form.passageiro[i].nomeErro = ''
						}

						if (this.passCpfObrigatorio) {
							if (this.form.passageiro[i].cpf == '') {
								this.form.passageiro[i].cpfErro = obrig + 'cpf válido'
								passou = false
							} else {
								this.form.passageiro[i].cpfErro = ''
							}
						} else {
							this.form.passageiro[i].cpfErro = ''
						}

						// valida orgao
						if (this.enableOrgao) {
							if (this.form.passageiro[i].orgao == '') {
								this.form.passageiro[i].orgaoErro = obrig
								passou = false
							} else {
								this.form.passageiro[i].orgaoErro = ''
							}
						}

						// valida cargo
						if (this.enableCargo) {
							if (this.form.passageiro[i].cargo == '') {
								this.form.passageiro[i].cargoErro = obrig
								passou = false
							} else {
								this.form.passageiro[i].cargoErro = ''
							}
						}
						if ((this.form.passageiro[i].id_passageiro = '')) {
							this.form.passageiro[i].nomeErro =
								'Passageiro inválido, selecione novamente.'

							passou = false
						} else {
							if (passou) {
								this.form.passageiro[i].nomeErro = ''
							}
						}
					} else if (
						this.form.passageiro[i].tipo == 'V' &&
						Number(this.form.passageiro[i].vitimaIdentificada)
					) {
						if (this.form.passageiro[i].nome == '') {
							this.form.passageiro[i].nomeErro = obrig
							passou = false
						} else {
							this.form.passageiro[i].nomeErro = ''
						}
					}
				}
			}
			// VALIDA CASO TENHA CARGA
			if (this.form.carga) {
				if (this.flagPeso) {
					for (let carg of this.form.cargaArray) {
						if (carg.peso == 0) {
							carg.pesoErro = obrig
							passou = false
						} else {
							carg.descricao = 'Bagagem'
							carg.pesoErro = ''
						}
					}
				} else {
					for (let carg of this.form.cargaArray) {
						if (carg.descricao == '') {
							carg.descricaoErro = obrig
							passou = false
						} else {
							carg.descricaoErro = ''
						}

						if (carg.peso == '') {
							carg.pesoErro = obrig
							passou = false
						} else {
							carg.pesoErro = ''
						}

						if (carg.tipo_carga == '' && this.flagCompleto) {
							carg.erro_tipo_carga = obrig
							passou = false
						} else {
							carg.erro_tipo_carga = ''
						}

						if (carg.id_passageiro == '' && this.flagCompleto) {
							carg.id_pass_erro = obrig
							passou = false
						} else {
							carg.id_pass_erro = ''
						}

						if (carg.tipo_embalagem == '' && this.flagCompleto) {
							carg.erroEmbalagem = obrig
							passou = false
						} else {
							carg.erroEmbalagem = ''
						}
					}
				}
			}

			// PMSP
			if (this._idCliente == 14) {
				var soma = 0
				this.form.orgao = this.form.orgao.map((item) => {
					soma += item.tempo_voo

					return item
				})

				if (
					Number(this.form.tempo_voo_piloto).toFixed(1) !=
					Number(soma).toFixed(1)
				) {
					passou = false
					this.form.orgao = this.form.orgao.map((item) => {
						item.erroTempoVoo = 'A soma é diferente que o tempo do piloto'
						return item
					})
				} else {
					this.form.orgao = this.form.orgao.map((item) => {
						item.erroTempoVoo = ''
						return item
					})
				}
			}

			// valida a discrepancia
			if (this.form.discrepancia.length > 0) {
				for (var i in this.form.discrepancia) {
					if (this.form.discrepancia[i].id_usuario == '') {
						this.form.discrepancia[i].erroUsuario = obrigatorio
						passou = false
					} else {
						this.form.discrepancia[i].erroUsuario = ''
					}

					if (this.form.discrepancia[i].descricao == '') {
						this.form.discrepancia[i].erroDescricao = obrigatorio
						passou = false
					} else {
						this.form.discrepancia[i].erroDescricao = ''
					}
				}
			}

			// valida a ocorrencia
			if (this.form.ocorrencias.length > 0) {
				this.form.ocorrencias = this.form.ocorrencias.map((item) => {
					if (item.data == '') {
						item.erro_data = obrigatorio
						passou = false
					} else {
						item.erro_data = ''
					}

					if (item.local == '') {
						item.erro_local = obrigatorio
						passou = false
					} else {
						item.erro_local = ''
					}

					if (item.codigo_classificacao == '') {
						item.erro_codigo_classificacao = obrigatorio
						passou = false
					} else {
						item.erro_codigo_classificacao = ''
					}

					if (item.qualificacao_civil == '') {
						item.erro_qualificacao_civil = obrigatorio
						passou = false
					} else {
						item.erro_qualificacao_civil = ''
					}

					if (item.descricao_fatos == '') {
						item.erro_descricao_fatos = obrigatorio
						passou = false
					} else {
						item.erro_descricao_fatos = ''
					}

					return item
				})
			}

			if (
				this.form.objetivo_alcancado == '' &&
				this.exibeObjetivosMissao == '1'
			) {
				this.erro.objetivo_alcancado = obrigatorio
				passou = false
			} else {
				this.erro.objetivo_alcancado = ''
			}

			if (this.homologadoAnac) {
				if (!this.form.tipo_natureza) {
					this.erro.tipo_natureza = obrigatorio
					passou = false
				} else {
					this.erro.tipo_natureza = ''
				}
			}

			// tipo de missao
			if (!this.form.tipo_missao) {
				this.erro.tipo_missao = obrigatorio
				passou = false
			} else {
				this.erro.tipo_missao = ''
			}

			// subclassificacao
			if (this._idCliente != 41 && this.exibeClassificacao) {
				if (this.form.classificacao == null || this.form.classificacao == '') {
					this.erro.classificacao = obrigatorio
					passou = false
				} else {
					this.erro.classificacao = ''
				}
			}

			// orgao
			if (this.form.orgao.length == 0) {
				this.erro.orgao = obrigatorio
				passou = false
			} else {
				this.erro.orgao = ''

				for (var i in this.form.orgao) {
					if (this.form.orgao[i].orgao == '') {
						this.form.orgao[i].erroOrgao = obrigatorio
						passou = false
					} else {
						this.form.orgao[i].erroOrgao = ''

						// se o orgao tiver unidades
						if (this.form.orgao[i].orgao.unidade.length > 0) {
							if (this.form.orgao[i].unidade.length == 0) {
								this.form.orgao[i].erroOrgao =
									this._traducao('global', 'voceTemQueEscolherUnidade') +
									' ---->'
								passou = false
							} else {
								this.form.orgao[i].erroOrgao = ''
							}

							for (var j in this.form.orgao[i].unidade) {
								if (this.form.orgao[i].unidade[j].unidade == '') {
									this.form.orgao[i].unidade[j].erroUnidade = obrig
									passou = false
								} else {
									this.form.orgao[i].unidade[j].erroUnidade = ''
								}
							}
						}
					}
				}
			}

			if (this.form.existe_abastecimento == null) {
				this.erro.existe_abastecimento = obrigatorio
				passou = false
			} else {
				this.erro.existe_abastecimento = ''
				if (this.form.existe_abastecimento == 1) {
					switch (this.componenteAbastecimento) {
						case 'somente_ce':
							await this.$refs.abastecimentoBasicoRef.validadorFormAbastecimento()
							break
						case 'campos_intermediarios':
							await this.$refs.abastecimentoIntermediarioRef.validadorFormAbastecimento()
							break
						case 'campos_movimentacao_combustivel':
							await this.$refs.abastecimentoMovimentacaoCombustivelRef.validadorFormAbastecimento()
							break
						default:
							this.validadorComponenteAbastecimento = true
					}

					if (!this.validadorComponenteAbastecimento) {
						passou = this.validadorComponenteAbastecimento
					}
				}
			}

			// houve contexto
			if (this.form.houve_contexto == '' && this.exibeContextoOperativo) {
				this.erro.houve_contexto = obrigatorio
				passou = false
			} else {
				this.erro.houve_contexto = ''

				if (this.form.houve_contexto == '1') {
					if (this.form.contexto_operativo == '') {
						this.erro.contexto_operativo = obrigatorio
						passou = false
					} else {
						this.erro.contexto_operativo = ''
					}
				}
			}

			if (this.despacho != '') {
				// se tiver ordem
				if (
					this.despacho.id_ordem_missao != null &&
					this.despacho.id_ordem_missao != '0'
				) {
					if (this.dbComercial) {
						this.form.finalizar_ordem = 1
					}
					if (
						this.form.finalizar_ordem == '' &&
						this.exibeFinalizarOrdemMissao == '1'
					) {
						this.erro.finalizar_ordem = obrigatorio
						passou = false
					} else {
						this.erro.finalizar_ordem = ''
					}
				}

				if (this.form.finalizar_despacho == '') {
					this.erro.finalizar_despacho = obrigatorio
					passou = false
				} else {
					this.erro.finalizar_despacho = ''
				}
			}
			this.$forceUpdate()
			return passou
		},

		dadosAbastecimentoValido(data) {
			this.validadorComponenteAbastecimento = true
			this.form.abastecimentoCombustivel = data
		},
		dadosAbastecimentoInvalido(errors) {
			this.validadorComponenteAbastecimento = false
		},

		dadosTempoVooValido(data) {
			this.validadorComponenteTempoVoo = true
			this.form = data
		},
		dadosTempoVooInvalido(errors) {
			this.validadorComponenteTempoVoo = false
		},

		voltaLista() {
			this.limpaTimeOuts()
			this._escondeModal('modal-ordem-tempo-expirado')
			this.$emit('volta-diario-piloto')
			//bus.$emit('volta-diario-piloto', this.name)
		},

		limpaTimeOuts() {
			clearTimeout(this.timeOut)
			clearTimeout(this.timeOutModal)
		},

		carregaDados() {
			this.carregarListaPassageiros()
		},

		async verificaCe() {
			if (this.aeronave.id && this.form.numero_ce) {
				window.bus.$emit('load-in', {
					text: this._traducao('global', 'carregando')
				})
				const dadosMovimentacoesCombustivel =
					await this.getMovimentacaoCombustivel(
						this.aeronave.id,
						this.form.numero_ce
					)
				window.bus.$emit('load-out')
				if (
					Array.isArray(dadosMovimentacoesCombustivel) &&
					dadosMovimentacoesCombustivel.length >= 1
				) {
					this.$refs.movimentacoesCombustivel.carregaDados(
						dadosMovimentacoesCombustivel
					)
				} else {
					this.movimentacaoCombustivel.exibeOrigem = false
					this.movimentacaoCombustivel.origem = null
				}
			}
		},

		async getMovimentacaoCombustivel(idAeronave, numeroCe) {
			return new Promise((resolve) => {
				this._axios(
					`/mg-siga/Relatorio_voo_trecho/get_movimentacao_combustivel/${idAeronave}/${numeroCe}`,
					'get',
					{
						callback: (retorno) => {
							if (retorno._request && retorno._status) {
								resolve(retorno.lista)
							}
						}
					}
				)
			})
		},
		movimentacaoSelecionado(movimentacao) {
			this.form.volume = parseFloat(movimentacao.volume)
			this.form.id_abastecimento_comprovante = movimentacao.id
			this.form.id_unidade_armazenamento = movimentacao.id_unidade_armazenamento
			if (movimentacao.id_movimentacao) {
				this.movimentacaoCombustivel.exibeOrigem = true
				this.movimentacaoCombustivel.origem = movimentacao.origem
			}
		},
		exibirRemover() {
			if (
				this.movimentacaoCombustivel.exibeOrigem === null ||
				this.movimentacaoCombustivel.origem === null
			) {
				return false
			}
			return true
		},

		limpardb() {
			this.form.numero_ce = null
			this.form.volume = 0
			this.form.id_abastecimento_comprovante = null
			this.designativo_abastecimento = ''
			this.form.abastecimentoCombustivel = []
			this.movimentacaoCombustivel.exibeOrigem = false
			this.movimentacaoCombustivel.origem = null
			this.exibirRemover()
		},

		async trocarPiloto(
			vooInstrucao,
			funcao,
			index,
			zeraId,
			carregaAnac,
			indexFuncao
		) {
			this.funcoesQueAssinam.forEach((func, i) => {
				func.active = i === indexFuncao
			})
			if(funcao && funcao.includes('instrução')){
				vooInstrucao = '1'
			}
			this.clickSetaVooInstrucao(vooInstrucao)
			await this.carregaUsuariosTripulacao(funcao, index, zeraId, carregaAnac)
		},

		carregaDadosDb() {
			this._httpGet(
				'mg-siga/Relatorio_voo_trecho/get/' + this.trecho.id,
				(response) => {
					bus.$emit('load-out')
					if (response._request) {
						this.carregaDadosPreenchimento(response.lista)
					}
				}
			)
		},
		async carregaDadosPreenchimento(data) {
			this.form.tipo_voo = data.origem

			// carrega o despacho caso tenha
			if (data.id_despacho_emergencial != null) {
				this._httpGet(
					'mg-siga/Despacho_emergencial/get/' + data.id_despacho_emergencial,
					(retorno) => {
						bus.$emit('load-out')

						if (retorno._request) {
							this.despacho = retorno.lista
						}
					}
				)
			}
			this.form.total_ciclo_torque =
				data.total_ciclo_torque == null ? '' : data.total_ciclo_torque
			this.form.total_gancho =
				data.total_gancho == null ? '' : data.total_gancho
			this.form.total_guincho =
				data.total_guincho == null ? '' : data.total_guincho
			this.form.total_partidas =
				data.total_partidas == null ? '' : data.total_partidas
			this.form.total_pousos =
				data.total_pousos == null ? '' : data.total_pousos
			this.form.existe_unidade_conservacao = data.existe_unidade_conservacao

			if (data.verificacao_vor) {
				if (data.verificacao_vor.length == 0) {
					this.form.verificacao_vor[0].verifica_vor = 'N'
				} else {
					this.form.verificacao_vor[0].verifica_vor = 'S'
					this.form.verificacao_vor[0].id = data.verificacao_vor[0].id
					this.form.verificacao_vor[0].data = data.verificacao_vor[0].data
					this.form.verificacao_vor[0].id_estado =
						data.verificacao_vor[0].id_estado
					this.loadVor = true
					this.carregaCidades((callback) => {
						this.loadVor = false
						this.cidadesVor = callback.lista
						//this.cidadesPara.push({ id: '', descricao: 'ESCOLHA' })
					}, data.verificacao_vor[0].id_estado)
					this.form.verificacao_vor[0].id_cidade =
						data.verificacao_vor[0].id_cidade
					this.form.verificacao_vor[0].defasagem1 =
						data.verificacao_vor[0].defasagem1
					this.form.verificacao_vor[0].defasagem2 =
						data.verificacao_vor[0].defasagem2
					this.form.verificacao_vor[0].aprovado =
						data.verificacao_vor[0].aprovado == '1' ? 'S' : 'N'
				}
			}

			this.form.numero_diario_anac = this.trecho.numero_diario

			this.form.id = data.id
			this.form.id_despacho = data.id_despacho_emergencial
			this.form.voo_instrucao = data.voo_instrucao
			this.form.finalizar_despacho = data.finalizar_despacho

			this.form.nome_usuario_inseriu = data.nome_usuario_inseriu
			this.form.data_cadastro = data.data_cadastro

			this.form.objetivo_alcancado =
				data.objetivo_alcancado == null ? '' : data.objetivo_alcancado
			this.form.decolagem = this._SQLDateToDateTime(
				data.decolagem,
				$sessao.getDateFormat() + ' HH:MM'
			)
			this.setaDecolagem(this.form.decolagem)
			this.form.pouso = this._SQLDateToDateTime(
				data.pouso,
				$sessao.getDateFormat() + ' HH:MM'
			)
			this.setaPouso(this.form.pouso)

			if (data.pouso_utc != null) {
				this.form.pouso_utc = this._SQLDateToDateTime(
					data.pouso_utc,
					$sessao.getDateFormat() + ' HH:MM'
				)
			} else {
				this.form.pouso_utc = ''
			}

			if (data.decolagem_utc != null) {
				this.form.decolagem_utc = this._SQLDateToDateTime(
					data.decolagem_utc,
					$sessao.getDateFormat() + ' HH:MM'
				)
			} else {
				this.form.decolagem_utc = ''
			}

			if (data.corte_utc != null) {
				this.form.corte_utc = this._SQLDateToDateTime(
					data.corte_utc,
					$sessao.getDateFormat() + ' HH:MM'
				)
			} else {
				this.form.corte_utc = ''
			}

			if (data.acionamento_utc != null) {
				this.form.acionamento_utc = this._SQLDateToDateTime(
					data.acionamento_utc,
					$sessao.getDateFormat() + ' HH:MM'
				)
			} else {
				this.form.acionamento_utc = ''
			}

			this.form.para = data.para

			this.form.para_select = await this.fetchRotaer(data.id_rotaer_destino)
			this.form.nome_estado_para = data.estado_termino_missao
			if (this.form.nome_estado_para) {
				var estado = _.find(this.estadosDestino, (o) => {
					return (
						o.sigla &&
						o.sigla.toUpperCase() == this.form.nome_estado_para.toUpperCase()
					)
				})
			}
			if (estado) {
				this.carregaCidades((callback) => {
					this.cidadesPara = callback.lista
					this.form.nome_cidade_para = data.cidade_termino_missao
					this.form.nome_estado_para = data.estado_termino_missao
					this.form.lat_fim = data.lat_fim
					this.form.lng_fim = data.lng_fim
				}, estado.id)
			}

			this.form.de = data.de

			this.form.de_select = await this.fetchRotaer(data.id_rotaer_origem)
			this.form.nome_estado_de = data.estado_inicio_missao
			if (this.form.nome_estado_de) {
				var estado = _.find(this.estados, (o) => {
					return (
						o.sigla &&
						o.sigla.toUpperCase() == this.form.nome_estado_de.toUpperCase()
					)
				})
			}
			if (estado) {
				this.carregaCidades((callback) => {
					this.cidadesDe = callback.lista
					this.form.nome_cidade_de = data.cidade_inicio_missao
					this.form.nome_estado_de = data.estado_inicio_missao
					this.form.lat_inicio = data.lat_inicio
					this.form.lng_inicio = data.lng_inicio
				}, estado.id)
			}

			// pega os dados do piloto
			if (
				!this.isVisualizarDiarioOperadorOuPiloto &&
				this.form.tripulacao.length > 0 &&
				data.tripulacao.length > 0
			) {
				this.form.tripulacao[0].id_usuario = data.tripulacao[0].id_usuario
				this.form.tripulacao[0].erroUsuario = ''
				this.form.tripulacao[0].apresentacao = this._SQLDateToDateTime(
					data.tripulacao[0].apresentacao,
					$sessao.getDateFormat() + ' HH:MM'
				)
				this.form.tripulacao[0].erroApresentacao = ''
				this.form.tripulacao[0].codigo_ovn = data.tripulacao[0].codigo_ovn
				this.form.tripulacao[0].erroOVN = ''
				this.form.tripulacao[0].usuarios = []

				let indexFuncaoAtiva = this.funcoesQueAssinam.findIndex(
					(item) => item.descricao == data.tripulacao[0].funcao
				)
				if (indexFuncaoAtiva === -1) {
					indexFuncaoAtiva = this.funcoesQueAssinam.findIndex(
						(item) => item.descricao === 'piloto em comando'
					)
				}
				this.funcoesQueAssinam[indexFuncaoAtiva].active = true
				this.funcoesQueAssinam[indexFuncaoAtiva].active = true
				this.carregaUsuariosTripulacao(
					data.tripulacao[0].funcao,
					0,
					false,
					true
				)

				var verificaComando =
					this.form.voo_instrucao == 0
						? 'piloto em comando'
						: 'piloto em instrução'
				for (var i in data.tripulacao) {
					if (data.tripulacao[i].funcao != null) {
						if (
							Number(data.tripulacao[i].id_usuario) != 0 &&
							data.tripulacao[i].funcao.toLowerCase() != verificaComando && i != 0
						) {
							this.form.tripulacao.push({
								id_usuario: data.tripulacao[i].id_usuario,
								erroUsuario: '',
								funcao: data.tripulacao[i].funcao,
								anac: data.tripulacao[i].anac,
								apresentacao: this._SQLDateToDateTime(
									data.tripulacao[i].apresentacao,
									$sessao.getDateFormat() + ' HH:MM'
								),
								erroApresentacao: '',
								codigo_ovn: data.tripulacao[i].codigo_ovn,
								usuarios: [],
								nome: '',
								trigrama: '',
								erroFuncao: '',
								erroOVN: ''
							})

							this.carregaUsuariosTripulacao(
								data.tripulacao[i].funcao,
								i,
								false,
								true
							)
						}
					}
				}
			} else {
				this.form.tripulacao = data.tripulacao.map((tripulacao) => ({
					...tripulacao,
					apresentacao: this._SQLDateToDateTime(
						tripulacao.apresentacao,
						window.$sessao.getDateFormat() + ' HH:MM'
					),
					erroUsuario: '',
					erroApresentacao: '',
					erroFuncao: '',
					erroOVN: ''
				}))
			}

			this.form.base = data.base

			// para o histórico, antes tinha so a descrição, depois criamos uma tabela, então para não dar pau no histórico
			// verifico se o id e null, se for carrega pela descrição, se tiver id, carrega pelo id
			if (_.isNil(data.id_tipo_missao)) {
				this.form.tipo_missao = _.find(this.tiposDeMissoes, (o) => {
					return o.descricao == data.descricao_tipo_missao
				})
			} else {
				this.form.tipo_missao = _.find(this.tiposDeMissoes, (o) => {
					return o.id == data.id_tipo_missao
				})
			}

			if (!_.isNil(data.id_tipo_natureza)) {
				this.form.tipo_natureza = _.find(this.tiposDeNaturezas, (o) => {
					return o.id == data.id_tipo_natureza
				})
			}

			this.form.descricao = data.descricao_missao

			this.form.classificacao =
				data.id_classificacao != null
					? this.getClassificacaoById(data.id_classificacao)
					: ''

			this.form.subclassificacao =
				data.id_subclassificacao != null
					? this.getSubclassificacaoById(data.id_subclassificacao)
					: ''

			this.form.houve_contexto = this.validaNull(data.houve_contexto)

			if (this.form.houve_contexto != null) {
				for (var i in this.contextos) {
					if (this.contextos[i].id == data.id_contexto_operativo) {
						this.form.contexto_operativo = this.contextos[i]
					}
				}
			}

			// orgaos recebidos
			this.form.orgao = []
			_.forEach(data.orgao, (org) => {
				var orgao_apoiado = {}
				var orgao = _.find(this.orgaos, (o) => {
					return o.id == org.id
				})
				orgao_apoiado.erroOrgao = ''
				orgao_apoiado.erroTempoVoo = ''
				orgao_apoiado.orgao = orgao
				orgao_apoiado.tempo_voo = Number(org.tempo_voo).toFixed(2)
				var unidades = []

				_.forEach(org.unidade, (unidade) => {
					var uni = _.find(orgao_apoiado.orgao.unidade, (o) => {
						return o.id == unidade.id_orgao_apoiado_unidade
					})

					if (!_.isNil(uni)) {
						uni.erroUnidade = ''
						unidades.push({unidade: uni, erroUnidade: ''})
					}
				})

				orgao_apoiado.unidade = unidades
				this.form.orgao.push(orgao_apoiado)
			})

			this.form.observacao = data.observacao

			// se for um array
			if (_.isArray(data.unidade_conservacao)) {
				// se existir unidade de conservação
				if (data.unidade_conservacao.length > 0) {
					this.form.unidade_conservacao = data.unidade_conservacao.map(
						(item) => {
							return {
								obj: _.find(this.unidadesConservacao, (o) => {
									return item.id_unidade_conservacao == o.id
								}),
								erro: ''
							}
						}
					)
				}
			} else {
				if (data.unidade_conservacao != '') {
					this.form.unidade_conservacao.push({
						obj: _.find(this.basesOperacao, (o) => {
							o.sigla == data.unidade_conservacao
						})
					})
				}
			}
		},

		clickAdicionaPassageiro(tipo) {
			console.log(tipo)
			this.form.passageiro.push({
				tipo: tipo,
				data_nascimento: '',
				idade_aparente: '',
				idadeErro: '',
				sexo: '',
				sexoErro: '',
				nome: '',
				nomeErro: '',
				orgao: '',
				orgaoErro: '',
				cargo: '',
				cargoErro: '',
				outro: '',
				cpf: '',
				cpfErro: '',
				telefone: '',
				telefoneErro: '',
				vitimaIdentificada: 0
			})
			if (this.tripulacaoTecnica !== '1') {
				this.form.pax = Number(this.form.pax) + 1
			}
		},

		clickPrintPassageiro(item, tipo, id_diario = null) {
			let url = `mg-siga/Ordem_missao/${tipo}/${item.id_ordem}/${
				item.id_despacho
			}/${id_diario}/${$sessao.getToken()}`
			url = this.getURL_WS(url)
			let a = document.createElement('a')
			a.href = url
			a.target = '_blank'
			document.body.appendChild(a)
			a.click()

			window.bus.$emit('load-in', {
				text: this._traducao('global', 'carregando')
			})

			this._axios(url, 'get', {
				callback: (response) => {
					window.bus.$emit('load-out')

					if (response._request) {
						if (!_.isNil(response.lista)) {
							this.lista = response.lista
							this.buscou = true
						} else {
							bus.$emit('exibir-notificacao', {
								text: 'Nenhum resultado foi encontrado.',
								type: 'danger'
							})
						}
					}
				}
			})
		},

		checaMeioAmbiente() {
			if (
				this.form.descricao.descricao == 'COMBATE A INCÊNDIO FLORESTAL' ||
				this.form.descricao.descricao == 'MONITORAMENTO AMBIENTAL'
			) {
				this.form.existe_unidade_conservacao = '1'
			}
		},

		uploadFilesAnexos(files) {
			this.form.anexos = this.form.anexos.filter((existingFile) => {
				return files.some(
					(newFile) => newFile.nomeTemp === existingFile.nomeTemp
				)
			})

			files.forEach((item) => {
				if (!item.id) {
					const duplicado = this.form.anexos.some(
						(doc) =>
							doc.nomeTemp === item.nomeTemp ||
							doc.nomeTemp === item.hash_arquivo
					)
					if (!duplicado) {
						this.form.anexos.push({
							id_relatorio_voo_trecho: this.form.id,
							ext: item.ext,
							icone: item.icone,
							nome: item.nome,
							nomeTemp: item.nomeTemp ? item.nomeTemp : item.hash_arquivo,
							tamanho: item.tamanho
						})
					}
				}
			})
		},
		loadImageAnexos(imgString) {
			const idRelatorio = this.trecho.id
			this._axios('mg-siga/Relatorio_voo_trecho/get_photo_db', 'post', {
				data: {imgString, idRelatorio},
				callback: (response) => {
					if (response._request) {
						this.showCameraAnexos = false
						const anexo = response.lista
						this.loadedFilesDiario.push({
							id_relatorio_voo_trecho: idRelatorio,
							id: anexo.id,
							ext: anexo.ext,
							nome: anexo.nome,
							nomeTemp: anexo.nome_temporario,
							link: anexo.link
						})
						this.form.anexos = this.loadedFilesDiario
						this.$nextTick(() => {
							if (this.$refs.anexosDiario) {
								this.$refs.anexosDiario.carregaLista(this.loadedFilesDiario)
							}
						})
					}
				}
			})
		},
		carregaAnexos(id_abastecimento, index) {
			this._axios(
				`mg-siga/Relatorio_voo_trecho/get_anexos_abastecimento/${id_abastecimento}`,
				'get',
				{
					callback: (response) => {
						if (response._status && response._request) {
							this.loadedFiles = []
							response.lista.forEach((item) => {
								this.loadedFiles.push({
									id: item.id,
									hash_arquivo: item.nome,
									nomeTemp: item.nome_temporario,
									icone: item.icone,
									link: item.link,
									nome: item.nome,
									tamanho: item.tamanho,
									ext: item.ext
								})
							})
							this.form.abastecimentoCombustivel[index].anexos =
								this.loadedFiles
							this.$nextTick(() => {
								if (this.$refs.abastecimentoBasicoRef) {
									this.$refs.abastecimentoBasicoRef.carregaListaAnexo(
										this.loadedFiles,
										index
									)
								}
								if (this.$refs.abastecimentoIntermediarioRef) {
									this.$refs.abastecimentoIntermediarioRef.carregaListaAnexo(
										this.loadedFiles,
										index
									)
								}
								if (this.$refs.abastecimentoMovimentacaoCombustivelRef) {
									this.$refs.abastecimentoMovimentacaoCombustivelRef.carregaListaAnexo(
										this.loadedFiles,
										index
									)
								}
							})
						}
					}
				}
			)
		},

		carregaAnexosDiario() {
			this._axios(
				`mg-siga/Relatorio_voo_trecho/get_anexos/${this.form.id}`,
				'get',
				{
					callback: (response) => {
						if (response._status && response._request) {
							this.loadedFilesDiario = []
							response.lista.forEach((item) => {
								this.loadedFilesDiario.push({
									id: item.id,
									hash_arquivo: item.nome,
									nomeTemp: item.nome_temporario,
									icone: item.icone,
									link: item.link,
									nome: item.nome,
									tamanho: item.tamanho,
									ext: item.ext
								})
							})
							this.form.anexos = this.loadedFilesDiario
							this.$nextTick(() => {
								if (this.$refs.anexosDiario) {
									this.$refs.anexosDiario.carregaLista(this.loadedFilesDiario)
								}
							})
						}
					}
				}
			)
		},

		searchRotaer(arr, str) {
			const flattenValues = (o, values = []) =>
				!Object.values(o).forEach((x) =>
					Array.isArray(x) || (typeof x === 'object' && x !== null)
						? [...flattenValues(x, values)]
						: values.push(x)
				) && values
			const sanitizeStr = (s) =>
				s
					.toString()
					.toLowerCase()
					.replace(/[^a-z0-9]/g, '')
			const textSearch = (v, d) =>
				d.filter(
					(x) =>
						flattenValues(x).filter(
							(y) => y && sanitizeStr(y).indexOf(sanitizeStr(v)) >= 0
						).length
				)

			return textSearch(str, arr)
		},
		clickExcluirAbastecimento(item, index) {
			if (item.id == 0) {
				this.form.abastecimentoCombustivel.splice(index, 1)
			} else {
				const texto = `
				<h3> 
					<span class='text-danger'>${_traducao('global', 'desejaExcluirAbastecimento')}
					</span> <br/> <br/> ${_traducao('global', 'excluirAbastecimento')} 
				</h3> `;
				this._modalExcluir(
					(retorno) => {
						if (retorno.excluir) {
							this.excluirAbastecimento(retorno.obj, index)
						}
					},
					item,
					texto,
					this._traducao('global', 'excluir').toUpperCase()
				)
			}
		},

		excluirAbastecimento(item, index) {
			bus.$emit('load-in', {text: this._traducao('global', 'excluindo')})
			this._axios(
				`mg-siga/Relatorio_voo_trecho/excluir_abastecimento/${item.id}`,
				'get',
				{
					callback: (retorno) => {
						if (retorno.status == 'sucesso') {
							bus.$emit('exibir-notificacao', {
								type: 'success',
								text: 'Abastecimento excluído com sucesso'
							})
							this.form.abastecimentoCombustivel.splice(index, 1)
							this.adicionarAbastecimento()
							return
						}
					},
					finally: () => {
						bus.$emit('load-out')
					}
				}
			)
		},
		adicionarAbastecimento() {
			this.form.existe_abastecimento = '1'

			if (this.form.abastecimentoCombustivel.length <= 0) {
				this.clickAddAbastecimento()
			}
		},
		clickAddAbastecimento() {
			this.form.abastecimentoCombustivel.push({
				id: 0,
				designativo_abastecimento: 'origem',
				anexos: [],
				relacao_abastecimento: this.aeronave.relacao_abastecimento
					? this.aeronave.relacao_abastecimento
					: '',
				id_unidade_armazenamento: null,
				numero_ce: null,
				volume: null,
				data_abastecimento: null,
				id_fornecedor: null,
				id_tipo_lancamento: null,
				id_abastecimento_comprovante: null,
				id_orgao: null,
				id_combustivel: null,
				valor_unitario: 0,
				valor_total: 0,
				nota_fiscal: null,
				erro: {
					numero_ce: null,
					volume: null,
					origem_abastecimento: null,
					designativo_abastecimento: null,
					relacao_abastecimento: null,
					id_tipo_lancamento: null
				}
			})
			this.criarRegistroDeAbastecimento()
		},
		async naoHouveAbastecimento() {
			this.form.existe_abastecimento = '0'
			const qtd_abastecimento = this.form.abastecimentoCombustivel.length
			for (let i = 0; i < qtd_abastecimento; i++) {
				await this._axios(
					`mg-siga/Relatorio_voo_trecho/excluir_abastecimento/${this.form.abastecimentoCombustivel[i].id}`,
					'get',
					{
						callback: () => {}
					}
				)
			}
			this.form.abastecimentoCombustivel = []
		},

		async preenchimentoAutomaticoHouveAbastecimento() {
			let parametroPreenchimento = await this._getParametro(175)
			this.preenchimentoHouveAbastecimento = parametroPreenchimento.trim()
			if (this.preenchimentoHouveAbastecimento == 'Sim') {
				this.form.existe_abastecimento = 1
			} else if (this.preenchimentoHouveAbastecimento == 'Não') {
				this.form.existe_abastecimento = 0
			} else if (this.preenchimentoHouveAbastecimento == 'Em branco') {
				this.form.existe_abastecimento = null
			} else {
				this.form.existe_abastecimento = 0
			}
		},

		exibeFuncao(){
			if(this.funcoesQueAssinam.some((f) => f.active)){
				let funcaoAssinar = this.funcoesQueAssinam.find((func) => func.active)
				return funcaoAssinar.descricao.toUpperCase()
			} else {
				return "PILOTO EM COMANDO"
			}
		}
	}
	
}
</script>

<style scoped>
.table-hover-tr:hover td {
	background: #f0f0f0;
}

.bk-success td {
	background: #dff0d8 !important;
}

.trecho-borda-click-passageiro:hover {
	background: #f9f9f9;
}

.btn-remover-orgao {
	color: red !important;
}

.add:hover {
	background: #fff;
}

.add-modal:hover {
	background: #ddd;
}
.inveter-tripulacao {
	position: absolute;
	padding: 2px 4px;
	cursor: pointer;
	display: inline-block;
	right: -14px;
	top: 45%;
	z-index: 99999;
	border-radius: 2px;
	color: #2196f3;
}
.inveter-tripulacao:hover {
	color: #2174f3;
}

.loader {
	text-align: center;
	color: #bbbbbb;
}

.color {
	color: #2196f3;
}

.border-color {
	border-color: #2196f3;
}

.ellipsis-label {
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
}

@media (max-width: 1000px) {
	.dropdown-content {
		position: absolute;
		left: -140px;
	}
}
</style>